var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutoEvaluationLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-44"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-44",
    cx: 250,
    cy: 350.79,
    rx: 242.03,
    ry: 139.73,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-44",
    d: "M128.07,414.33l119.76,69.18a11.06,11.06,0,0,0,10,0l183-105.64c2.77-1.6,2.77-4.19,0-5.79L321.07,302.9a11.12,11.12,0,0,0-10,0l-183,105.65C125.31,410.14,125.31,412.73,128.07,414.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-44",
    d: "M156.56,348.56l-61.17,35.3a5.91,5.91,0,0,1-5.31,0L29,348.57c-1.47-.85-1.47-2.22,0-3.07l61.17-35.29a5.85,5.85,0,0,1,5.31,0l61.09,35.29C158,346.34,158,347.72,156.56,348.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-44",
    d: "M259.51,289.17l-62,35.75a5.93,5.93,0,0,1-5.38,0l-61.88-35.74c-1.48-.86-1.48-2.25,0-3.11l62-35.75a5.93,5.93,0,0,1,5.38,0l61.88,35.75C261,286.93,261,288.32,259.51,289.17Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.7,313l-6.43-3.72s-3.82-15.88-2.3-30.18c2.15-20.09,15.38-27.66,20.41-25.92s6.48,7.58-1.84,19.55C333.63,279.8,327.6,294.51,328.7,313Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.7,313l-6.43-3.72s-3.82-15.88-2.3-30.18c2.15-20.09,15.38-27.66,20.41-25.92s6.48,7.58-1.84,19.55C333.63,279.8,327.6,294.51,328.7,313Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326,305.2h.06a.44.44,0,0,0,.35-.52c-3.52-18.53,3-39.36,11-48a.45.45,0,0,0,0-.63.44.44,0,0,0-.63,0c-8.16,8.82-14.77,30-11.19,48.8A.44.44,0,0,0,326,305.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.81,323.09c1,.49,3.52-1.7,4.23-2.23a8.9,8.9,0,0,0,2.79-3.55,8.28,8.28,0,0,0,.48-5,20.37,20.37,0,0,0-.76-2.64c-.29-.85-.59-1.69-.88-2.54a6.68,6.68,0,0,1-.51-2.59c.14-1.78,1.65-3.1,3-4.24s3.08-2.9,3-5a7.55,7.55,0,0,0-2.1-4.37c-1.09-1.23-2.35-2.31-3.34-3.63a5.22,5.22,0,0,1-1.24-3.25,5.42,5.42,0,0,1,.62-2.1,29.73,29.73,0,0,0,2.05-4.26,4.17,4.17,0,0,0-.94-4.37,4.87,4.87,0,0,0-3.71-.73,8.53,8.53,0,0,0-3.35,1.37c-3.28,2.05-5,6.15-8.52,7.78a35.26,35.26,0,0,1-4.29,1.28,5.33,5.33,0,0,0-3.45,2.63c-1.19,2.7,1.42,5.81.63,8.65-.69,2.51-3,3.58-4.28,5.87a5.33,5.33,0,0,0-.47,3.27,15.49,15.49,0,0,0,1.64,5.39,48.06,48.06,0,0,0,3.25,5Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.81,323.09c1,.49,3.52-1.7,4.23-2.23a8.9,8.9,0,0,0,2.79-3.55,8.28,8.28,0,0,0,.48-5,20.37,20.37,0,0,0-.76-2.64c-.29-.85-.59-1.69-.88-2.54a6.68,6.68,0,0,1-.51-2.59c.14-1.78,1.65-3.1,3-4.24s3.08-2.9,3-5a7.55,7.55,0,0,0-2.1-4.37c-1.09-1.23-2.35-2.31-3.34-3.63a5.22,5.22,0,0,1-1.24-3.25,5.42,5.42,0,0,1,.62-2.1,29.73,29.73,0,0,0,2.05-4.26,4.17,4.17,0,0,0-.94-4.37,4.87,4.87,0,0,0-3.71-.73,8.53,8.53,0,0,0-3.35,1.37c-3.28,2.05-5,6.15-8.52,7.78a35.26,35.26,0,0,1-4.29,1.28,5.33,5.33,0,0,0-3.45,2.63c-1.19,2.7,1.42,5.81.63,8.65-.69,2.51-3,3.58-4.28,5.87a5.33,5.33,0,0,0-.47,3.27,15.49,15.49,0,0,0,1.64,5.39,48.06,48.06,0,0,0,3.25,5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M336.52,318.24h0a.43.43,0,0,0,.39-.46c-1.54-16.67,5.4-35.51,10.85-41.16a.42.42,0,1,0-.6-.59c-5.57,5.76-12.65,24.92-11.09,41.83A.42.42,0,0,0,336.52,318.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.17,297.68l.13,0a57,57,0,0,1,12-2.57.42.42,0,0,0,.38-.46.41.41,0,0,0-.46-.38A58,58,0,0,0,338,296.87a.42.42,0,0,0-.25.54A.4.4,0,0,0,338.17,297.68Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--server-2--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Server--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.63,101.68l49.77,28.73a3.68,3.68,0,0,1,1.67,2.88V284.46a3.68,3.68,0,0,1-1.67,2.88l-53.83,31.08a3.69,3.69,0,0,1-3.33,0l-49.77-28.73a3.7,3.7,0,0,1-1.67-2.89V135.64a3.68,3.68,0,0,1,1.67-2.88l53.83-31.08A3.63,3.63,0,0,1,200.63,101.68Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.81,135.64V286.8a3.69,3.69,0,0,0,1.66,2.89l49.77,28.73a3.34,3.34,0,0,0,1.66.4v-155a3.45,3.45,0,0,1-1.66-.4l-49.77-28.73-.46-.38-.59-.49A3.42,3.42,0,0,0,141.81,135.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.47,132.76l53.83-31.08a3.63,3.63,0,0,1,3.33,0l49.77,28.73a1,1,0,0,1,0,1.92l-53.83,31.08a3.63,3.63,0,0,1-3.33,0l-49.77-28.73A1,1,0,0,1,143.47,132.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,101.28a3.34,3.34,0,0,1,1.66.4l49.77,28.73a1,1,0,0,1,0,1.92l-53.83,31.08a3.67,3.67,0,0,1-3.33,0l-49.77-28.73a1,1,0,0,1,0-1.92l53.83-31.08a3.36,3.36,0,0,1,1.67-.4m0-.93a4.28,4.28,0,0,0-2.13.52L143,132a1.94,1.94,0,0,0,0,3.54l49.77,28.73a4.62,4.62,0,0,0,4.26,0l53.84-31.08a1.94,1.94,0,0,0,0-3.54L201.1,100.87a4.31,4.31,0,0,0-2.13-.52Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.1,166.44c-1.73-1-3.13-.09-3.13,2V244.8a7.17,7.17,0,0,0,3.12,5.65c1.73,1,3.13.09,3.13-2V172.09A7.17,7.17,0,0,0,187.1,166.44Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.09,248.63a3.58,3.58,0,0,1-1.56-2.83V169.25c0-1.07.7-1.52,1.57-1a3.56,3.56,0,0,1,1.56,2.82v76.56C188.66,248.67,188,249.13,187.09,248.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.09,248.63a3.58,3.58,0,0,1-1.56-2.83V169.25c0-1.07.7-1.52,1.57-1a3.56,3.56,0,0,1,1.56,2.82v76.56C188.66,248.67,188,249.13,187.09,248.63Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.09,248.63a3.58,3.58,0,0,1-1.56-2.83V208.4l3.13,1.8v37.41C188.66,248.67,188,249.13,187.09,248.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.72,161c-1.72-1-3.12-.09-3.12,2v76.33a7.17,7.17,0,0,0,3.12,5.65c1.73,1,3.13.09,3.13-2V166.68A7.15,7.15,0,0,0,177.72,161Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.72,243.22a3.58,3.58,0,0,1-1.56-2.83V163.84c0-1.07.7-1.52,1.56-1a3.54,3.54,0,0,1,1.57,2.82V242.2C179.29,243.26,178.59,243.72,177.72,243.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.35,155.62c-1.72-1-3.12-.09-3.12,2V234a7.17,7.17,0,0,0,3.12,5.65c1.73,1,3.13.09,3.13-2V161.27A7.15,7.15,0,0,0,168.35,155.62Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.35,237.81a3.58,3.58,0,0,1-1.56-2.83V158.43c0-1.07.7-1.52,1.56-1a3.54,3.54,0,0,1,1.57,2.82v76.56C169.91,237.85,169.22,238.31,168.35,237.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.35,237.81a3.58,3.58,0,0,1-1.56-2.83V158.43c0-1.07.7-1.52,1.56-1a3.54,3.54,0,0,1,1.57,2.82v76.56C169.91,237.85,169.22,238.31,168.35,237.81Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.35,237.81a3.58,3.58,0,0,1-1.56-2.83V179.39l3.13,1.81v55.59C169.91,237.85,169.22,238.31,168.35,237.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,150.21c-1.72-1-3.12-.09-3.12,2v76.33a7.17,7.17,0,0,0,3.12,5.65c1.73,1,3.13.09,3.13-2V155.86A7.15,7.15,0,0,0,159,150.21Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,232.4a3.58,3.58,0,0,1-1.56-2.83V153c0-1.07.7-1.52,1.56-1a3.53,3.53,0,0,1,1.56,2.82v76.56C160.54,232.44,159.84,232.9,159,232.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,232.4a3.58,3.58,0,0,1-1.56-2.83V153c0-1.07.7-1.52,1.56-1a3.53,3.53,0,0,1,1.56,2.82v76.56C160.54,232.44,159.84,232.9,159,232.4Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,232.4a3.58,3.58,0,0,1-1.56-2.83v-14l3.12,1.81v14C160.54,232.44,159.84,232.9,159,232.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.61,144.8c-1.72-1-3.12-.09-3.12,2v76.33a7.17,7.17,0,0,0,3.12,5.65c1.73,1,3.13.09,3.13-2V150.45A7.15,7.15,0,0,0,149.61,144.8Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.61,227a3.58,3.58,0,0,1-1.56-2.83V147.61c0-1.07.7-1.52,1.56-1a3.56,3.56,0,0,1,1.56,2.82V226C151.17,227,150.47,227.49,149.61,227Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.61,227a3.58,3.58,0,0,1-1.56-2.83V147.61c0-1.07.7-1.52,1.56-1a3.56,3.56,0,0,1,1.56,2.82V226C151.17,227,150.47,227.49,149.61,227Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.61,227a3.58,3.58,0,0,1-1.56-2.83v-41l3.12,1.8v41C151.17,227,150.47,227.49,149.61,227Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--server--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.35,289.86a1.6,1.6,0,0,1,.74,1.27c0,.47-.33.66-.74.43a1.66,1.66,0,0,1-.73-1.28C152.62,289.81,153,289.62,153.35,289.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.49,293.41a1.6,1.6,0,0,1,.74,1.27c0,.47-.33.66-.74.42a1.62,1.62,0,0,1-.73-1.27C158.76,293.36,159.09,293.17,159.49,293.41Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.53,296.89a1.62,1.62,0,0,1,.73,1.27c0,.47-.33.65-.73.42a1.59,1.59,0,0,1-.73-1.27C164.8,296.85,165.12,296.66,165.53,296.89Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M171.61,300.41a1.59,1.59,0,0,1,.73,1.26c0,.47-.32.65-.73.42a1.61,1.61,0,0,1-.72-1.26C170.89,300.36,171.21,300.18,171.61,300.41Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M214.37,192a1.42,1.42,0,0,1-.76-.2,1.82,1.82,0,0,1-.82-1.69v-3.93a4.78,4.78,0,0,1,2.19-3.8l28.91-16.69a1.84,1.84,0,0,1,1.88-.13,1.82,1.82,0,0,1,.82,1.69v3.93a4.78,4.78,0,0,1-2.19,3.8l-28.91,16.69A2.3,2.3,0,0,1,214.37,192Zm30-25.44L215.49,183.2a3.79,3.79,0,0,0-1.69,2.93v3.93c0,.41.11.71.31.82a.91.91,0,0,0,.87-.13l28.91-16.69a3.79,3.79,0,0,0,1.69-2.93V167.2c0-.41-.11-.71-.31-.82a.91.91,0,0,0-.87.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,169.41v1.9a.86.86,0,0,1-.39.67l-.44.26c-.21.12-.39,0-.39-.23v-1.9a.89.89,0,0,1,.39-.68l.44-.25C243.86,169.06,244,169.16,244,169.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.07,170.54v1.9a.88.88,0,0,1-.38.68l-.44.25c-.22.12-.39,0-.39-.23v-1.9a.83.83,0,0,1,.39-.67l.44-.26C241.9,170.19,242.07,170.29,242.07,170.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.11,171.67v1.9a.86.86,0,0,1-.39.68l-.43.25c-.22.12-.39,0-.39-.22v-1.91a.83.83,0,0,1,.39-.67l.43-.26C239.94,171.32,240.11,171.42,240.11,171.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.15,172.8v1.91a.87.87,0,0,1-.39.67l-.44.25c-.21.13-.39,0-.39-.22V173.5a.86.86,0,0,1,.39-.67l.44-.25C238,172.45,238.15,172.55,238.15,172.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.19,173.93v1.91a.86.86,0,0,1-.39.67l-.44.25c-.21.13-.39,0-.39-.22v-1.91a.87.87,0,0,1,.39-.67l.44-.25C236,173.58,236.19,173.68,236.19,173.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.22,175.06V177a.83.83,0,0,1-.39.67l-.43.25c-.22.13-.39,0-.39-.22v-1.91a.86.86,0,0,1,.39-.67l.43-.25C234.05,174.72,234.22,174.82,234.22,175.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.26,176.19v1.91a.83.83,0,0,1-.39.67l-.44.26c-.21.12-.38,0-.38-.23v-1.9a.88.88,0,0,1,.38-.68l.44-.25C232.09,175.85,232.26,176,232.26,176.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.3,177.33v1.9a.89.89,0,0,1-.39.68l-.44.25c-.21.12-.39,0-.39-.23V178a.89.89,0,0,1,.39-.68l.44-.25C230.12,177,230.3,177.08,230.3,177.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.33,178.46v1.9a.86.86,0,0,1-.39.68l-.43.25c-.22.12-.39,0-.39-.22v-1.91a.83.83,0,0,1,.39-.67l.43-.26C228.16,178.11,228.33,178.21,228.33,178.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.37,179.59v1.91a.85.85,0,0,1-.39.67l-.44.25c-.21.13-.38,0-.38-.22v-1.91a.85.85,0,0,1,.38-.67l.44-.25C226.2,179.24,226.37,179.34,226.37,179.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.41,180.72v1.91a.86.86,0,0,1-.39.67l-.44.25c-.21.13-.39,0-.39-.22v-1.91a.86.86,0,0,1,.39-.67l.44-.25C224.23,180.37,224.41,180.47,224.41,180.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.44,181.85v1.91a.85.85,0,0,1-.38.67l-.44.25c-.22.13-.39,0-.39-.22v-1.91a.86.86,0,0,1,.39-.67l.44-.25C222.27,181.51,222.44,181.61,222.44,181.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.48,183v1.91a.83.83,0,0,1-.39.67l-.43.26c-.22.12-.39,0-.39-.23v-1.9a.86.86,0,0,1,.39-.68l.43-.25C220.31,182.64,220.48,182.74,220.48,183Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.52,184.12V186a.89.89,0,0,1-.39.68l-.44.25c-.21.12-.39,0-.39-.23v-1.9a.89.89,0,0,1,.39-.68l.44-.25C218.34,183.77,218.52,183.87,218.52,184.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.56,185.25v1.9a.89.89,0,0,1-.39.68l-.44.25c-.21.12-.39,0-.39-.22V186a.86.86,0,0,1,.39-.67l.44-.26C216.38,184.9,216.56,185,216.56,185.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.37,189.07l-.81-.47h0a1.06,1.06,0,0,0-1.08.11,3.38,3.38,0,0,0-1.53,2.66,1.08,1.08,0,0,0,.44,1h0l.75.43.14-.23a1.52,1.52,0,0,0,.44-.17,3.42,3.42,0,0,0,1.54-2.66,1.62,1.62,0,0,0,0-.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.25,189.16a3.38,3.38,0,0,0-1.53,2.66c0,1,.68,1.38,1.53.89a3.41,3.41,0,0,0,1.54-2.67C210.79,189.06,210.1,188.66,209.25,189.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.25,189.16a3.38,3.38,0,0,0-1.53,2.66c0,1,.68,1.38,1.53.89a3.41,3.41,0,0,0,1.54-2.67C210.79,189.06,210.1,188.66,209.25,189.16Z",
    style: {
      fill: "#fafafa",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.7,192.92l-.81-.47h0a1.08,1.08,0,0,0-1.08.11,3.39,3.39,0,0,0-1.54,2.66,1.08,1.08,0,0,0,.45,1h0l.76.43.13-.23a1.42,1.42,0,0,0,.44-.17,3.39,3.39,0,0,0,1.54-2.66,1.62,1.62,0,0,0-.05-.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.58,193a3.39,3.39,0,0,0-1.54,2.66c0,1,.69,1.38,1.54.89a3.4,3.4,0,0,0,1.54-2.67C204.12,192.91,203.43,192.52,202.58,193Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.58,193a3.39,3.39,0,0,0-1.54,2.66c0,1,.69,1.38,1.54.89a3.4,3.4,0,0,0,1.54-2.67C204.12,192.91,203.43,192.52,202.58,193Z",
    style: {
      fill: "#fafafa",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.33,222.48a1.29,1.29,0,0,1-.67-.17,1.65,1.65,0,0,1-.73-1.5V206.62a4.15,4.15,0,0,1,1.92-3.31l41.34-23.87a1.5,1.5,0,0,1,2.4,1.39V195a4.18,4.18,0,0,1-1.91,3.31l-41.34,23.86A2,2,0,0,1,202.33,222.48Zm42.34-42.19-41.34,23.87a3.18,3.18,0,0,0-1.42,2.46v14.19a.75.75,0,0,0,.24.65.72.72,0,0,0,.69-.12l41.34-23.86a3.2,3.2,0,0,0,1.41-2.46V180.83a.73.73,0,0,0-.25-.66.76.76,0,0,0-.68.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,186.12a3.56,3.56,0,0,1-1.66,2.76l-35.1,20.26c-.91.53-1.66.16-1.66-.84a3.59,3.59,0,0,1,1.66-2.76l35.1-20.26C242.22,184.75,243,185.12,243,186.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,193.33a3.56,3.56,0,0,1-1.66,2.77l-35.1,20.26c-.91.53-1.66.15-1.66-.84a3.59,3.59,0,0,1,1.66-2.77l35.1-20.26C242.22,192,243,192.34,243,193.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.3,192.49l-14.9,8.6v3.6l14.9-8.59a3.56,3.56,0,0,0,1.66-2.77C243,192.34,242.22,192,241.3,192.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.37,228.43a1.51,1.51,0,0,1-.76-.19,1.85,1.85,0,0,1-.82-1.7v-3.93a4.78,4.78,0,0,1,2.19-3.8l28.91-16.69a1.84,1.84,0,0,1,1.88-.13,1.82,1.82,0,0,1,.82,1.69v3.93a4.78,4.78,0,0,1-2.19,3.8L215.49,228.1A2.3,2.3,0,0,1,214.37,228.43Zm30-25.44-28.91,16.69a3.79,3.79,0,0,0-1.69,2.93v3.93c0,.41.11.71.31.82a.91.91,0,0,0,.87-.13l28.91-16.69a3.79,3.79,0,0,0,1.69-2.93v-3.93c0-.41-.11-.71-.31-.82a.91.91,0,0,0-.87.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,205.89v1.9a.86.86,0,0,1-.39.67l-.44.26c-.21.12-.39,0-.39-.23v-1.9a.89.89,0,0,1,.39-.68l.44-.25C243.86,205.54,244,205.64,244,205.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.07,207v1.9a.88.88,0,0,1-.38.68l-.44.25c-.22.12-.39,0-.39-.23v-1.9a.83.83,0,0,1,.39-.67l.44-.26C241.9,206.67,242.07,206.77,242.07,207Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.11,208.15v1.91a.86.86,0,0,1-.39.67l-.43.25c-.22.12-.39,0-.39-.22v-1.91a.83.83,0,0,1,.39-.67l.43-.26C239.94,207.8,240.11,207.9,240.11,208.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.15,209.28v1.91a.87.87,0,0,1-.39.67l-.44.25c-.21.13-.39,0-.39-.22V210a.86.86,0,0,1,.39-.67l.44-.25C238,208.93,238.15,209,238.15,209.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.19,210.41v1.91a.86.86,0,0,1-.39.67l-.44.25c-.21.13-.39,0-.39-.22v-1.91a.87.87,0,0,1,.39-.67l.44-.25C236,210.06,236.19,210.16,236.19,210.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.22,211.54v1.91a.83.83,0,0,1-.39.67l-.43.26c-.22.12-.39,0-.39-.23v-1.91a.86.86,0,0,1,.39-.67l.43-.25C234.05,211.2,234.22,211.3,234.22,211.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.26,212.68v1.9a.83.83,0,0,1-.39.67l-.44.26c-.21.12-.38,0-.38-.23v-1.9a.88.88,0,0,1,.38-.68l.44-.25C232.09,212.33,232.26,212.43,232.26,212.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.3,213.81v1.9a.89.89,0,0,1-.39.68l-.44.25c-.21.12-.39,0-.39-.23v-1.9a.86.86,0,0,1,.39-.67l.44-.26C230.12,213.46,230.3,213.56,230.3,213.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.33,214.94v1.91a.86.86,0,0,1-.39.67l-.43.25c-.22.12-.39,0-.39-.22v-1.91a.83.83,0,0,1,.39-.67l.43-.26C228.16,214.59,228.33,214.69,228.33,214.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.37,216.07V218a.85.85,0,0,1-.39.67l-.44.25c-.21.13-.38,0-.38-.22v-1.91a.85.85,0,0,1,.38-.67l.44-.25C226.2,215.72,226.37,215.82,226.37,216.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.41,217.2v1.91a.86.86,0,0,1-.39.67l-.44.25c-.21.13-.39,0-.39-.22V217.9a.86.86,0,0,1,.39-.67L224,217C224.23,216.85,224.41,217,224.41,217.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.44,218.33v1.91a.85.85,0,0,1-.38.67l-.44.25c-.22.13-.39,0-.39-.22V219a.86.86,0,0,1,.39-.67l.44-.25C222.27,218,222.44,218.09,222.44,218.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.48,219.47v1.9a.83.83,0,0,1-.39.67l-.43.26c-.22.12-.39,0-.39-.23v-1.9a.86.86,0,0,1,.39-.68l.43-.25C220.31,219.12,220.48,219.22,220.48,219.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.52,220.6v1.9a.89.89,0,0,1-.39.68l-.44.25c-.21.12-.39,0-.39-.23v-1.9a.89.89,0,0,1,.39-.68l.44-.25C218.34,220.25,218.52,220.35,218.52,220.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.56,221.73v1.9a.89.89,0,0,1-.39.68l-.44.25c-.21.12-.39,0-.39-.22v-1.91a.86.86,0,0,1,.39-.67l.44-.26C216.38,221.38,216.56,221.48,216.56,221.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.37,225.55l-.81-.47h0a1.06,1.06,0,0,0-1.08.11,3.38,3.38,0,0,0-1.53,2.66,1.08,1.08,0,0,0,.44,1h0l.75.43.14-.23a1.52,1.52,0,0,0,.44-.17,3.42,3.42,0,0,0,1.54-2.66,1.62,1.62,0,0,0,0-.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.25,225.64a3.38,3.38,0,0,0-1.53,2.66c0,1,.68,1.38,1.53.89a3.41,3.41,0,0,0,1.54-2.67C210.79,225.54,210.1,225.15,209.25,225.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.25,225.64a3.38,3.38,0,0,0-1.53,2.66c0,1,.68,1.38,1.53.89a3.41,3.41,0,0,0,1.54-2.67C210.79,225.54,210.1,225.15,209.25,225.64Z",
    style: {
      fill: "#fafafa",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.7,229.4l-.81-.47h0a1.08,1.08,0,0,0-1.08.11,3.39,3.39,0,0,0-1.54,2.66,1.08,1.08,0,0,0,.45,1h0l.76.43.13-.23a1.42,1.42,0,0,0,.44-.17,3.39,3.39,0,0,0,1.54-2.66,1.48,1.48,0,0,0-.05-.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.58,229.49a3.39,3.39,0,0,0-1.54,2.66c0,1,.69,1.38,1.54.89a3.39,3.39,0,0,0,1.54-2.66C204.12,229.39,203.43,229,202.58,229.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.58,229.49a3.39,3.39,0,0,0-1.54,2.66c0,1,.69,1.38,1.54.89a3.39,3.39,0,0,0,1.54-2.66C204.12,229.39,203.43,229,202.58,229.49Z",
    style: {
      fill: "#fafafa",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.33,259a1.29,1.29,0,0,1-.67-.18,1.65,1.65,0,0,1-.73-1.5V243.1a4.17,4.17,0,0,1,1.91-3.31l41.35-23.87a1.5,1.5,0,0,1,2.4,1.39V231.5a4.15,4.15,0,0,1-1.91,3.3l-41.34,23.87A2,2,0,0,1,202.33,259Zm42.34-42.2-41.34,23.87a3.18,3.18,0,0,0-1.42,2.46v14.19a.75.75,0,0,0,.24.65.72.72,0,0,0,.69-.12L244.18,234a3.19,3.19,0,0,0,1.41-2.46V217.31a.73.73,0,0,0-.25-.66.76.76,0,0,0-.68.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,222.6a3.56,3.56,0,0,1-1.66,2.76l-35.1,20.26c-.91.54-1.66.16-1.66-.84A3.59,3.59,0,0,1,206.2,242l35.1-20.26C242.22,221.23,243,221.6,243,222.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,229.81a3.56,3.56,0,0,1-1.66,2.77l-35.1,20.26c-.91.53-1.66.15-1.66-.84a3.59,3.59,0,0,1,1.66-2.77L241.3,229C242.22,228.44,243,228.82,243,229.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.3,229l-14.9,8.6v3.61l14.9-8.6a3.56,3.56,0,0,0,1.66-2.77C243,228.82,242.22,228.44,241.3,229Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.37,264.91a1.51,1.51,0,0,1-.76-.19,1.85,1.85,0,0,1-.82-1.7v-3.93a4.78,4.78,0,0,1,2.19-3.8l28.91-16.69a1.84,1.84,0,0,1,1.88-.13,1.82,1.82,0,0,1,.82,1.69v3.93a4.78,4.78,0,0,1-2.19,3.8l-28.91,16.69A2.3,2.3,0,0,1,214.37,264.91Zm30-25.44-28.91,16.69a3.79,3.79,0,0,0-1.69,2.93V263c0,.41.11.71.31.82a.91.91,0,0,0,.87-.13L243.89,247a3.79,3.79,0,0,0,1.69-2.93v-3.93c0-.41-.11-.71-.31-.82a.91.91,0,0,0-.87.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,242.37v1.9a.89.89,0,0,1-.39.68l-.44.25c-.21.12-.39,0-.39-.23v-1.9a.89.89,0,0,1,.39-.68l.44-.25C243.86,242,244,242.12,244,242.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.07,243.5v1.9a.88.88,0,0,1-.38.68l-.44.25c-.22.12-.39,0-.39-.23v-1.9a.83.83,0,0,1,.39-.67l.44-.26C241.9,243.15,242.07,243.25,242.07,243.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.11,244.63v1.91a.86.86,0,0,1-.39.67l-.43.25c-.22.12-.39,0-.39-.22v-1.91a.83.83,0,0,1,.39-.67l.43-.26C239.94,244.28,240.11,244.38,240.11,244.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.15,245.76v1.91a.87.87,0,0,1-.39.67l-.44.25c-.21.13-.39,0-.39-.22v-1.91a.86.86,0,0,1,.39-.67l.44-.25C238,245.41,238.15,245.51,238.15,245.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.19,246.89v1.91a.86.86,0,0,1-.39.67l-.44.25c-.21.13-.39,0-.39-.22v-1.91a.87.87,0,0,1,.39-.67l.44-.25C236,246.54,236.19,246.64,236.19,246.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.22,248v1.91a.83.83,0,0,1-.39.67l-.43.26c-.22.12-.39,0-.39-.23v-1.9a.86.86,0,0,1,.39-.68l.43-.25C234.05,247.68,234.22,247.78,234.22,248Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.26,249.16v1.9a.83.83,0,0,1-.39.67l-.44.26c-.21.12-.38,0-.38-.23v-1.9a.88.88,0,0,1,.38-.68l.44-.25C232.09,248.81,232.26,248.91,232.26,249.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.3,250.29v1.9a.89.89,0,0,1-.39.68l-.44.25c-.21.12-.39,0-.39-.23V251a.86.86,0,0,1,.39-.67l.44-.26C230.12,249.94,230.3,250,230.3,250.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.33,251.42v1.91a.86.86,0,0,1-.39.67l-.43.25c-.22.12-.39,0-.39-.22v-1.91a.83.83,0,0,1,.39-.67l.43-.26C228.16,251.07,228.33,251.17,228.33,251.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.37,252.55v1.91a.85.85,0,0,1-.39.67l-.44.25c-.21.13-.38,0-.38-.22v-1.91a.85.85,0,0,1,.38-.67l.44-.25C226.2,252.2,226.37,252.3,226.37,252.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.41,253.68v1.91a.86.86,0,0,1-.39.67l-.44.25c-.21.13-.39,0-.39-.22v-1.91a.87.87,0,0,1,.39-.67l.44-.25C224.23,253.33,224.41,253.43,224.41,253.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.44,254.81v1.91a.85.85,0,0,1-.38.67l-.44.26c-.22.12-.39,0-.39-.23v-1.91a.86.86,0,0,1,.39-.67l.44-.25C222.27,254.47,222.44,254.57,222.44,254.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.48,256v1.9a.83.83,0,0,1-.39.67l-.43.26c-.22.12-.39,0-.39-.23v-1.9a.86.86,0,0,1,.39-.68l.43-.25C220.31,255.6,220.48,255.7,220.48,256Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.52,257.08V259a.89.89,0,0,1-.39.68l-.44.25c-.21.12-.39,0-.39-.23v-1.9a.86.86,0,0,1,.39-.67l.44-.26C218.34,256.73,218.52,256.83,218.52,257.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.56,258.21v1.9a.89.89,0,0,1-.39.68l-.44.25c-.21.12-.39,0-.39-.22v-1.91a.86.86,0,0,1,.39-.67l.44-.26C216.38,257.86,216.56,258,216.56,258.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.37,262l-.81-.47h0a1.06,1.06,0,0,0-1.08.11,3.38,3.38,0,0,0-1.53,2.66,1.11,1.11,0,0,0,.44,1h0l.75.43.14-.23a1.52,1.52,0,0,0,.44-.17,3.42,3.42,0,0,0,1.54-2.66,1.62,1.62,0,0,0,0-.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.25,262.12a3.38,3.38,0,0,0-1.53,2.66c0,1,.68,1.38,1.53.89a3.41,3.41,0,0,0,1.54-2.67C210.79,262,210.1,261.63,209.25,262.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.25,262.12a3.38,3.38,0,0,0-1.53,2.66c0,1,.68,1.38,1.53.89a3.41,3.41,0,0,0,1.54-2.67C210.79,262,210.1,261.63,209.25,262.12Z",
    style: {
      fill: "#fafafa",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.7,265.88l-.81-.47h0a1.08,1.08,0,0,0-1.08.11,3.39,3.39,0,0,0-1.54,2.66,1.08,1.08,0,0,0,.45,1h0l.76.43.13-.23a1.42,1.42,0,0,0,.44-.17,3.39,3.39,0,0,0,1.54-2.66,1.48,1.48,0,0,0-.05-.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.58,266a3.39,3.39,0,0,0-1.54,2.66c0,1,.69,1.38,1.54.89a3.39,3.39,0,0,0,1.54-2.66C204.12,265.87,203.43,265.48,202.58,266Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.58,266a3.39,3.39,0,0,0-1.54,2.66c0,1,.69,1.38,1.54.89a3.39,3.39,0,0,0,1.54-2.66C204.12,265.87,203.43,265.48,202.58,266Z",
    style: {
      fill: "#fafafa",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.33,295.44a1.29,1.29,0,0,1-.67-.17,1.65,1.65,0,0,1-.73-1.5V279.58a4.15,4.15,0,0,1,1.92-3.31l41.34-23.87a1.5,1.5,0,0,1,2.4,1.39V268a4.18,4.18,0,0,1-1.91,3.31l-41.34,23.86A2,2,0,0,1,202.33,295.44Zm42.34-42.19-41.34,23.87a3.18,3.18,0,0,0-1.42,2.46v14.19a.75.75,0,0,0,.24.65.72.72,0,0,0,.69-.12l41.34-23.86a3.2,3.2,0,0,0,1.41-2.46V253.79a.73.73,0,0,0-.25-.66.76.76,0,0,0-.68.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,259.08a3.56,3.56,0,0,1-1.66,2.76L206.2,282.1c-.91.54-1.66.16-1.66-.84a3.59,3.59,0,0,1,1.66-2.76l35.1-20.26C242.22,257.71,243,258.08,243,259.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,266.29a3.56,3.56,0,0,1-1.66,2.77l-35.1,20.26c-.91.53-1.66.15-1.66-.84a3.59,3.59,0,0,1,1.66-2.77l35.1-20.26C242.22,264.92,243,265.3,243,266.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.3,265.45l-14.9,8.6v3.61l14.9-8.6a3.56,3.56,0,0,0,1.66-2.77C243,265.3,242.22,264.92,241.3,265.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.37,301.39a1.51,1.51,0,0,1-.76-.19,1.85,1.85,0,0,1-.82-1.7v-3.93a4.78,4.78,0,0,1,2.19-3.8l28.91-16.69a1.84,1.84,0,0,1,1.88-.13,1.82,1.82,0,0,1,.82,1.69v3.93a4.78,4.78,0,0,1-2.19,3.8l-28.91,16.69A2.3,2.3,0,0,1,214.37,301.39Zm30-25.44-28.91,16.69a3.81,3.81,0,0,0-1.69,2.93v3.93c0,.41.11.71.31.82a.91.91,0,0,0,.87-.13l28.91-16.69a3.79,3.79,0,0,0,1.69-2.93v-3.93c0-.41-.11-.71-.31-.82a.91.91,0,0,0-.87.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,278.85v1.9a.89.89,0,0,1-.39.68l-.44.25c-.21.12-.39,0-.39-.23v-1.9a.89.89,0,0,1,.39-.68l.44-.25C243.86,278.5,244,278.6,244,278.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.07,280v1.9a.88.88,0,0,1-.38.68l-.44.25c-.22.12-.39,0-.39-.22v-1.91a.83.83,0,0,1,.39-.67l.44-.26C241.9,279.63,242.07,279.73,242.07,280Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.11,281.11V283a.86.86,0,0,1-.39.67l-.43.25c-.22.12-.39,0-.39-.22v-1.91a.83.83,0,0,1,.39-.67l.43-.25C239.94,280.76,240.11,280.86,240.11,281.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.15,282.24v1.91a.86.86,0,0,1-.39.67l-.44.25c-.21.13-.39,0-.39-.22v-1.91a.86.86,0,0,1,.39-.67l.44-.25C238,281.89,238.15,282,238.15,282.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.19,283.37v1.91a.86.86,0,0,1-.39.67l-.44.25c-.21.13-.39,0-.39-.22v-1.91a.87.87,0,0,1,.39-.67l.44-.25C236,283,236.19,283.12,236.19,283.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.22,284.5v1.91a.83.83,0,0,1-.39.67l-.43.26c-.22.12-.39,0-.39-.23v-1.9a.86.86,0,0,1,.39-.68l.43-.25C234.05,284.16,234.22,284.26,234.22,284.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.26,285.64v1.9a.86.86,0,0,1-.39.68l-.44.25c-.21.12-.38,0-.38-.23v-1.9a.88.88,0,0,1,.38-.68l.44-.25C232.09,285.29,232.26,285.39,232.26,285.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.3,286.77v1.9a.89.89,0,0,1-.39.68l-.44.25c-.21.12-.39,0-.39-.23v-1.9a.86.86,0,0,1,.39-.67l.44-.26C230.12,286.42,230.3,286.52,230.3,286.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.33,287.9v1.91a.86.86,0,0,1-.39.67l-.43.25c-.22.12-.39,0-.39-.22V288.6a.83.83,0,0,1,.39-.67l.43-.25C228.16,287.55,228.33,287.65,228.33,287.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.37,289v1.91a.85.85,0,0,1-.39.67l-.44.25c-.21.13-.38,0-.38-.22v-1.91a.85.85,0,0,1,.38-.67l.44-.25C226.2,288.68,226.37,288.78,226.37,289Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.41,290.16v1.91a.86.86,0,0,1-.39.67l-.44.25c-.21.13-.39,0-.39-.22v-1.91a.87.87,0,0,1,.39-.67l.44-.25C224.23,289.81,224.41,289.91,224.41,290.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.44,291.29v1.91a.85.85,0,0,1-.38.67l-.44.26c-.22.12-.39,0-.39-.23V292a.86.86,0,0,1,.39-.67l.44-.25C222.27,291,222.44,291.05,222.44,291.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.48,292.43v1.9a.83.83,0,0,1-.39.67l-.43.26c-.22.12-.39,0-.39-.23v-1.9a.86.86,0,0,1,.39-.68l.43-.25C220.31,292.08,220.48,292.18,220.48,292.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.52,293.56v1.9a.89.89,0,0,1-.39.68l-.44.25c-.21.12-.39,0-.39-.23v-1.9a.86.86,0,0,1,.39-.67l.44-.26C218.34,293.21,218.52,293.31,218.52,293.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.56,294.69v1.91a.89.89,0,0,1-.39.67l-.44.25c-.21.12-.39,0-.39-.22v-1.91a.86.86,0,0,1,.39-.67l.44-.26C216.38,294.34,216.56,294.44,216.56,294.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.37,298.51l-.81-.47h0a1.06,1.06,0,0,0-1.08.11,3.38,3.38,0,0,0-1.53,2.66,1.11,1.11,0,0,0,.44,1h0l.75.43.14-.23a1.52,1.52,0,0,0,.44-.17,3.42,3.42,0,0,0,1.54-2.66,1.62,1.62,0,0,0,0-.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.25,298.6a3.38,3.38,0,0,0-1.53,2.66c0,1,.68,1.38,1.53.89a3.41,3.41,0,0,0,1.54-2.67C210.79,298.5,210.1,298.11,209.25,298.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.25,298.6a3.38,3.38,0,0,0-1.53,2.66c0,1,.68,1.38,1.53.89a3.41,3.41,0,0,0,1.54-2.67C210.79,298.5,210.1,298.11,209.25,298.6Z",
    style: {
      fill: "#fafafa",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.7,302.36l-.81-.47h0a1.08,1.08,0,0,0-1.08.11,3.39,3.39,0,0,0-1.54,2.66,1.08,1.08,0,0,0,.45,1h0l.76.43.13-.23a1.42,1.42,0,0,0,.44-.17,3.39,3.39,0,0,0,1.54-2.66,1.48,1.48,0,0,0-.05-.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.58,302.45a3.39,3.39,0,0,0-1.54,2.66c0,1,.69,1.38,1.54.89a3.39,3.39,0,0,0,1.54-2.66C204.12,302.36,203.43,302,202.58,302.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.58,302.45a3.39,3.39,0,0,0-1.54,2.66c0,1,.69,1.38,1.54.89a3.39,3.39,0,0,0,1.54-2.66C204.12,302.36,203.43,302,202.58,302.45Z",
    style: {
      fill: "#fafafa",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.33,186a1.29,1.29,0,0,1-.67-.17,1.65,1.65,0,0,1-.73-1.5V170.14a4.17,4.17,0,0,1,1.91-3.31L244.18,143a1.5,1.5,0,0,1,2.4,1.39v14.19a4.15,4.15,0,0,1-1.91,3.3l-41.34,23.87A2,2,0,0,1,202.33,186Zm42.83-42.35a1,1,0,0,0-.49.16l-41.34,23.87a3.18,3.18,0,0,0-1.42,2.46v14.19a.75.75,0,0,0,.24.65.72.72,0,0,0,.69-.12L244.18,161a3.17,3.17,0,0,0,1.41-2.45V144.35a.73.73,0,0,0-.25-.66A.36.36,0,0,0,245.16,143.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,149.64a3.56,3.56,0,0,1-1.66,2.76l-35.1,20.26c-.91.53-1.66.16-1.66-.84a3.59,3.59,0,0,1,1.66-2.76l35.1-20.26C242.22,148.27,243,148.64,243,149.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,156.85a3.56,3.56,0,0,1-1.66,2.77l-35.1,20.26c-.91.53-1.66.15-1.66-.84a3.59,3.59,0,0,1,1.66-2.77L241.3,156C242.22,155.48,243,155.86,243,156.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.3,156l-14.9,8.6v3.6l14.9-8.59a3.56,3.56,0,0,0,1.66-2.77C243,155.86,242.22,155.48,241.3,156Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147.87,275.13l.81-.47h0a1.08,1.08,0,0,1,1.08.11,3.39,3.39,0,0,1,1.54,2.66,1.08,1.08,0,0,1-.45,1h0l-.76.43-.13-.23a1.42,1.42,0,0,1-.44-.17A3.39,3.39,0,0,1,148,275.8a1.62,1.62,0,0,1,0-.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,275.22a3.39,3.39,0,0,1,1.54,2.66c0,1-.69,1.38-1.54.89a3.4,3.4,0,0,1-1.54-2.67C147.45,275.12,148.14,274.73,149,275.22Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.19,271.09l6.24,3.59a3.89,3.89,0,0,1,1.77,3.06v3.58c0,1.13-.79,1.59-1.77,1l-6.24-3.58a3.92,3.92,0,0,1-1.77-3.07v-3.58C144.42,271,145.21,270.53,146.19,271.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.19,271.09l6.24,3.59a3.89,3.89,0,0,1,1.77,3.06v3.58c0,1.13-.79,1.59-1.77,1l-6.24-3.58a3.92,3.92,0,0,1-1.77-3.07v-3.58C144.42,271,145.21,270.53,146.19,271.09Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.87,275.13l.81-.47h0a1.08,1.08,0,0,1,1.08.11,3.39,3.39,0,0,1,1.54,2.66,1.08,1.08,0,0,1-.45,1h0l-.76.43-.13-.23a1.42,1.42,0,0,1-.44-.17A3.39,3.39,0,0,1,148,275.8a1.62,1.62,0,0,1,0-.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,275.22a3.39,3.39,0,0,1,1.54,2.66c0,1-.69,1.38-1.54.89a3.4,3.4,0,0,1-1.54-2.67C147.45,275.12,148.14,274.73,149,275.22Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.21,277.21l30.26,17.46a2.16,2.16,0,0,1,1,1.69v8.36c0,.63-.44.88-1,.57l-30.26-17.46a2.16,2.16,0,0,1-1-1.7v-8.35C158.23,277.15,158.67,276.9,159.21,277.21Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.07,280.89a2.1,2.1,0,0,0,1,1.63l26.58,15.33c.54.31,1,.09,1-.49a2.1,2.1,0,0,0-1-1.63L161.05,280.4C160.51,280.09,160.07,280.31,160.07,280.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.07,285.14a2.1,2.1,0,0,0,1,1.63l26.58,15.33c.54.31,1,.09,1-.5a2.1,2.1,0,0,0-1-1.62l-26.58-15.33C160.51,284.33,160.07,284.56,160.07,285.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.05,284.65l14.68,8.46v2.12l-14.68-8.46a2.1,2.1,0,0,1-1-1.63C160.07,284.56,160.51,284.33,161.05,284.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.19,253.76l6.24,3.58a3.92,3.92,0,0,1,1.77,3.07V264c0,1.13-.79,1.58-1.77,1l-6.24-3.59a3.89,3.89,0,0,1-1.77-3.06v-3.58C144.42,253.65,145.21,253.2,146.19,253.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.19,253.76l6.24,3.58a3.92,3.92,0,0,1,1.77,3.07V264c0,1.13-.79,1.58-1.77,1l-6.24-3.59a3.89,3.89,0,0,1-1.77-3.06v-3.58C144.42,253.65,145.21,253.2,146.19,253.76Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.87,257.8l.81-.47h0a1.11,1.11,0,0,1,1.08.11,3.41,3.41,0,0,1,1.54,2.67,1.07,1.07,0,0,1-.45,1h0l-.76.44-.13-.23a1.42,1.42,0,0,1-.44-.17,3.41,3.41,0,0,1-1.54-2.67,1.6,1.6,0,0,1,0-.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,257.88a3.41,3.41,0,0,1,1.54,2.67c0,1-.69,1.37-1.54.88a3.39,3.39,0,0,1-1.54-2.66C147.45,257.79,148.14,257.39,149,257.88Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.19,236.52l6.24,3.59a3.9,3.9,0,0,1,1.77,3.06v3.58c0,1.13-.79,1.59-1.77,1l-6.24-3.58a3.92,3.92,0,0,1-1.77-3.07v-3.57C144.42,236.42,145.21,236,146.19,236.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.19,236.52l6.24,3.59a3.9,3.9,0,0,1,1.77,3.06v3.58c0,1.13-.79,1.59-1.77,1l-6.24-3.58a3.92,3.92,0,0,1-1.77-3.07v-3.57C144.42,236.42,145.21,236,146.19,236.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.87,240.56l.81-.47h0a1.08,1.08,0,0,1,1.08.11,3.39,3.39,0,0,1,1.54,2.66,1.08,1.08,0,0,1-.45,1h0l-.76.43-.13-.23a1.42,1.42,0,0,1-.44-.17,3.39,3.39,0,0,1-1.54-2.66,1.48,1.48,0,0,1,0-.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.87,240.56l.81-.47h0a1.08,1.08,0,0,1,1.08.11,3.39,3.39,0,0,1,1.54,2.66,1.08,1.08,0,0,1-.45,1h0l-.76.43-.13-.23a1.42,1.42,0,0,1-.44-.17,3.39,3.39,0,0,1-1.54-2.66,1.48,1.48,0,0,1,0-.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,240.65a3.39,3.39,0,0,1,1.54,2.66c0,1-.69,1.38-1.54.89a3.39,3.39,0,0,1-1.54-2.66C147.45,240.56,148.14,240.16,149,240.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.21,242.64l30.26,17.46a2.16,2.16,0,0,1,1,1.7v8.35c0,.63-.44.88-1,.57l-30.26-17.46a2.16,2.16,0,0,1-1-1.69v-8.36C158.23,242.59,158.67,242.33,159.21,242.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.07,246.33a2.1,2.1,0,0,0,1,1.62l26.58,15.33c.54.32,1,.09,1-.49a2.1,2.1,0,0,0-1-1.63l-26.58-15.33C160.51,245.52,160.07,245.74,160.07,246.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.05,250.08l14.68,8.46v2.12l-14.68-8.46a2.1,2.1,0,0,1-1-1.63C160.07,250,160.51,249.77,161.05,250.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.87,240.56l.81-.47h0a1.08,1.08,0,0,1,1.08.11,3.39,3.39,0,0,1,1.54,2.66,1.08,1.08,0,0,1-.45,1h0l-.76.43-.13-.23a1.42,1.42,0,0,1-.44-.17,3.39,3.39,0,0,1-1.54-2.66,1.48,1.48,0,0,1,0-.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,240.65a3.39,3.39,0,0,1,1.54,2.66c0,1-.69,1.38-1.54.89a3.39,3.39,0,0,1-1.54-2.66C147.45,240.56,148.14,240.16,149,240.65Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.21,242.64l30.26,17.46a2.16,2.16,0,0,1,1,1.7v8.35c0,.63-.44.88-1,.57l-30.26-17.46a2.16,2.16,0,0,1-1-1.69v-8.36C158.23,242.59,158.67,242.33,159.21,242.64Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.07,246.33a2.1,2.1,0,0,0,1,1.62l26.58,15.33c.54.32,1,.09,1-.49a2.1,2.1,0,0,0-1-1.63l-26.58-15.33C160.51,245.52,160.07,245.74,160.07,246.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.07,250.57a2.1,2.1,0,0,0,1,1.63l26.58,15.33c.54.31,1,.09,1-.49a2.1,2.1,0,0,0-1-1.63l-26.58-15.33C160.51,249.77,160.07,250,160.07,250.57Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.05,250.08l14.68,8.46v2.12l-14.68-8.46a2.1,2.1,0,0,1-1-1.63C160.07,250,160.51,249.77,161.05,250.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.21,259.93l30.26,17.45a2.16,2.16,0,0,1,1,1.7v8.35c0,.63-.44.88-1,.57l-30.26-17.45a2.19,2.19,0,0,1-1-1.7v-8.36C158.23,259.87,158.67,259.61,159.21,259.93Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.07,263.61a2.13,2.13,0,0,0,1,1.63l26.58,15.33c.54.31,1,.09,1-.5a2.1,2.1,0,0,0-1-1.63l-26.58-15.33C160.51,262.8,160.07,263,160.07,263.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.07,267.86a2.1,2.1,0,0,0,1,1.62l26.58,15.33c.54.32,1,.09,1-.49a2.1,2.1,0,0,0-1-1.63l-26.58-15.33C160.51,267.05,160.07,267.27,160.07,267.86Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.05,267.36,179.41,278v2.12l-18.36-10.59a2.1,2.1,0,0,1-1-1.62C160.07,267.27,160.51,267.05,161.05,267.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--speech-bubble--inject-44",
    d: "M158.71,110.16a2,2,0,0,1-1.85-1.29l-2.2-6L144.08,109a1.44,1.44,0,0,1-2.31-1.34V59a4,4,0,0,1,1.84-3.2l53.5-30.89a1.6,1.6,0,0,1,1.61-.11,1.61,1.61,0,0,1,.7,1.45V74.94a4,4,0,0,1-1.84,3.2L163.81,97.63l-3.19,11.1a1.94,1.94,0,0,1-1.83,1.43Zm-3.56-8.6,2.59,7a1,1,0,0,0,1,.68,1,1,0,0,0,1-.76L163,97l34.09-19.69a3.08,3.08,0,0,0,1.38-2.39V26.27c0-.32-.09-.56-.24-.64a.7.7,0,0,0-.67.11l-53.5,30.89A3.08,3.08,0,0,0,142.7,59v48.67c0,.32.08.56.24.64a.7.7,0,0,0,.67-.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.44,48.56l0,18.35L158.3,84.69c-3.93-5-2.78-17.63,3.36-27.59C164.14,53.09,166.34,50.52,169.44,48.56Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.58,64.74c-2.2,11.15-9.9,21.51-17.48,23.36a7.41,7.41,0,0,1-7.53-1.84l11.22-18.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.87,62.81l-13.2,3.24,7.41-19.51C183.8,48.31,186,54.56,184.87,62.81Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.68,46.4,171,64V47.62A9.32,9.32,0,0,1,177.68,46.4Z",
    style: {
      fill: "#ebebeb"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--server-1--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--server--inject-44"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "147.93 324.17 92.81 355.99 37.68 324.17 92.81 292.34 147.93 324.17",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.93 324.17 92.81 355.99 37.68 324.17 92.81 292.34 147.93 324.17",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.81 355.99 92.81 352.02 41.13 322.18 37.68 324.17 92.81 355.99",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.81,356v21.78a7.6,7.6,0,0,0,3.67-.87h0l23.88-13.79,25.36-14.65a4.84,4.84,0,0,0,2.21-3.82V324.17Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.81,356v21.78a7.6,7.6,0,0,0,3.67-.87h0l23.88-13.79,25.36-14.65a4.84,4.84,0,0,0,2.21-3.82V324.17Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.68,324.17v20.47a4.88,4.88,0,0,0,2.2,3.82L61.8,361.11,89.14,376.9a7.54,7.54,0,0,0,3.67.87V356Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.68,324.17v20.47a4.88,4.88,0,0,0,2.2,3.82L61.8,361.11,89.14,376.9a7.54,7.54,0,0,0,3.67.87V356Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.93 300.3 92.81 332.13 37.68 300.3 92.81 268.47 147.93 300.3",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.93 300.3 92.81 332.13 37.68 300.3 92.81 268.47 147.93 300.3",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.81 332.13 92.81 328.15 41.13 298.31 37.68 300.3 92.81 332.13",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.93 316.21 92.81 348.04 92.81 332.13 147.93 300.3 147.93 316.21",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.93 316.21 92.81 348.04 92.81 332.13 147.93 300.3 147.93 316.21",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.81 348.04 37.68 316.21 37.68 300.3 92.81 332.13 92.81 348.04",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.81 348.04 37.68 316.21 37.68 300.3 92.81 332.13 92.81 348.04",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.04 324.17 141.04 320.19 92.81 348.04 92.81 352.02 141.04 324.17",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.13 318.2 41.13 322.18 92.81 352.02 92.81 348.04 41.13 318.2",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.13 318.2 41.13 322.18 92.81 352.02 92.81 348.04 41.13 318.2",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.93 276.43 92.81 308.25 37.68 276.43 92.81 244.6 147.93 276.43",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.93 276.43 92.81 308.25 37.68 276.43 92.81 244.6 147.93 276.43",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.81 308.25 92.81 304.28 41.13 274.44 37.68 276.43 92.81 308.25",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.93 292.34 92.81 324.17 92.81 308.25 147.93 276.43 147.93 292.34",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.93 292.34 92.81 324.17 92.81 308.25 147.93 276.43 147.93 292.34",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.81 324.17 37.68 292.34 37.68 276.43 92.81 308.25 92.81 324.17",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.81 324.17 37.68 292.34 37.68 276.43 92.81 308.25 92.81 324.17",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.04 300.3 141.04 296.32 92.81 324.17 92.81 328.15 141.04 300.3",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.13 294.33 41.13 298.31 92.81 328.15 92.81 324.17 41.13 294.33",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.04 276.43 141.04 272.45 92.81 300.3 92.81 304.28 141.04 276.43",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.13 270.46 41.13 274.44 92.81 304.28 92.81 300.3 41.13 270.46",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.93 252.56 92.81 284.39 37.68 252.56 92.81 220.74 147.93 252.56",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.93 252.56 92.81 284.39 37.68 252.56 92.81 220.74 147.93 252.56",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.93 252.56 92.81 284.39 37.68 252.56 92.81 220.74 147.93 252.56",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.81 280.41 92.81 284.39 37.68 252.56 41.13 250.58 92.81 280.41",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.93 268.47 92.81 300.3 92.81 284.39 147.93 252.56 147.93 268.47",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.93 268.47 92.81 300.3 92.81 284.39 147.93 252.56 147.93 268.47",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.81 300.3 37.68 268.47 37.68 252.56 92.81 284.39 92.81 300.3",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.81 300.3 37.68 268.47 37.68 252.56 92.81 284.39 92.81 300.3",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.04 252.57 141.04 248.59 92.81 276.44 92.81 280.41 141.04 252.57",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.13 246.6 41.13 250.58 92.81 280.41 92.81 276.44 41.13 246.6",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.93 228.65 92.81 260.47 37.68 228.65 92.81 196.82 147.93 228.65",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.93 228.65 92.81 260.47 37.68 228.65 92.81 196.82 147.93 228.65",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.93 228.65 92.81 260.47 37.68 228.65 92.81 196.82 147.93 228.65",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.81 256.5 92.81 260.47 37.68 228.65 41.13 226.66 92.81 256.5",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.93 244.56 92.81 276.38 92.81 260.47 147.93 228.65 147.93 244.56",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.93 244.56 92.81 276.38 92.81 260.47 147.93 228.65 147.93 244.56",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.81 276.38 37.68 244.56 37.68 228.65 92.81 260.47 92.81 276.38",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.81 276.38 37.68 244.56 37.68 228.65 92.81 260.47 92.81 276.38",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.88,203.51l50.75-29.28a4.89,4.89,0,0,1,4.41,0l50.69,29.28a4.9,4.9,0,0,1,2.2,3.82V220.7L92.77,252.52h0L37.68,220.7V207.33A4.9,4.9,0,0,1,39.88,203.51Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.88,203.51l50.75-29.28a4.89,4.89,0,0,1,4.41,0l50.69,29.28a4.9,4.9,0,0,1,2.2,3.82V220.7L92.77,252.52h0L37.68,220.7V207.33A4.9,4.9,0,0,1,39.88,203.51Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.78,235.86v16.66l55.15-31.82V207.33a4.92,4.92,0,0,0-1.81-3.54c.81.71.67,1.65-.4,2.27L95,235.34A4.57,4.57,0,0,1,92.78,235.86Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.78,235.86v16.66l55.15-31.82V207.33a4.92,4.92,0,0,0-1.81-3.54c.81.71.67,1.65-.4,2.27L95,235.34A4.57,4.57,0,0,1,92.78,235.86Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.73,206.06,95,235.34a4.87,4.87,0,0,1-4.4,0L39.88,206.06a1.35,1.35,0,0,1,0-2.55l50.75-29.28a4.89,4.89,0,0,1,4.41,0l50.69,29.28A1.35,1.35,0,0,1,145.73,206.06Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.73,206.06,95,235.34a4.87,4.87,0,0,1-4.4,0L39.88,206.06a1.35,1.35,0,0,1,0-2.55l50.75-29.28a4.89,4.89,0,0,1,4.41,0l50.69,29.28A1.35,1.35,0,0,1,145.73,206.06Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.04 228.65 141.04 224.68 92.81 252.52 92.81 256.5 141.04 228.65",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.13 222.69 41.13 226.66 92.81 256.5 92.81 252.52 41.13 222.69",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.67,349.54a1.68,1.68,0,0,1,.77,1.32c0,.49-.35.69-.77.44a1.67,1.67,0,0,1-.76-1.32C48.91,349.49,49.25,349.29,49.67,349.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,353.22a1.69,1.69,0,0,1,.77,1.32c0,.49-.34.69-.77.44a1.67,1.67,0,0,1-.76-1.32C55.28,353.18,55.62,353,56,353.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.31,356.84a1.67,1.67,0,0,1,.76,1.31c0,.49-.34.69-.76.44a1.67,1.67,0,0,1-.76-1.31C61.55,356.79,61.89,356.6,62.31,356.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.63,360.49a1.67,1.67,0,0,1,.76,1.31c0,.48-.34.68-.76.44a1.67,1.67,0,0,1-.76-1.31C67.87,360.44,68.21,360.25,68.63,360.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.24,330.75l6.47,3.72a4.05,4.05,0,0,1,1.84,3.18v3.72c0,1.17-.82,1.64-1.84,1.06l-6.47-3.72a4.05,4.05,0,0,1-1.84-3.18v-3.72C40.4,330.64,41.22,330.17,42.24,330.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44,334.94l.84-.49h0a1.11,1.11,0,0,1,1.12.12,3.53,3.53,0,0,1,1.6,2.76,1.11,1.11,0,0,1-.47,1h0l-.78.45-.14-.23a1.9,1.9,0,0,1-.46-.18,3.54,3.54,0,0,1-1.6-2.77,1.62,1.62,0,0,1,0-.4Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,334.94l.84-.49h0a1.11,1.11,0,0,1,1.12.12,3.53,3.53,0,0,1,1.6,2.76,1.11,1.11,0,0,1-.47,1h0l-.78.45-.14-.23a1.9,1.9,0,0,1-.46-.18,3.54,3.54,0,0,1-1.6-2.77,1.62,1.62,0,0,1,0-.4Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.14,335a3.54,3.54,0,0,1,1.6,2.77c0,1-.71,1.43-1.6.92A3.53,3.53,0,0,1,43.55,336C43.55,334.94,44.26,334.52,45.14,335Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.24,306.86l6.47,3.73a4,4,0,0,1,1.84,3.18v3.71c0,1.17-.82,1.65-1.84,1.06l-6.47-3.72a4.05,4.05,0,0,1-1.84-3.18v-3.72C40.4,306.75,41.22,306.28,42.24,306.86Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44,311.05l.84-.48h0a1.11,1.11,0,0,1,1.12.11,3.54,3.54,0,0,1,1.6,2.76,1.14,1.14,0,0,1-.47,1h0l-.78.45-.14-.24a1.56,1.56,0,0,1-.46-.18,3.53,3.53,0,0,1-1.6-2.76,1.7,1.7,0,0,1,0-.41Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,311.05l.84-.48h0a1.11,1.11,0,0,1,1.12.11,3.54,3.54,0,0,1,1.6,2.76,1.14,1.14,0,0,1-.47,1h0l-.78.45-.14-.24a1.56,1.56,0,0,1-.46-.18,3.53,3.53,0,0,1-1.6-2.76,1.7,1.7,0,0,1,0-.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.14,311.14a3.54,3.54,0,0,1,1.6,2.77c0,1-.71,1.43-1.6.92a3.53,3.53,0,0,1-1.59-2.76C43.55,311.05,44.26,310.64,45.14,311.14Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.24,283l6.47,3.72a4.05,4.05,0,0,1,1.84,3.18v3.72c0,1.17-.82,1.64-1.84,1.06L42.24,291a4.05,4.05,0,0,1-1.84-3.18v-3.72C40.4,282.88,41.22,282.41,42.24,283Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44,287.18l.84-.48h0a1.11,1.11,0,0,1,1.12.12,3.53,3.53,0,0,1,1.6,2.76,1.11,1.11,0,0,1-.47,1h0l-.78.45-.14-.23a1.9,1.9,0,0,1-.46-.18,3.54,3.54,0,0,1-1.6-2.77,1.62,1.62,0,0,1,0-.4Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,287.18l.84-.48h0a1.11,1.11,0,0,1,1.12.12,3.53,3.53,0,0,1,1.6,2.76,1.11,1.11,0,0,1-.47,1h0l-.78.45-.14-.23a1.9,1.9,0,0,1-.46-.18,3.54,3.54,0,0,1-1.6-2.77,1.62,1.62,0,0,1,0-.4Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.14,287.27a3.54,3.54,0,0,1,1.6,2.77c0,1-.71,1.43-1.6.92a3.53,3.53,0,0,1-1.59-2.77C43.55,287.18,44.26,286.76,45.14,287.27Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.24,259.15l6.47,3.72a4.05,4.05,0,0,1,1.84,3.18v3.72c0,1.17-.82,1.64-1.84,1.06l-6.47-3.73a4,4,0,0,1-1.84-3.18v-3.71C40.4,259,41.22,258.56,42.24,259.15Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44,263.34l.84-.49h0A1.13,1.13,0,0,1,46,263a3.54,3.54,0,0,1,1.6,2.77,1.12,1.12,0,0,1-.47,1h0l-.78.45-.14-.24a1.52,1.52,0,0,1-.46-.17A3.54,3.54,0,0,1,44.1,264a1.77,1.77,0,0,1,0-.41Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,263.34l.84-.49h0A1.13,1.13,0,0,1,46,263a3.54,3.54,0,0,1,1.6,2.77,1.12,1.12,0,0,1-.47,1h0l-.78.45-.14-.24a1.52,1.52,0,0,1-.46-.17A3.54,3.54,0,0,1,44.1,264a1.77,1.77,0,0,1,0-.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.14,263.43a3.54,3.54,0,0,1,1.6,2.76c0,1-.71,1.43-1.6.93a3.53,3.53,0,0,1-1.59-2.77C43.55,263.33,44.26,262.92,45.14,263.43Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.24,235.23,48.71,239a4,4,0,0,1,1.84,3.18v3.71c0,1.17-.82,1.65-1.84,1.06l-6.47-3.72A4,4,0,0,1,40.4,240v-3.72C40.4,235.12,41.22,234.65,42.24,235.23Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44,239.42l.84-.48h0a1.11,1.11,0,0,1,1.12.11,3.54,3.54,0,0,1,1.6,2.76,1.14,1.14,0,0,1-.47,1h0l-.78.45-.14-.24a1.33,1.33,0,0,1-.46-.18,3.53,3.53,0,0,1-1.6-2.76,1.7,1.7,0,0,1,0-.41Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,239.42l.84-.48h0a1.11,1.11,0,0,1,1.12.11,3.54,3.54,0,0,1,1.6,2.76,1.14,1.14,0,0,1-.47,1h0l-.78.45-.14-.24a1.33,1.33,0,0,1-.46-.18,3.53,3.53,0,0,1-1.6-2.76,1.7,1.7,0,0,1,0-.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.14,239.52a3.51,3.51,0,0,1,1.6,2.76c0,1-.71,1.43-1.6.92a3.53,3.53,0,0,1-1.59-2.76C43.55,239.42,44.26,239,45.14,239.52Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.24,211.34l6.47,3.73a4,4,0,0,1,1.84,3.18V222c0,1.17-.82,1.65-1.84,1.06l-6.47-3.72a4,4,0,0,1-1.84-3.18v-3.71C40.4,211.23,41.22,210.76,42.24,211.34Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44,215.53l.84-.48h0a1.11,1.11,0,0,1,1.12.11,3.54,3.54,0,0,1,1.6,2.77,1.13,1.13,0,0,1-.47,1h0l-.78.45-.14-.24a1.33,1.33,0,0,1-.46-.18,3.53,3.53,0,0,1-1.6-2.76,1.7,1.7,0,0,1,0-.41Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,215.53l.84-.48h0a1.11,1.11,0,0,1,1.12.11,3.54,3.54,0,0,1,1.6,2.77,1.13,1.13,0,0,1-.47,1h0l-.78.45-.14-.24a1.33,1.33,0,0,1-.46-.18,3.53,3.53,0,0,1-1.6-2.76,1.7,1.7,0,0,1,0-.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.14,215.63a3.51,3.51,0,0,1,1.6,2.76c0,1-.71,1.43-1.6.92a3.52,3.52,0,0,1-1.59-2.76C43.55,215.53,44.26,215.12,45.14,215.63Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.65,331.2,115.31,347a4.07,4.07,0,0,0-1.83,3.18v3.72c0,1.17.82,1.65,1.83,1.06l27.34-15.78a4.07,4.07,0,0,0,1.83-3.18v-3.72C144.48,331.09,143.66,330.62,142.65,331.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.55,334.35v1.8a.82.82,0,0,1-.37.64l-.41.24c-.21.11-.37,0-.37-.22V335a.78.78,0,0,1,.37-.63l.41-.24C142.38,334,142.55,334.11,142.55,334.35Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.69,335.42v1.8a.82.82,0,0,1-.37.64l-.41.24c-.2.11-.37,0-.37-.22v-1.8a.81.81,0,0,1,.37-.63l.41-.24C140.53,335.09,140.69,335.18,140.69,335.42Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.83,336.49v1.8a.81.81,0,0,1-.36.64l-.42.24c-.2.11-.36,0-.36-.22v-1.8a.8.8,0,0,1,.36-.63l.42-.24C138.67,336.16,138.83,336.25,138.83,336.49Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,337.56v1.8a.82.82,0,0,1-.37.64l-.41.24c-.21.11-.37,0-.37-.22v-1.8a.78.78,0,0,1,.37-.63l.41-.24C136.81,337.23,137,337.32,137,337.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.12,338.63v1.8a.8.8,0,0,1-.37.64l-.41.24c-.2.11-.37,0-.37-.22v-1.8a.81.81,0,0,1,.37-.63l.41-.24C135,338.3,135.12,338.39,135.12,338.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.27,339.7v1.8a.82.82,0,0,1-.37.64l-.42.24c-.2.11-.36,0-.36-.22v-1.8a.8.8,0,0,1,.36-.63l.42-.24C133.1,339.37,133.27,339.46,133.27,339.7Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.41,340.77v1.8a.82.82,0,0,1-.37.64l-.41.24c-.2.11-.37,0-.37-.22v-1.8a.81.81,0,0,1,.37-.63l.41-.24C131.24,340.44,131.41,340.53,131.41,340.77Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.55,341.84v1.8a.81.81,0,0,1-.36.64l-.42.24c-.2.11-.36,0-.36-.22v-1.8a.8.8,0,0,1,.36-.63l.42-.24C129.39,341.51,129.55,341.6,129.55,341.84Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.7,342.91v1.8a.82.82,0,0,1-.37.64l-.41.24c-.21.11-.37,0-.37-.22v-1.8a.78.78,0,0,1,.37-.63l.41-.24C127.53,342.58,127.7,342.67,127.7,342.91Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.84,344v1.8a.8.8,0,0,1-.37.64l-.41.24c-.2.11-.37,0-.37-.22v-1.8a.81.81,0,0,1,.37-.63l.41-.24C125.68,343.65,125.84,343.74,125.84,344Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,345.05v1.8a.81.81,0,0,1-.36.64l-.42.24c-.2.11-.36,0-.36-.22v-1.8a.83.83,0,0,1,.36-.64l.42-.23C123.82,344.72,124,344.81,124,345.05Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.13,346.12v1.8a.82.82,0,0,1-.37.64l-.41.24c-.2.11-.37,0-.37-.22v-1.8a.81.81,0,0,1,.37-.63l.41-.24C122,345.79,122.13,345.88,122.13,346.12Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.27,347.19V349a.81.81,0,0,1-.36.64l-.42.24c-.2.11-.37,0-.37-.22v-1.8a.81.81,0,0,1,.37-.63l.42-.24C120.11,346.86,120.27,347,120.27,347.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.42,348.26v1.8a.82.82,0,0,1-.37.64l-.41.24c-.21.11-.37,0-.37-.22v-1.8a.81.81,0,0,1,.37-.64l.41-.23C118.25,347.93,118.42,348,118.42,348.26Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.56,349.33v1.8a.81.81,0,0,1-.37.64l-.41.24c-.2.11-.37,0-.37-.22V350a.84.84,0,0,1,.37-.64l.41-.23C116.4,349,116.56,349.09,116.56,349.33Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.65,307.34l-27.34,15.78a4.06,4.06,0,0,0-1.83,3.18V330c0,1.17.82,1.64,1.83,1.06l27.34-15.79a4.06,4.06,0,0,0,1.83-3.18V308.4C144.48,307.23,143.66,306.75,142.65,307.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.55,310.48v1.81a.81.81,0,0,1-.37.63l-.41.24c-.21.12-.37,0-.37-.21v-1.8a.8.8,0,0,1,.37-.64l.41-.24C142.38,310.16,142.55,310.25,142.55,310.48Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.69,311.55v1.81a.81.81,0,0,1-.37.63l-.41.24a.23.23,0,0,1-.37-.21v-1.8a.82.82,0,0,1,.37-.64l.41-.24C140.53,311.23,140.69,311.32,140.69,311.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.83,312.62v1.81a.8.8,0,0,1-.36.63l-.42.24c-.2.12-.36,0-.36-.21v-1.8a.81.81,0,0,1,.36-.64l.42-.24C138.67,312.3,138.83,312.39,138.83,312.62Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,313.69v1.81a.81.81,0,0,1-.37.63l-.41.24c-.21.12-.37,0-.37-.21v-1.8a.8.8,0,0,1,.37-.64l.41-.24C136.81,313.37,137,313.46,137,313.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.12,314.76v1.81a.78.78,0,0,1-.37.63l-.41.24a.23.23,0,0,1-.37-.21v-1.8a.82.82,0,0,1,.37-.64l.41-.24C135,314.44,135.12,314.53,135.12,314.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.27,315.83v1.81a.81.81,0,0,1-.37.63l-.42.24c-.2.12-.36,0-.36-.21v-1.8a.81.81,0,0,1,.36-.64l.42-.24C133.1,315.51,133.27,315.6,133.27,315.83Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.41,316.9v1.81a.81.81,0,0,1-.37.63l-.41.24a.23.23,0,0,1-.37-.21v-1.8a.82.82,0,0,1,.37-.64l.41-.24C131.24,316.58,131.41,316.67,131.41,316.9Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.55,318v1.81a.8.8,0,0,1-.36.63l-.42.24c-.2.12-.36,0-.36-.21v-1.8a.81.81,0,0,1,.36-.64l.42-.24C129.39,317.65,129.55,317.74,129.55,318Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.7,319v1.81a.81.81,0,0,1-.37.63l-.41.24c-.21.12-.37,0-.37-.21v-1.8a.8.8,0,0,1,.37-.64l.41-.24C127.53,318.72,127.7,318.81,127.7,319Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.84,320.11v1.81a.78.78,0,0,1-.37.63l-.41.24a.23.23,0,0,1-.37-.21v-1.8a.82.82,0,0,1,.37-.64l.41-.24C125.68,319.78,125.84,319.88,125.84,320.11Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,321.18V323a.8.8,0,0,1-.36.63l-.42.24c-.2.12-.36,0-.36-.21v-1.8a.81.81,0,0,1,.36-.64l.42-.24C123.82,320.85,124,321,124,321.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.13,322.25v1.81a.81.81,0,0,1-.37.63l-.41.24a.23.23,0,0,1-.37-.21v-1.8a.82.82,0,0,1,.37-.64l.41-.24A.23.23,0,0,1,122.13,322.25Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.27,323.32v1.81a.8.8,0,0,1-.36.63l-.42.24a.23.23,0,0,1-.37-.21V324a.82.82,0,0,1,.37-.64l.42-.24C120.11,323,120.27,323.09,120.27,323.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.42,324.39v1.81a.81.81,0,0,1-.37.63l-.41.24c-.21.12-.37,0-.37-.21v-1.8a.8.8,0,0,1,.37-.64l.41-.24A.23.23,0,0,1,118.42,324.39Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.56,325.46v1.81a.78.78,0,0,1-.37.63l-.41.24a.23.23,0,0,1-.37-.21v-1.8a.82.82,0,0,1,.37-.64l.41-.24C116.4,325.13,116.56,325.23,116.56,325.46Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.65,283.45l-27.34,15.78a4.06,4.06,0,0,0-1.83,3.18v3.71c0,1.17.82,1.65,1.83,1.06l27.34-15.78a4.06,4.06,0,0,0,1.83-3.18v-3.71C144.48,283.33,143.66,282.86,142.65,283.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.55,286.59v1.8a.82.82,0,0,1-.37.64l-.41.24c-.21.12-.37,0-.37-.21v-1.8a.8.8,0,0,1,.37-.64l.41-.24A.23.23,0,0,1,142.55,286.59Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.69,287.66v1.8a.82.82,0,0,1-.37.64l-.41.24a.23.23,0,0,1-.37-.21v-1.81a.82.82,0,0,1,.37-.63l.41-.24C140.53,287.33,140.69,287.43,140.69,287.66Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.83,288.73v1.8a.81.81,0,0,1-.36.64l-.42.24c-.2.12-.36,0-.36-.21v-1.8a.81.81,0,0,1,.36-.64l.42-.24C138.67,288.4,138.83,288.5,138.83,288.73Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,289.8v1.8a.82.82,0,0,1-.37.64l-.41.24c-.21.12-.37,0-.37-.21v-1.81a.8.8,0,0,1,.37-.63l.41-.24A.23.23,0,0,1,137,289.8Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.12,290.87v1.8a.8.8,0,0,1-.37.64l-.41.24a.23.23,0,0,1-.37-.21v-1.81a.82.82,0,0,1,.37-.63l.41-.24C135,290.54,135.12,290.64,135.12,290.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.27,291.94v1.8a.82.82,0,0,1-.37.64l-.42.24c-.2.12-.36,0-.36-.21V292.6a.81.81,0,0,1,.36-.63l.42-.24A.23.23,0,0,1,133.27,291.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.41,293v1.8a.82.82,0,0,1-.37.64l-.41.24a.23.23,0,0,1-.37-.21v-1.81a.82.82,0,0,1,.37-.63l.41-.24A.23.23,0,0,1,131.41,293Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.55,294.08v1.8a.81.81,0,0,1-.36.64l-.42.24c-.2.12-.36,0-.36-.21v-1.81a.81.81,0,0,1,.36-.63l.42-.24C129.39,293.75,129.55,293.85,129.55,294.08Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.7,295.15V297a.82.82,0,0,1-.37.64l-.41.24c-.21.12-.37,0-.37-.21v-1.81a.8.8,0,0,1,.37-.63l.41-.24A.23.23,0,0,1,127.7,295.15Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.84,296.22V298a.8.8,0,0,1-.37.64l-.41.24a.23.23,0,0,1-.37-.21v-1.81a.82.82,0,0,1,.37-.63l.41-.24C125.68,295.89,125.84,296,125.84,296.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,297.29v1.8a.81.81,0,0,1-.36.64l-.42.24c-.2.12-.36,0-.36-.21V298a.81.81,0,0,1,.36-.63l.42-.24C123.82,297,124,297.06,124,297.29Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.13,298.36v1.8a.82.82,0,0,1-.37.64l-.41.24a.23.23,0,0,1-.37-.21V299a.82.82,0,0,1,.37-.63l.41-.24A.23.23,0,0,1,122.13,298.36Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.27,299.43v1.8a.81.81,0,0,1-.36.64l-.42.24a.23.23,0,0,1-.37-.21v-1.81a.82.82,0,0,1,.37-.63l.42-.24C120.11,299.1,120.27,299.2,120.27,299.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.42,300.5v1.8a.82.82,0,0,1-.37.64l-.41.24c-.21.12-.37,0-.37-.21v-1.81a.8.8,0,0,1,.37-.63l.41-.24A.23.23,0,0,1,118.42,300.5Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.56,301.57v1.8a.8.8,0,0,1-.37.64l-.41.24a.23.23,0,0,1-.37-.21v-1.81a.82.82,0,0,1,.37-.63l.41-.24C116.4,301.24,116.56,301.34,116.56,301.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.65,259.59l-27.34,15.79a4.06,4.06,0,0,0-1.83,3.18v3.71c0,1.17.82,1.65,1.83,1.06l27.34-15.78a4.06,4.06,0,0,0,1.83-3.18v-3.72C144.48,259.48,143.66,259,142.65,259.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.55,262.74v1.8a.82.82,0,0,1-.37.64l-.41.24c-.21.12-.37,0-.37-.21V263.4a.8.8,0,0,1,.37-.63l.41-.24A.23.23,0,0,1,142.55,262.74Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.69,263.81v1.8a.82.82,0,0,1-.37.64l-.41.24a.23.23,0,0,1-.37-.21v-1.81a.82.82,0,0,1,.37-.63l.41-.24C140.53,263.48,140.69,263.58,140.69,263.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.83,264.88v1.8a.81.81,0,0,1-.36.64l-.42.24c-.2.12-.36,0-.36-.21v-1.81a.81.81,0,0,1,.36-.63l.42-.24C138.67,264.55,138.83,264.65,138.83,264.88Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,266v1.8a.82.82,0,0,1-.37.64l-.41.24c-.21.12-.37,0-.37-.21v-1.81a.8.8,0,0,1,.37-.63l.41-.24A.23.23,0,0,1,137,266Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.12,267v1.8a.8.8,0,0,1-.37.64l-.41.24a.23.23,0,0,1-.37-.21v-1.81a.82.82,0,0,1,.37-.63l.41-.24C135,266.69,135.12,266.79,135.12,267Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.27,268.09v1.8a.82.82,0,0,1-.37.64l-.42.24c-.2.12-.36,0-.36-.21v-1.81a.81.81,0,0,1,.36-.63l.42-.24A.23.23,0,0,1,133.27,268.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.41,269.16V271a.82.82,0,0,1-.37.64l-.41.24a.23.23,0,0,1-.37-.21v-1.81a.82.82,0,0,1,.37-.63L131,269A.23.23,0,0,1,131.41,269.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.55,270.23V272a.81.81,0,0,1-.36.64l-.42.24c-.2.12-.36,0-.36-.21v-1.81a.81.81,0,0,1,.36-.63l.42-.24C129.39,269.9,129.55,270,129.55,270.23Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.7,271.3v1.8a.82.82,0,0,1-.37.64l-.41.24c-.21.12-.37,0-.37-.21V272a.78.78,0,0,1,.37-.63l.41-.24A.23.23,0,0,1,127.7,271.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.84,272.37v1.8a.8.8,0,0,1-.37.64l-.41.24a.23.23,0,0,1-.37-.21V273a.82.82,0,0,1,.37-.63l.41-.24C125.68,272,125.84,272.14,125.84,272.37Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,273.44v1.8a.81.81,0,0,1-.36.64l-.42.24c-.2.12-.36,0-.36-.21V274.1a.81.81,0,0,1,.36-.63l.42-.24C123.82,273.11,124,273.21,124,273.44Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.13,274.51v1.8a.82.82,0,0,1-.37.64l-.41.24A.23.23,0,0,1,121,277v-1.81a.81.81,0,0,1,.37-.63l.41-.24A.23.23,0,0,1,122.13,274.51Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.27,275.58v1.8a.81.81,0,0,1-.36.64l-.42.24a.23.23,0,0,1-.37-.21v-1.81a.81.81,0,0,1,.37-.63l.42-.24C120.11,275.25,120.27,275.35,120.27,275.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.42,276.65v1.8a.82.82,0,0,1-.37.64l-.41.24c-.21.12-.37,0-.37-.21v-1.81a.78.78,0,0,1,.37-.63l.41-.24A.23.23,0,0,1,118.42,276.65Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.56,277.72v1.8a.8.8,0,0,1-.37.64l-.41.24a.23.23,0,0,1-.37-.21v-1.81a.81.81,0,0,1,.37-.63l.41-.24C116.4,277.39,116.56,277.49,116.56,277.72Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.65,235.68l-27.34,15.78a4.07,4.07,0,0,0-1.83,3.18v3.72c0,1.17.82,1.65,1.83,1.06l27.34-15.78a4.07,4.07,0,0,0,1.83-3.18v-3.72C144.48,235.57,143.66,235.1,142.65,235.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.55,238.83v1.8a.84.84,0,0,1-.37.64l-.41.24c-.21.11-.37,0-.37-.22v-1.8a.81.81,0,0,1,.37-.64l.41-.23C142.38,238.5,142.55,238.59,142.55,238.83Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.69,239.9v1.8a.84.84,0,0,1-.37.64l-.41.24c-.2.11-.37,0-.37-.22v-1.8a.84.84,0,0,1,.37-.64l.41-.23C140.53,239.57,140.69,239.66,140.69,239.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.83,241v1.8a.83.83,0,0,1-.36.64l-.42.24c-.2.11-.36,0-.36-.22v-1.8a.83.83,0,0,1,.36-.64l.42-.23C138.67,240.64,138.83,240.73,138.83,241Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,242v1.8a.84.84,0,0,1-.37.64l-.41.24c-.21.11-.37,0-.37-.22v-1.8a.81.81,0,0,1,.37-.64l.41-.23C136.81,241.71,137,241.8,137,242Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.12,243.11v1.8a.81.81,0,0,1-.37.64l-.41.23c-.2.12-.37,0-.37-.21v-1.8a.84.84,0,0,1,.37-.64l.41-.23C135,242.78,135.12,242.87,135.12,243.11Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.27,244.18V246a.84.84,0,0,1-.37.64l-.42.23c-.2.12-.36,0-.36-.21v-1.8a.83.83,0,0,1,.36-.64l.42-.23C133.1,243.85,133.27,243.94,133.27,244.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.41,245.25v1.8a.84.84,0,0,1-.37.64l-.41.23c-.2.12-.37,0-.37-.21v-1.8a.84.84,0,0,1,.37-.64L131,245C131.24,244.92,131.41,245,131.41,245.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.55,246.32v1.8a.83.83,0,0,1-.36.64l-.42.23c-.2.12-.36,0-.36-.21V247a.83.83,0,0,1,.36-.64l.42-.23C129.39,246,129.55,246.08,129.55,246.32Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.7,247.39v1.8a.84.84,0,0,1-.37.64l-.41.23c-.21.12-.37,0-.37-.21v-1.8a.81.81,0,0,1,.37-.64l.41-.23C127.53,247.06,127.7,247.15,127.7,247.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.84,248.46v1.8a.81.81,0,0,1-.37.64l-.41.23c-.2.12-.37,0-.37-.21v-1.8a.84.84,0,0,1,.37-.64l.41-.23C125.68,248.13,125.84,248.22,125.84,248.46Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,249.53v1.8a.83.83,0,0,1-.36.64l-.42.23c-.2.12-.36,0-.36-.21v-1.8a.83.83,0,0,1,.36-.64l.42-.23C123.82,249.2,124,249.29,124,249.53Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.13,250.6v1.8a.84.84,0,0,1-.37.64l-.41.23c-.2.12-.37,0-.37-.21v-1.8a.84.84,0,0,1,.37-.64l.41-.23C122,250.27,122.13,250.36,122.13,250.6Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.27,251.67v1.8a.83.83,0,0,1-.36.64l-.42.23c-.2.12-.37,0-.37-.21v-1.8a.84.84,0,0,1,.37-.64l.42-.23C120.11,251.34,120.27,251.43,120.27,251.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.42,252.74v1.8a.84.84,0,0,1-.37.64l-.41.23c-.21.12-.37,0-.37-.21v-1.8a.81.81,0,0,1,.37-.64l.41-.23C118.25,252.41,118.42,252.5,118.42,252.74Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.56,253.81v1.8a.81.81,0,0,1-.37.64l-.41.23c-.2.12-.37,0-.37-.21v-1.8a.84.84,0,0,1,.37-.64l.41-.23C116.4,253.48,116.56,253.57,116.56,253.81Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.65,211.81l-27.34,15.78a4.07,4.07,0,0,0-1.83,3.18v3.72c0,1.17.82,1.64,1.83,1.06l27.34-15.78a4.07,4.07,0,0,0,1.83-3.18v-3.72C144.48,211.7,143.66,211.22,142.65,211.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.55,215v1.8a.84.84,0,0,1-.37.64l-.41.23c-.21.12-.37,0-.37-.21v-1.8a.81.81,0,0,1,.37-.64l.41-.24C142.38,214.63,142.55,214.72,142.55,215Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.69,216v1.8a.84.84,0,0,1-.37.64l-.41.23c-.2.12-.37,0-.37-.21v-1.8a.84.84,0,0,1,.37-.64l.41-.24C140.53,215.7,140.69,215.79,140.69,216Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.83,217.1v1.8a.83.83,0,0,1-.36.64l-.42.23c-.2.12-.36,0-.36-.21v-1.8a.83.83,0,0,1,.36-.64l.42-.24C138.67,216.77,138.83,216.86,138.83,217.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,218.17V220a.84.84,0,0,1-.37.64l-.41.23c-.21.12-.37,0-.37-.21v-1.8a.81.81,0,0,1,.37-.64l.41-.24C136.81,217.84,137,217.93,137,218.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.12,219.24V221a.81.81,0,0,1-.37.64l-.41.23c-.2.12-.37,0-.37-.21v-1.8a.84.84,0,0,1,.37-.64l.41-.24C135,218.91,135.12,219,135.12,219.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.27,220.31v1.8a.84.84,0,0,1-.37.64l-.42.23c-.2.12-.36,0-.36-.21V221a.83.83,0,0,1,.36-.64l.42-.24C133.1,220,133.27,220.07,133.27,220.31Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.41,221.38v1.8a.84.84,0,0,1-.37.64l-.41.23c-.2.12-.37,0-.37-.21V222a.84.84,0,0,1,.37-.64l.41-.24C131.24,221.05,131.41,221.14,131.41,221.38Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.55,222.45v1.8a.83.83,0,0,1-.36.64l-.42.23c-.2.12-.36,0-.36-.21v-1.8a.83.83,0,0,1,.36-.64l.42-.24C129.39,222.12,129.55,222.21,129.55,222.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.7,223.52v1.8a.84.84,0,0,1-.37.64l-.41.23c-.21.12-.37,0-.37-.21v-1.8a.8.8,0,0,1,.37-.64l.41-.24C127.53,223.19,127.7,223.28,127.7,223.52Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.84,224.59v1.8a.81.81,0,0,1-.37.64l-.41.23c-.2.12-.37,0-.37-.21v-1.8a.84.84,0,0,1,.37-.64l.41-.24C125.68,224.26,125.84,224.35,125.84,224.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,225.66v1.8a.83.83,0,0,1-.36.64l-.42.23c-.2.12-.36,0-.36-.21v-1.8a.81.81,0,0,1,.36-.64l.42-.24C123.82,225.33,124,225.42,124,225.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.13,226.73v1.8a.81.81,0,0,1-.37.63l-.41.24c-.2.12-.37,0-.37-.21v-1.8a.82.82,0,0,1,.37-.64l.41-.24C122,226.4,122.13,226.49,122.13,226.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.27,227.8v1.8a.8.8,0,0,1-.36.63l-.42.24c-.2.12-.37,0-.37-.21v-1.8a.82.82,0,0,1,.37-.64l.42-.24C120.11,227.47,120.27,227.56,120.27,227.8Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.42,228.87v1.8a.84.84,0,0,1-.37.64l-.41.23c-.21.12-.37,0-.37-.21v-1.8a.8.8,0,0,1,.37-.64l.41-.24C118.25,228.54,118.42,228.63,118.42,228.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.56,229.94v1.8a.78.78,0,0,1-.37.63l-.41.24c-.2.12-.37,0-.37-.21v-1.8a.82.82,0,0,1,.37-.64l.41-.24C116.4,229.61,116.56,229.7,116.56,229.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.59,353.78l-.84-.48h0a1.14,1.14,0,0,0-1.12.12,3.51,3.51,0,0,0-1.6,2.76,1.14,1.14,0,0,0,.47,1h0l.78.45.14-.24a1.56,1.56,0,0,0,.46-.18,3.54,3.54,0,0,0,1.6-2.76,1.7,1.7,0,0,0,0-.41Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.59,353.78l-.84-.48h0a1.14,1.14,0,0,0-1.12.12,3.51,3.51,0,0,0-1.6,2.76,1.14,1.14,0,0,0,.47,1h0l.78.45.14-.24a1.56,1.56,0,0,0,.46-.18,3.54,3.54,0,0,0,1.6-2.76,1.7,1.7,0,0,0,0-.41Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43,353.87a3.52,3.52,0,0,0-1.6,2.77c0,1,.71,1.43,1.6.92A3.53,3.53,0,0,0,109,354.8C109,353.78,108.31,353.36,107.43,353.87Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43,353.87a3.52,3.52,0,0,0-1.6,2.77c0,1,.71,1.43,1.6.92A3.53,3.53,0,0,0,109,354.8C109,353.78,108.31,353.36,107.43,353.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.66,357.78l-.84-.48h0a1.11,1.11,0,0,0-1.12.12,3.53,3.53,0,0,0-1.6,2.76,1.11,1.11,0,0,0,.47,1h0l.78.44.14-.23a1.9,1.9,0,0,0,.46-.18,3.54,3.54,0,0,0,1.6-2.77,1.62,1.62,0,0,0-.05-.4Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.66,357.78l-.84-.48h0a1.11,1.11,0,0,0-1.12.12,3.53,3.53,0,0,0-1.6,2.76,1.11,1.11,0,0,0,.47,1h0l.78.44.14-.23a1.9,1.9,0,0,0,.46-.18,3.54,3.54,0,0,0,1.6-2.77,1.62,1.62,0,0,0-.05-.4Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5,357.87a3.54,3.54,0,0,0-1.6,2.77c0,1,.72,1.43,1.6.92a3.53,3.53,0,0,0,1.59-2.77C102.09,357.78,101.38,357.36,100.5,357.87Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5,357.87a3.54,3.54,0,0,0-1.6,2.77c0,1,.72,1.43,1.6.92a3.53,3.53,0,0,0,1.59-2.77C102.09,357.78,101.38,357.36,100.5,357.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.59,329.91l-.84-.48h0a1.11,1.11,0,0,0-1.12.11,3.51,3.51,0,0,0-1.6,2.76,1.14,1.14,0,0,0,.47,1h0l.78.45.14-.24a1.56,1.56,0,0,0,.46-.18,3.53,3.53,0,0,0,1.6-2.76,1.7,1.7,0,0,0,0-.41Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.59,329.91l-.84-.48h0a1.11,1.11,0,0,0-1.12.11,3.51,3.51,0,0,0-1.6,2.76,1.14,1.14,0,0,0,.47,1h0l.78.45.14-.24a1.56,1.56,0,0,0,.46-.18,3.53,3.53,0,0,0,1.6-2.76,1.7,1.7,0,0,0,0-.41Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43,330a3.48,3.48,0,0,0-1.6,2.76c0,1,.71,1.43,1.6.92a3.53,3.53,0,0,0,1.59-2.76C109,329.91,108.31,329.5,107.43,330Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43,330a3.48,3.48,0,0,0-1.6,2.76c0,1,.71,1.43,1.6.92a3.53,3.53,0,0,0,1.59-2.76C109,329.91,108.31,329.5,107.43,330Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.66,333.91l-.84-.48h0a1.14,1.14,0,0,0-1.12.12,3.54,3.54,0,0,0-1.6,2.76,1.14,1.14,0,0,0,.47,1h0l.78.45.14-.24a1.56,1.56,0,0,0,.46-.18,3.54,3.54,0,0,0,1.6-2.76,1.7,1.7,0,0,0-.05-.41Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.66,333.91l-.84-.48h0a1.14,1.14,0,0,0-1.12.12,3.54,3.54,0,0,0-1.6,2.76,1.14,1.14,0,0,0,.47,1h0l.78.45.14-.24a1.56,1.56,0,0,0,.46-.18,3.54,3.54,0,0,0,1.6-2.76,1.7,1.7,0,0,0-.05-.41Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5,334a3.54,3.54,0,0,0-1.6,2.77c0,1,.72,1.43,1.6.92a3.53,3.53,0,0,0,1.59-2.76C102.09,333.91,101.38,333.49,100.5,334Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5,334a3.54,3.54,0,0,0-1.6,2.77c0,1,.72,1.43,1.6.92a3.53,3.53,0,0,0,1.59-2.76C102.09,333.91,101.38,333.49,100.5,334Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.59,306.05l-.84-.49h0a1.11,1.11,0,0,0-1.12.11,3.52,3.52,0,0,0-1.6,2.77,1.13,1.13,0,0,0,.47,1h0l.78.45.14-.24a1.33,1.33,0,0,0,.46-.18,3.53,3.53,0,0,0,1.6-2.76,1.7,1.7,0,0,0,0-.41Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.59,306.05l-.84-.49h0a1.11,1.11,0,0,0-1.12.11,3.52,3.52,0,0,0-1.6,2.77,1.13,1.13,0,0,0,.47,1h0l.78.45.14-.24a1.33,1.33,0,0,0,.46-.18,3.53,3.53,0,0,0,1.6-2.76,1.7,1.7,0,0,0,0-.41Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43,306.14a3.48,3.48,0,0,0-1.6,2.76c0,1,.71,1.43,1.6.92a3.52,3.52,0,0,0,1.59-2.76C109,306,108.31,305.63,107.43,306.14Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43,306.14a3.48,3.48,0,0,0-1.6,2.76c0,1,.71,1.43,1.6.92a3.52,3.52,0,0,0,1.59-2.76C109,306,108.31,305.63,107.43,306.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.66,310l-.84-.48h0a1.11,1.11,0,0,0-1.12.11,3.54,3.54,0,0,0-1.6,2.76,1.14,1.14,0,0,0,.47,1h0l.78.45.14-.24a1.56,1.56,0,0,0,.46-.18,3.53,3.53,0,0,0,1.6-2.76,1.7,1.7,0,0,0-.05-.41Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.66,310l-.84-.48h0a1.11,1.11,0,0,0-1.12.11,3.54,3.54,0,0,0-1.6,2.76,1.14,1.14,0,0,0,.47,1h0l.78.45.14-.24a1.56,1.56,0,0,0,.46-.18,3.53,3.53,0,0,0,1.6-2.76,1.7,1.7,0,0,0-.05-.41Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5,310.13a3.54,3.54,0,0,0-1.6,2.77c0,1,.72,1.43,1.6.92a3.53,3.53,0,0,0,1.59-2.76C102.09,310,101.38,309.63,100.5,310.13Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5,310.13a3.54,3.54,0,0,0-1.6,2.77c0,1,.72,1.43,1.6.92a3.53,3.53,0,0,0,1.59-2.76C102.09,310,101.38,309.63,100.5,310.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.59,282.18l-.84-.49h0a1.11,1.11,0,0,0-1.12.11,3.52,3.52,0,0,0-1.6,2.77,1.13,1.13,0,0,0,.47,1h0l.78.45.14-.24a1.33,1.33,0,0,0,.46-.18,3.53,3.53,0,0,0,1.6-2.76,1.7,1.7,0,0,0,0-.41Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.59,282.18l-.84-.49h0a1.11,1.11,0,0,0-1.12.11,3.52,3.52,0,0,0-1.6,2.77,1.13,1.13,0,0,0,.47,1h0l.78.45.14-.24a1.33,1.33,0,0,0,.46-.18,3.53,3.53,0,0,0,1.6-2.76,1.7,1.7,0,0,0,0-.41Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43,282.27a3.5,3.5,0,0,0-1.6,2.76c0,1,.71,1.43,1.6.92a3.52,3.52,0,0,0,1.59-2.76C109,282.17,108.31,281.76,107.43,282.27Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43,282.27a3.5,3.5,0,0,0-1.6,2.76c0,1,.71,1.43,1.6.92a3.52,3.52,0,0,0,1.59-2.76C109,282.17,108.31,281.76,107.43,282.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.66,286.17l-.84-.48h0a1.11,1.11,0,0,0-1.12.11,3.54,3.54,0,0,0-1.6,2.76,1.14,1.14,0,0,0,.47,1h0l.78.45.14-.24a1.56,1.56,0,0,0,.46-.18,3.53,3.53,0,0,0,1.6-2.76,1.7,1.7,0,0,0-.05-.41Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.66,286.17l-.84-.48h0a1.11,1.11,0,0,0-1.12.11,3.54,3.54,0,0,0-1.6,2.76,1.14,1.14,0,0,0,.47,1h0l.78.45.14-.24a1.56,1.56,0,0,0,.46-.18,3.53,3.53,0,0,0,1.6-2.76,1.7,1.7,0,0,0-.05-.41Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5,286.27A3.51,3.51,0,0,0,98.9,289c0,1,.72,1.43,1.6.92a3.53,3.53,0,0,0,1.59-2.76C102.09,286.17,101.38,285.76,100.5,286.27Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5,286.27A3.51,3.51,0,0,0,98.9,289c0,1,.72,1.43,1.6.92a3.53,3.53,0,0,0,1.59-2.76C102.09,286.17,101.38,285.76,100.5,286.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.59,258.26l-.84-.48h0a1.14,1.14,0,0,0-1.12.12,3.5,3.5,0,0,0-1.6,2.76,1.11,1.11,0,0,0,.47,1h0l.78.44.14-.23a1.9,1.9,0,0,0,.46-.18,3.54,3.54,0,0,0,1.6-2.76,1.64,1.64,0,0,0,0-.41Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.59,258.26l-.84-.48h0a1.14,1.14,0,0,0-1.12.12,3.5,3.5,0,0,0-1.6,2.76,1.11,1.11,0,0,0,.47,1h0l.78.44.14-.23a1.9,1.9,0,0,0,.46-.18,3.54,3.54,0,0,0,1.6-2.76,1.64,1.64,0,0,0,0-.41Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43,258.35a3.52,3.52,0,0,0-1.6,2.77c0,1,.71,1.43,1.6.92a3.53,3.53,0,0,0,1.59-2.77C109,258.26,108.31,257.84,107.43,258.35Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43,258.35a3.52,3.52,0,0,0-1.6,2.77c0,1,.71,1.43,1.6.92a3.53,3.53,0,0,0,1.59-2.77C109,258.26,108.31,257.84,107.43,258.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.66,262.26l-.84-.49h0a1.11,1.11,0,0,0-1.12.12,3.53,3.53,0,0,0-1.6,2.76,1.11,1.11,0,0,0,.47,1h0l.78.45.14-.23a1.9,1.9,0,0,0,.46-.18,3.54,3.54,0,0,0,1.6-2.77,1.62,1.62,0,0,0-.05-.4Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.66,262.26l-.84-.49h0a1.11,1.11,0,0,0-1.12.12,3.53,3.53,0,0,0-1.6,2.76,1.11,1.11,0,0,0,.47,1h0l.78.45.14-.23a1.9,1.9,0,0,0,.46-.18,3.54,3.54,0,0,0,1.6-2.77,1.62,1.62,0,0,0-.05-.4Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5,262.35a3.54,3.54,0,0,0-1.6,2.77c0,1,.72,1.43,1.6.92a3.53,3.53,0,0,0,1.59-2.77C102.09,262.26,101.38,261.84,100.5,262.35Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5,262.35a3.54,3.54,0,0,0-1.6,2.77c0,1,.72,1.43,1.6.92a3.53,3.53,0,0,0,1.59-2.77C102.09,262.26,101.38,261.84,100.5,262.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.59,234.4l-.84-.49h0a1.11,1.11,0,0,0-1.12.12,3.48,3.48,0,0,0-1.6,2.76,1.12,1.12,0,0,0,.47,1h0l.78.45.14-.23a1.9,1.9,0,0,0,.46-.18,3.54,3.54,0,0,0,1.6-2.77,1.62,1.62,0,0,0,0-.4Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.59,234.4l-.84-.49h0a1.11,1.11,0,0,0-1.12.12,3.48,3.48,0,0,0-1.6,2.76,1.12,1.12,0,0,0,.47,1h0l.78.45.14-.23a1.9,1.9,0,0,0,.46-.18,3.54,3.54,0,0,0,1.6-2.77,1.62,1.62,0,0,0,0-.4Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43,234.49a3.52,3.52,0,0,0-1.6,2.77c0,1,.71,1.43,1.6.92a3.53,3.53,0,0,0,1.59-2.77C109,234.39,108.31,234,107.43,234.49Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43,234.49a3.52,3.52,0,0,0-1.6,2.77c0,1,.71,1.43,1.6.92a3.53,3.53,0,0,0,1.59-2.77C109,234.39,108.31,234,107.43,234.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.66,238.4l-.84-.49h0a1.13,1.13,0,0,0-1.12.11,3.54,3.54,0,0,0-1.6,2.77,1.12,1.12,0,0,0,.47,1h0l.78.45.14-.24a1.52,1.52,0,0,0,.46-.17,3.54,3.54,0,0,0,1.6-2.77,1.77,1.77,0,0,0-.05-.41Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.66,238.4l-.84-.49h0a1.13,1.13,0,0,0-1.12.11,3.54,3.54,0,0,0-1.6,2.77,1.12,1.12,0,0,0,.47,1h0l.78.45.14-.24a1.52,1.52,0,0,0,.46-.17,3.54,3.54,0,0,0,1.6-2.77,1.77,1.77,0,0,0-.05-.41Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5,238.49a3.54,3.54,0,0,0-1.6,2.76c0,1,.72,1.43,1.6.93a3.53,3.53,0,0,0,1.59-2.77C102.09,238.39,101.38,238,100.5,238.49Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5,238.49a3.54,3.54,0,0,0-1.6,2.76c0,1,.72,1.43,1.6.93a3.53,3.53,0,0,0,1.59-2.77C102.09,238.39,101.38,238,100.5,238.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.75,289.34l31.41,18.12a2.28,2.28,0,0,1,1,1.77v8.67c0,.65-.46.91-1,.59L55.75,300.37a2.26,2.26,0,0,1-1-1.76v-8.68C54.73,289.28,55.19,289,55.75,289.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.64,293.17a2.21,2.21,0,0,0,1,1.69l27.59,15.91c.56.32,1,.09,1-.52a2.18,2.18,0,0,0-1-1.68L57.66,292.65C57.1,292.33,56.64,292.56,56.64,293.17Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.64,297.58a2.21,2.21,0,0,0,1,1.69l27.59,15.91c.56.32,1,.09,1-.52a2.21,2.21,0,0,0-1-1.69L57.66,297.06C57.1,296.74,56.64,297,56.64,297.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.66,297.06l15.24,8.79v2.2l-15.24-8.78a2.21,2.21,0,0,1-1-1.69C56.64,297,57.1,296.74,57.66,297.06Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.75,313.27l31.41,18.11a2.28,2.28,0,0,1,1,1.77v8.67c0,.65-.46.91-1,.59L55.75,324.29a2.25,2.25,0,0,1-1-1.76v-8.68C54.73,313.2,55.19,312.94,55.75,313.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.64,317.09a2.2,2.2,0,0,0,1,1.69l27.59,15.91c.56.33,1,.1,1-.51a2.18,2.18,0,0,0-1-1.69L57.66,316.57C57.1,316.25,56.64,316.48,56.64,317.09Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.64,321.5a2.2,2.2,0,0,0,1,1.69L85.25,339.1c.56.33,1,.09,1-.51a2.18,2.18,0,0,0-1-1.69L57.66,321C57.1,320.66,56.64,320.89,56.64,321.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.66,321l19.06,11v2.21l-19.06-11a2.2,2.2,0,0,1-1-1.69C56.64,320.89,57.1,320.66,57.66,321Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.75,337l31.41,18.12a2.28,2.28,0,0,1,1,1.76v8.68c0,.65-.46.91-1,.59L55.75,348a2.27,2.27,0,0,1-1-1.77V337.6C54.73,337,55.19,336.69,55.75,337Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.64,340.84a2.21,2.21,0,0,0,1,1.69l27.59,15.91c.56.32,1,.09,1-.52a2.21,2.21,0,0,0-1-1.69L57.66,340.32C57.1,340,56.64,340.23,56.64,340.84Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.64,345.25a2.21,2.21,0,0,0,1,1.69l27.59,15.91c.56.32,1,.09,1-.52a2.21,2.21,0,0,0-1-1.69L57.66,344.73C57.1,344.41,56.64,344.64,56.64,345.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.66,344.73l22.88,13.19v2.21L57.66,346.94a2.21,2.21,0,0,1-1-1.69C56.64,344.64,57.1,344.41,57.66,344.73Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.75,265.65l31.41,18.12a2.28,2.28,0,0,1,1,1.76v8.68c0,.65-.46.91-1,.59L55.75,276.68a2.27,2.27,0,0,1-1-1.77v-8.67C54.73,265.59,55.19,265.33,55.75,265.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.64,269.48a2.21,2.21,0,0,0,1,1.69l27.59,15.91c.56.32,1,.09,1-.52a2.21,2.21,0,0,0-1-1.69L57.66,269C57.1,268.64,56.64,268.87,56.64,269.48Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.64,273.88a2.18,2.18,0,0,0,1,1.69l27.59,15.92c.56.32,1,.09,1-.52a2.2,2.2,0,0,0-1-1.69L57.66,273.37C57.1,273.05,56.64,273.28,56.64,273.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.66,273.37l24.79,14.3v2.2l-24.79-14.3a2.18,2.18,0,0,1-1-1.69C56.64,273.28,57.1,273.05,57.66,273.37Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.75,217.86,87.16,236a2.24,2.24,0,0,1,1,1.76v8.68c0,.64-.46.91-1,.58L55.75,228.88a2.23,2.23,0,0,1-1-1.76v-8.67C54.73,217.8,55.19,217.54,55.75,217.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.64,221.68a2.18,2.18,0,0,0,1,1.69l27.59,15.92c.56.32,1,.09,1-.52a2.2,2.2,0,0,0-1-1.69L57.66,221.17C57.1,220.84,56.64,221.07,56.64,221.68Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.64,226.09a2.18,2.18,0,0,0,1,1.69L85.25,243.7c.56.32,1,.09,1-.52a2.2,2.2,0,0,0-1-1.69L57.66,225.58C57.1,225.25,56.64,225.48,56.64,226.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.66,225.58l19.06,11v2.2l-19.06-11a2.18,2.18,0,0,1-1-1.69C56.64,225.48,57.1,225.25,57.66,225.58Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.75,241.74l31.41,18.12a2.24,2.24,0,0,1,1,1.76v8.67c0,.65-.46.92-1,.59L55.75,252.76a2.23,2.23,0,0,1-1-1.76v-8.67C54.73,241.68,55.19,241.42,55.75,241.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.64,245.56a2.18,2.18,0,0,0,1,1.69l27.59,15.92c.56.32,1,.09,1-.52a2.2,2.2,0,0,0-1-1.69L57.66,245.05C57.1,244.72,56.64,245,56.64,245.56Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.64,250a2.18,2.18,0,0,0,1,1.69l27.59,15.91c.56.33,1,.1,1-.51a2.18,2.18,0,0,0-1-1.69L57.66,249.46C57.1,249.13,56.64,249.36,56.64,250Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.66,249.46l24.79,14.29V266l-24.79-14.3a2.18,2.18,0,0,1-1-1.69C56.64,249.36,57.1,249.13,57.66,249.46Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1,226.27,131,205a2.09,2.09,0,0,0,1-1.65v-1.24a2.13,2.13,0,0,0-1-1.66L94.1,179.1a2.14,2.14,0,0,0-1.91,0L55.28,200.41a2.12,2.12,0,0,0-1,1.66v1.24a2.08,2.08,0,0,0,1,1.65l36.91,21.31A2.14,2.14,0,0,0,94.1,226.27Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1,226.27,131,205a2.09,2.09,0,0,0,1-1.65v-1.24a2.13,2.13,0,0,0-1-1.66L94.1,179.1a2.14,2.14,0,0,0-1.91,0L55.28,200.41a2.12,2.12,0,0,0-1,1.66v1.24a2.08,2.08,0,0,0,1,1.65l36.91,21.31A2.14,2.14,0,0,0,94.1,226.27Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,201.51,94.1,222.82a2.08,2.08,0,0,1-1.91,0L55.28,201.51c-.53-.3-.53-.79,0-1.1L92.19,179.1a2.14,2.14,0,0,1,1.91,0L131,200.41C131.53,200.72,131.53,201.21,131,201.51Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.14,223.05v3.45a2,2,0,0,0,1-.23L131,205a2.09,2.09,0,0,0,1-1.65v-1.25a2.14,2.14,0,0,0-.78-1.53c.34.31.29.72-.18,1L94.1,222.82A1.9,1.9,0,0,1,93.14,223.05Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.14,223.05v3.45a2,2,0,0,0,1-.23L131,205a2.09,2.09,0,0,0,1-1.65v-1.25a2.14,2.14,0,0,0-.78-1.53c.34.31.29.72-.18,1L94.1,222.82A1.9,1.9,0,0,1,93.14,223.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1,215.93l25-14.42a2.08,2.08,0,0,0,1-1.65v-1.24a2.12,2.12,0,0,0-1-1.66l-16-9.24a6.44,6.44,0,0,1-1.61-1.43L93.8,176a1.26,1.26,0,0,0-1.61-.33l-25,14.41a2.11,2.11,0,0,0-1,1.65v8.14a2.09,2.09,0,0,0,1,1.65l25,14.42A2.14,2.14,0,0,0,94.1,215.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.19,212.48l-16-9.24a5.75,5.75,0,0,1-.83-.62,5.33,5.33,0,0,1-.78-.82l-7.64-10.29a1,1,0,0,1,.29-1.44l25-14.41a1.26,1.26,0,0,1,1.61.33l7.64,10.3a6,6,0,0,0,1.48,1.49L119.06,197a.59.59,0,0,1,0,1.11l-25,14.41A2.14,2.14,0,0,1,92.19,212.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.22,190.07l25-14.41a1.26,1.26,0,0,1,1.61.33l7.64,10.3a6.44,6.44,0,0,0,.78.81L75.35,202.62a5.33,5.33,0,0,1-.78-.82l-7.64-10.29A1,1,0,0,1,67.22,190.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,197.22a2.46,2.46,0,0,0-2.24,0c-.62.35-.62.93,0,1.29a2.46,2.46,0,0,0,2.24,0C113.62,198.15,113.62,197.57,113,197.22Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.4,
    cy: 200.45,
    rx: 1.58,
    ry: 0.91,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.93,
    cy: 203.03,
    rx: 1.58,
    ry: 0.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.57,205a2.52,2.52,0,0,0-2.24,0,.69.69,0,0,0,0,1.3,2.52,2.52,0,0,0,2.24,0A.69.69,0,0,0,99.57,205Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.52,
    cy: 195.92,
    rx: 1.58,
    ry: 0.91,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.17,197.86a2.52,2.52,0,0,0-2.24,0,.69.69,0,0,0,0,1.3,2.52,2.52,0,0,0,2.24,0A.69.69,0,0,0,105.17,197.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.57,
    cy: 201.1,
    rx: 1.58,
    ry: 0.91,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.21,203A2.52,2.52,0,0,0,94,203a.69.69,0,0,0,0,1.3,2.52,2.52,0,0,0,2.24,0A.69.69,0,0,0,96.21,203Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.28,193.34a2.44,2.44,0,0,0-2.23,0,.68.68,0,0,0,0,1.29,2.44,2.44,0,0,0,2.23,0A.68.68,0,0,0,106.28,193.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,195.92a2.52,2.52,0,0,0-2.24,0,.69.69,0,0,0,0,1.3,2.52,2.52,0,0,0,2.24,0A.69.69,0,0,0,101.81,195.92Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.33,198.51a2.46,2.46,0,0,0-2.24,0c-.62.36-.62.94,0,1.29a2.46,2.46,0,0,0,2.24,0C98,199.45,98,198.87,97.33,198.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.06,207.51a2.46,2.46,0,0,0-2.24,0,.68.68,0,0,0,0,1.29,2.46,2.46,0,0,0,2.24,0A.68.68,0,0,0,95.06,207.51Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7,205.57a2.44,2.44,0,0,0-2.23,0,.68.68,0,0,0,0,1.29,2.44,2.44,0,0,0,2.23,0A.68.68,0,0,0,91.7,205.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.85,201.1a2.46,2.46,0,0,0-2.24,0c-.62.35-.62.93,0,1.29a2.46,2.46,0,0,0,2.24,0C93.47,202,93.47,201.45,92.85,201.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.93,191.4a2.46,2.46,0,0,0-2.24,0c-.62.36-.62.94,0,1.29a2.46,2.46,0,0,0,2.24,0A.68.68,0,0,0,102.93,191.4Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.45,194a2.46,2.46,0,0,0-2.24,0c-.62.35-.62.93,0,1.29a2.46,2.46,0,0,0,2.24,0C99.07,194.92,99.07,194.34,98.45,194Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,196.57a2.52,2.52,0,0,0-2.24,0,.69.69,0,0,0,0,1.3,2.52,2.52,0,0,0,2.24,0A.69.69,0,0,0,94,196.57Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.49,199.16a2.46,2.46,0,0,0-2.24,0,.68.68,0,0,0,0,1.29,2.46,2.46,0,0,0,2.24,0A.68.68,0,0,0,89.49,199.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.35,203.63a2.46,2.46,0,0,0-2.24,0c-.62.36-.62.94,0,1.29a2.46,2.46,0,0,0,2.24,0A.68.68,0,0,0,88.35,203.63Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,201.69a2.52,2.52,0,0,0-2.24,0,.69.69,0,0,0,0,1.3A2.52,2.52,0,0,0,85,203,.69.69,0,0,0,85,201.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.09,212.71v3.44a2.08,2.08,0,0,0,1-.22l25-14.42a2.08,2.08,0,0,0,1-1.65v-1.24a2.11,2.11,0,0,0-.78-1.53c.35.3.29.71-.17,1l-25,14.42A2.09,2.09,0,0,1,93.09,212.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.14,185.86l0,0a.84.84,0,0,0-1.07-.23L75.32,198.15a.63.63,0,0,0-.19.95l0,0a.83.83,0,0,0,1.07.22l21.72-12.53A.65.65,0,0,0,98.14,185.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.14,185.86l0,0a.84.84,0,0,0-1.07-.23L80.9,194.93l.9,1.21,16.14-9.32A.65.65,0,0,0,98.14,185.86Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.35,183.45l0,0a.84.84,0,0,0-1.07-.23L73.53,195.74a.63.63,0,0,0-.2.95l0,0a.84.84,0,0,0,1.08.22l21.72-12.53A.65.65,0,0,0,96.35,183.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.35,183.45l0,0a.84.84,0,0,0-1.07-.23l-5.4,3.12.9,1.21,5.4-3.11A.65.65,0,0,0,96.35,183.45Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.55,181l0,0a.85.85,0,0,0-1.08-.23L71.73,193.33a.63.63,0,0,0-.2.95l0,0a.83.83,0,0,0,1.07.22L94.35,182A.65.65,0,0,0,94.55,181Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.55,181l0,0a.85.85,0,0,0-1.08-.23l-11.31,6.51.9,1.21L94.35,182A.63.63,0,0,0,94.55,181Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.75,178.63l0,0a.84.84,0,0,0-1.07-.23L69.94,190.92a.63.63,0,0,0-.2,1l0,0a.84.84,0,0,0,1.08.22l21.71-12.53A.64.64,0,0,0,92.75,178.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.75,178.63l0,0a.84.84,0,0,0-1.07-.23L71.94,189.76l.9,1.21,19.71-11.38A.64.64,0,0,0,92.75,178.63Z",
    style: {
      fill: "#90CAF9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cable--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.69,384.77l-11-6.32a4.07,4.07,0,0,0-3.75,0L92.16,413a3.39,3.39,0,0,1-3,0L16.73,371.16c-.32-.19-.5-.42-.5-.64s.18-.45.5-.63l33.08-19.1,0,0s0,0,.06,0a.2.2,0,0,0,0-.14.61.61,0,0,0-.28-.48.2.2,0,0,0-.18,0,.09.09,0,0,0-.06,0l-33.09,19.1a1.41,1.41,0,0,0,0,2.62l72.45,41.83a3.92,3.92,0,0,0,1.89.46,3.84,3.84,0,0,0,1.87-.46l59.82-34.53a3.33,3.33,0,0,1,3,0l11,6.32a.39.39,0,0,0,.39-.68Zm6.32-3.64-17.28-10a4.07,4.07,0,0,0-3.75,0L92.16,405.69a3.39,3.39,0,0,1-3,0L29.37,371.16c-.32-.19-.5-.42-.5-.64s.18-.45.5-.63l26.86-15.45h0s.08-.08.08-.17a.6.6,0,0,0-.28-.48.17.17,0,0,0-.16,0,.12.12,0,0,0-.07.05L29,369.21a1.57,1.57,0,0,0-.89,1.31,1.54,1.54,0,0,0,.89,1.31l59.81,34.53a3.81,3.81,0,0,0,1.89.46,3.73,3.73,0,0,0,1.87-.46l59.82-34.53a3.39,3.39,0,0,1,3,0l17.27,10a.38.38,0,0,0,.53-.15A.38.38,0,0,0,173,381.13Zm12.64-7.3-29.92-17.27a4.13,4.13,0,0,0-3.75,0L92.16,391.1a3.39,3.39,0,0,1-3,0L54.64,371.16c-.32-.19-.5-.42-.5-.64s.18-.45.5-.63l14.12-8.15,0,0,.06,0a.22.22,0,0,0,0-.15.58.58,0,0,0-.28-.47.19.19,0,0,0-.17,0l-14.2,8.19a1.41,1.41,0,0,0,0,2.62l34.54,19.94a3.8,3.8,0,0,0,1.89.45,3.72,3.72,0,0,0,1.87-.45l59.82-34.54a3.39,3.39,0,0,1,3,0l29.91,17.28a.38.38,0,0,0,.53-.15A.39.39,0,0,0,185.65,373.83Zm-6.32,3.65-23.6-13.62a4.07,4.07,0,0,0-3.75,0L92.16,398.39a3.33,3.33,0,0,1-3,0L42,371.16c-.31-.19-.5-.42-.5-.64s.19-.45.5-.63l20.5-11.83h0a.22.22,0,0,0,.07-.18.57.57,0,0,0-.27-.47.23.23,0,0,0-.19,0h0l-20.5,11.84a1.4,1.4,0,0,0,0,2.62l47.17,27.24a3.92,3.92,0,0,0,1.89.46,3.84,3.84,0,0,0,1.87-.46l59.82-34.54a3.39,3.39,0,0,1,3,0l23.59,13.62a.39.39,0,0,0,.53-.14A.38.38,0,0,0,179.33,377.48Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.69,384.77l-11-6.32a4.07,4.07,0,0,0-3.75,0L92.16,413a3.39,3.39,0,0,1-3,0L16.73,371.16c-.32-.19-.5-.42-.5-.64s.18-.45.5-.63l33.08-19.1,0,0s0,0,.06,0a.2.2,0,0,0,0-.14.61.61,0,0,0-.28-.48.2.2,0,0,0-.18,0,.09.09,0,0,0-.06,0l-33.09,19.1a1.41,1.41,0,0,0,0,2.62l72.45,41.83a3.92,3.92,0,0,0,1.89.46,3.84,3.84,0,0,0,1.87-.46l59.82-34.53a3.33,3.33,0,0,1,3,0l11,6.32a.39.39,0,0,0,.39-.68Zm6.32-3.64-17.28-10a4.07,4.07,0,0,0-3.75,0L92.16,405.69a3.39,3.39,0,0,1-3,0L29.37,371.16c-.32-.19-.5-.42-.5-.64s.18-.45.5-.63l26.86-15.45h0s.08-.08.08-.17a.6.6,0,0,0-.28-.48.17.17,0,0,0-.16,0,.12.12,0,0,0-.07.05L29,369.21a1.57,1.57,0,0,0-.89,1.31,1.54,1.54,0,0,0,.89,1.31l59.81,34.53a3.81,3.81,0,0,0,1.89.46,3.73,3.73,0,0,0,1.87-.46l59.82-34.53a3.39,3.39,0,0,1,3,0l17.27,10a.38.38,0,0,0,.53-.15A.38.38,0,0,0,173,381.13Zm6.32-3.65-23.6-13.62a4.07,4.07,0,0,0-3.75,0L92.16,398.39a3.33,3.33,0,0,1-3,0L42,371.16c-.31-.19-.5-.42-.5-.64s.19-.45.5-.63l20.5-11.83h0a.22.22,0,0,0,.07-.18.57.57,0,0,0-.27-.47.23.23,0,0,0-.19,0h0l-20.5,11.84a1.4,1.4,0,0,0,0,2.62l47.17,27.24a3.92,3.92,0,0,0,1.89.46,3.84,3.84,0,0,0,1.87-.46l59.82-34.54a3.39,3.39,0,0,1,3,0l23.59,13.62a.39.39,0,0,0,.53-.14A.38.38,0,0,0,179.33,377.48Zm6.32-3.65-29.92-17.27a4.13,4.13,0,0,0-3.75,0L92.16,391.1a3.39,3.39,0,0,1-3,0L54.64,371.16c-.32-.19-.5-.42-.5-.64s.18-.45.5-.63l14.12-8.15,0,0,.06,0a.22.22,0,0,0,0-.15.58.58,0,0,0-.28-.47.19.19,0,0,0-.17,0l-14.2,8.19a1.41,1.41,0,0,0,0,2.62l34.54,19.94a3.8,3.8,0,0,0,1.89.45,3.72,3.72,0,0,0,1.87-.45l59.82-34.54a3.39,3.39,0,0,1,3,0l29.91,17.28a.38.38,0,0,0,.53-.15A.39.39,0,0,0,185.65,373.83Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Line--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.33,130.34a.45.45,0,0,0-.46.46v42.92a.45.45,0,0,0,.46.46.46.46,0,0,0,.47-.46V130.8A.46.46,0,0,0,70.33,130.34Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.33,130.34a.45.45,0,0,0-.46.46v42.92a.45.45,0,0,0,.46.46.46.46,0,0,0,.47-.46V130.8A.46.46,0,0,0,70.33,130.34Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3,133.53a4.51,4.51,0,0,1,2-3.52c1.12-.64,2-.12,2,1.18a4.47,4.47,0,0,1-2,3.51C69.21,135.35,68.3,134.83,68.3,133.53Z",
    style: {
      fill: "#90CAF9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.79,105.07l-1.36-.79A3.2,3.2,0,0,1,93,102.2L87.11,57.69a1.74,1.74,0,0,0-2.79-1.37L54,73.8a2.79,2.79,0,0,1-3.81-1l-1-1.71a2.8,2.8,0,0,0-3.82-1L31.35,78.17a4.52,4.52,0,0,0-2.05,4.16l7,52.62A3.23,3.23,0,0,0,37.7,137l1.37.78a.82.82,0,0,0,.85.09l56.73-32.75A.85.85,0,0,1,95.79,105.07Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.79,105.07l-1.36-.79A3.2,3.2,0,0,1,93,102.2L87.11,57.69a1.74,1.74,0,0,0-2.79-1.37L54,73.8a2.79,2.79,0,0,1-3.81-1l-1-1.71a2.8,2.8,0,0,0-3.82-1L31.35,78.17a4.52,4.52,0,0,0-2.05,4.16l7,52.62A3.23,3.23,0,0,0,37.7,137l1.37.78a.82.82,0,0,0,.85.09l56.73-32.75A.85.85,0,0,1,95.79,105.07Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7,137l1.37.78a.82.82,0,0,0,.85.09l56.73-32.75a.85.85,0,0,1-.86-.08l-1.36-.79a2.86,2.86,0,0,1-.89-.88L36.81,136.15A3,3,0,0,0,37.7,137Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,132.28V88a3.58,3.58,0,0,1,1.61-2.8l49.72-28.7c.89-.52,1.61-.1,1.61.93v44.31a3.55,3.55,0,0,1-1.61,2.79L39.65,133.22C38.76,133.73,38,133.31,38,132.28Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.92,137.9a.86.86,0,0,0,.36-.78V93.27a5.35,5.35,0,0,1,2.42-4.19L94.58,59.13C95.92,58.36,97,59,97,60.52v43.85a.85.85,0,0,1-.35.78Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.92,137.9a.86.86,0,0,0,.36-.78V93.27a5.35,5.35,0,0,1,2.42-4.19L94.58,59.13C95.92,58.36,97,59,97,60.52v43.85a.85.85,0,0,1-.35.78Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.82,408c0,2.75,2.06,4.5,4.59,6l103.8,59.93a10.15,10.15,0,0,0,9.17,0l167.45-96.68c2.54-1.47,4.59-3.35,4.59-6.09s-2.05-4.44-4.59-5.9L324,305.26a10.09,10.09,0,0,0-9.17,0L147.41,401.94C144.87,403.4,142.82,405.22,142.82,408Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.41,407.23l103.8,59.93a10.15,10.15,0,0,0,9.17,0l167.45-96.68c2.54-1.46,2.54-3.83,0-5.29L324,305.26a10.09,10.09,0,0,0-9.17,0L147.41,401.94C144.87,403.4,144.87,405.77,147.41,407.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.8,468.27V475a9.38,9.38,0,0,1-4.59-1.09l-103.8-59.93c-2.53-1.46-4.59-3.22-4.59-6,0-2.57,1.85-4.36,4.23-5.82-2,1.39-2,3.73.36,5.09l103.8,59.93A9.28,9.28,0,0,0,255.8,468.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.83,402.64c-2-.92-2.56-2.52-2.75-5.33l-9-131.65a9.12,9.12,0,0,1,4.24-7.74l167.46-96.68c2.53-1.46,4.38-2.26,6.72-.66s2.39,2.48,2.58,5.3l9,131.64a9.12,9.12,0,0,1-4.24,7.75L147.39,402C144.86,403.41,143.42,403.84,140.83,402.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.09,165.87c-.2-2.8-2.41-3.9-4.94-2.44L137.69,260.11a8.65,8.65,0,0,0-3.13,3.37l-4.37-2.2h0a8.89,8.89,0,0,1,3.14-3.37l167.45-96.67c2.54-1.47,4.4-2.27,6.73-.66S309.89,163.07,310.09,165.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.05,402.14c-2.31,1.36-3.77,1.53-6.22.5-1.87-.79-2.55-2.52-2.75-5.33l-9-131.65a8,8,0,0,1,1.1-4.37l4.37,2.18h0a8.15,8.15,0,0,0-1.1,4.37l9,131.65C142.63,402.11,144.89,403.42,147.05,402.14Z",
    style: {
      fill: "#263238"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.6,265.14l161.15-93c1.52-.88,2.85-.22,3,1.47l8.4,122.81a5.51,5.51,0,0,1-2.54,4.65l-161.15,93c-1.52.88-2.85.22-3-1.47l-8.4-122.81A5.46,5.46,0,0,1,140.6,265.14Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.6,265.14a5.46,5.46,0,0,0-2.54,4.65l8.26,120.77,159.3-91.95a5.5,5.5,0,0,0,2.55-4.65l-8.26-120.77Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.6,265.14a5.46,5.46,0,0,0-2.54,4.65l8.26,120.77,159.3-91.95a5.5,5.5,0,0,0,2.55-4.65l-8.26-120.77Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.57,402.71l153.89-88.84a4.77,4.77,0,0,1,4.32,0l5.6,3.14a1.32,1.32,0,0,1,0,2.5l-153.9,88.83a4.79,4.79,0,0,1-4.33,0l-5.58-3.13A1.32,1.32,0,0,1,161.57,402.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.68,411.63l153.89-88.85a4.4,4.4,0,0,1,3.95-.21l40.05,23.12c1,.57.82,1.6-.37,2.28L220.49,436.7a4.41,4.41,0,0,1-4,.22l-40.23-23C175.32,413.34,175.49,412.32,176.68,411.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,360.1l4.82-2.78c.21-.12.23-.3,0-.41l-4.61-2.66a.79.79,0,0,0-.7,0l-4.81,2.78c-.21.12-.23.3,0,.4l4.6,2.66A.75.75,0,0,0,310,360.1Zm-7-9.63-4.82,2.79c-.2.11-.22.3,0,.4l4.61,2.66a.76.76,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.41l-4.61-2.66A.82.82,0,0,0,303,350.47Zm-15.57,9-8.15,4.71c-.2.12-.22.3,0,.4l4.61,2.66a.76.76,0,0,0,.7,0l8.15-4.71c.21-.12.22-.3,0-.4l-4.61-2.66A.76.76,0,0,0,287.42,359.46Zm8.53-4.92-4.82,2.78c-.2.12-.22.3,0,.41l4.61,2.66a.79.79,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.4l-4.61-2.66A.76.76,0,0,0,296,354.54Zm-18.9,10.91-4.82,2.78c-.21.12-.22.3,0,.41l4.61,2.66a.82.82,0,0,0,.7,0l4.81-2.79c.21-.11.23-.29.05-.4l-4.61-2.66A.75.75,0,0,0,277.05,365.45ZM270,369.52l-4.81,2.78c-.21.12-.23.3-.05.4l4.61,2.67a.79.79,0,0,0,.7,0l4.82-2.78c.21-.12.23-.3,0-.4l-4.61-2.67A.79.79,0,0,0,270,369.52Zm18.07,10.86,4.82-2.78c.2-.12.22-.3,0-.41l-4.61-2.66a.82.82,0,0,0-.7,0l-4.82,2.79c-.2.11-.22.29,0,.4l4.61,2.66A.76.76,0,0,0,288.07,380.38Zm-7,4.06,4.82-2.78c.2-.12.22-.3,0-.4l-4.61-2.66a.76.76,0,0,0-.7,0l-4.82,2.78c-.2.12-.22.3,0,.41l4.61,2.66A.79.79,0,0,0,281,384.44Zm-7,4.07,4.82-2.78c.2-.12.22-.3,0-.41l-4.61-2.66a.79.79,0,0,0-.7,0l-4.82,2.78c-.2.12-.22.3,0,.4l4.61,2.66A.76.76,0,0,0,274,388.51Zm-7,4.06,4.81-2.78c.21-.12.23-.3.05-.4l-4.61-2.66a.75.75,0,0,0-.7,0l-4.82,2.78c-.21.12-.23.3,0,.41l4.61,2.66A.79.79,0,0,0,267,392.57Zm36-28.41,4.82-2.78c.21-.11.22-.3,0-.4l-4.61-2.66a.76.76,0,0,0-.7,0l-4.81,2.78c-.21.12-.23.3-.05.41l4.61,2.66A.79.79,0,0,0,303,364.16Zm-7.87,12.15,10.75-6.2c.21-.12.22-.3,0-.41l-11.19-6.46a.79.79,0,0,0-.7,0l-5.56,3.21c-.21.12-.22.3,0,.41l5.92,3.42c.19.1.17.28,0,.4l-4.44,2.57c-.21.12-.23.3-.05.4l4.61,2.67A.79.79,0,0,0,295.11,376.31ZM263,373.58l-4.82,2.79c-.2.11-.22.29,0,.4l4.61,2.66a.76.76,0,0,0,.7,0l4.82-2.78c.21-.12.22-.3,0-.41l-4.61-2.66A.79.79,0,0,0,263,373.58Zm-7,4.07-4.82,2.78c-.2.12-.22.3,0,.41l4.61,2.66a.79.79,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.4l-4.61-2.66A.76.76,0,0,0,255.92,377.65Zm-39,43.41a.79.79,0,0,0,.7,0l4.82-2.78c.21-.12.22-.3,0-.4l-4.61-2.66a.76.76,0,0,0-.7,0L212.39,418c-.21.12-.23.3,0,.41Zm-17.36-10.89L194.77,413c-.21.11-.23.3,0,.4l4.61,2.66a.76.76,0,0,0,.7,0l4.81-2.78c.21-.12.23-.3.05-.41l-4.61-2.66A.82.82,0,0,0,199.59,410.17Zm8.93,8.16a.79.79,0,0,0,.7,0l4.81-2.78c.21-.12.23-.3,0-.4l-4.6-2.67a.79.79,0,0,0-.7,0L204,415.26c-.21.12-.23.3,0,.4Zm19.42,4.37,4.82-2.79c.21-.11.23-.3,0-.4l-4.61-2.66a.76.76,0,0,0-.7,0l-4.81,2.78c-.21.12-.23.3,0,.41l4.6,2.66A.82.82,0,0,0,227.94,422.7Zm-7.74,4.08a.76.76,0,0,0,.7,0l4.82-2.78c.21-.12.22-.3,0-.4l-4.61-2.67a.79.79,0,0,0-.7,0l-4.82,2.78c-.2.12-.22.3,0,.4Zm-13.57-20.67-4.82,2.78c-.21.12-.22.3,0,.4l4.61,2.67a.79.79,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.4l-4.61-2.67A.79.79,0,0,0,206.63,406.11Zm35.21-20.33L237,388.56c-.21.12-.22.3,0,.41l4.61,2.66a.79.79,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.4l-4.61-2.66A.75.75,0,0,0,241.84,385.78ZM213.67,402l-4.82,2.78c-.2.12-.22.3,0,.41l4.61,2.66a.79.79,0,0,0,.7,0l4.82-2.79c.2-.11.22-.29,0-.4L214.37,402A.76.76,0,0,0,213.67,402Zm35.21-20.33-4.82,2.79c-.2.11-.22.3,0,.4l4.61,2.66a.76.76,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.41l-4.61-2.66A.82.82,0,0,0,248.88,381.71Zm-14.08,8.14L230,392.63c-.21.12-.23.3,0,.4l4.61,2.66a.76.76,0,0,0,.7,0l4.81-2.78c.21-.12.23-.3,0-.41l-4.61-2.66A.77.77,0,0,0,234.8,389.85Zm-7.05,4.06-4.81,2.78c-.21.12-.23.3-.05.41l4.61,2.66a.79.79,0,0,0,.7,0L233,397c.21-.11.22-.3,0-.4l-4.61-2.66A.76.76,0,0,0,227.75,393.91Zm-7,4.07-4.82,2.78c-.2.12-.22.3,0,.4l4.61,2.66a.76.76,0,0,0,.7,0L226,401c.2-.12.22-.3,0-.41L221.41,398A.79.79,0,0,0,220.71,398Zm32.15,2.73,4.82-2.79c.21-.11.22-.3,0-.4l-4.61-2.66a.76.76,0,0,0-.7,0l-4.82,2.78c-.2.12-.22.3,0,.41l4.61,2.66A.82.82,0,0,0,252.86,400.71Zm65.7-59.22-4.82,2.78c-.21.12-.23.3,0,.4l4.61,2.66a.76.76,0,0,0,.7,0l4.81-2.78c.21-.12.23-.3.05-.41l-4.61-2.66A.79.79,0,0,0,318.56,341.49ZM310,346.41l-4.82,2.78c-.2.12-.22.3,0,.4l4.61,2.67a.79.79,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.4l-4.61-2.67A.79.79,0,0,0,310,346.41Zm15.57-9-4.82,2.78c-.2.12-.22.3,0,.41l4.61,2.66a.79.79,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.4l-4.61-2.66A.76.76,0,0,0,325.6,337.42Zm-38.92,36.16,4.81-2.78c.21-.12.23-.3,0-.41l-4.6-2.66a.79.79,0,0,0-.7,0l-4.82,2.78c-.21.12-.23.3,0,.4L286,373.6A.76.76,0,0,0,286.68,373.58Zm46.66-40.25a.79.79,0,0,0-.7,0l-4.82,2.78c-.2.12-.22.3,0,.4l4.61,2.66a.76.76,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.41ZM259.9,396.64l4.82-2.78c.21-.12.23-.3,0-.41l-4.61-2.66a.79.79,0,0,0-.7,0l-4.81,2.78c-.21.12-.23.3,0,.4l4.6,2.66A.75.75,0,0,0,259.9,396.64Zm86.36-49.86,4.82-2.78c.2-.12.22-.3,0-.4l-4.61-2.66a.76.76,0,0,0-.7,0L341,343.74c-.2.12-.22.3,0,.41l4.61,2.66A.79.79,0,0,0,346.26,346.78Zm-13.63.27,4.82-2.79c.21-.11.22-.29,0-.4l-4.61-2.66a.79.79,0,0,0-.7,0L327.36,344c-.2.12-.22.3,0,.41l4.61,2.66A.79.79,0,0,0,332.63,347.05Zm7.29-9.92a.79.79,0,0,0-.7,0l-4.81,2.78c-.21.12-.23.3,0,.4L339,343a.75.75,0,0,0,.7,0l4.82-2.78c.21-.12.23-.3,0-.4Zm1.49-.85,11.19,6.46a.76.76,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.41L347,333.07a.75.75,0,0,0-.7,0l-4.82,2.78C341.24,336,341.23,336.17,341.41,336.28Zm-16.27,9-4.82,2.78c-.2.12-.22.3,0,.4l4.61,2.67a.79.79,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.4l-4.61-2.67A.79.79,0,0,0,325.14,345.29Zm-53,30.6-4.82,2.78c-.2.12-.22.3,0,.4l4.61,2.66a.76.76,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.4l-4.61-2.67A.79.79,0,0,0,272.14,375.89Zm66.38-25a.76.76,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.41L339.47,345a.82.82,0,0,0-.7,0L334,347.81c-.2.11-.22.3,0,.4Zm-59.34,20.95-4.81,2.78c-.21.12-.23.3-.05.41l4.61,2.66a.82.82,0,0,0,.7,0l4.82-2.79c.21-.11.22-.3,0-.4l-4.61-2.66A.76.76,0,0,0,279.18,371.82ZM224,417a.76.76,0,0,0,.7,0l4.81-2.78c.21-.12.23-.3,0-.41l-4.61-2.66a.8.8,0,0,0-.69,0l-4.82,2.79c-.21.11-.23.3,0,.4Zm-8.19-8.58L211,411.19c-.21.12-.22.3,0,.41l4.61,2.66a.82.82,0,0,0,.7,0l4.82-2.79c.2-.11.22-.29,0-.4l-4.61-2.66A.76.76,0,0,0,215.81,408.41Zm15.93,4.49,4.81-2.78c.21-.12.23-.3,0-.4L232,407.06a.76.76,0,0,0-.7,0l-4.82,2.78c-.21.12-.22.3,0,.4l4.61,2.67A.79.79,0,0,0,231.74,412.9Zm7-4.06,4.82-2.78c.2-.12.22-.3,0-.41L239,403a.79.79,0,0,0-.7,0l-4.82,2.79c-.2.11-.22.29,0,.4l4.61,2.66A.79.79,0,0,0,238.78,408.84Zm7-4.07,4.82-2.78c.2-.12.22-.3,0-.41l-4.61-2.66a.79.79,0,0,0-.7,0l-4.82,2.78c-.2.12-.22.3,0,.4l4.61,2.66A.76.76,0,0,0,245.82,404.77Zm-23-.42L218,407.13c-.2.12-.22.3,0,.4l4.61,2.66a.76.76,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.41l-4.61-2.66A.79.79,0,0,0,222.85,404.35Zm7-4.07-4.82,2.78c-.2.12-.22.3,0,.41l4.61,2.66a.79.79,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.4l-4.61-2.66A.76.76,0,0,0,229.89,400.28ZM258.06,384l-4.82,2.78c-.2.12-.22.3,0,.41l4.61,2.66a.79.79,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.4L258.76,384A.76.76,0,0,0,258.06,384Zm-7,4.06-4.82,2.79c-.21.11-.23.3,0,.4l4.61,2.66a.76.76,0,0,0,.7,0l4.81-2.78c.21-.12.23-.3.05-.41l-4.61-2.66A.82.82,0,0,0,251,388.08ZM265.1,380l-4.82,2.78c-.2.12-.22.3,0,.41l4.61,2.66a.79.79,0,0,0,.7,0l4.82-2.79c.2-.11.22-.29,0-.4l-4.61-2.66A.79.79,0,0,0,265.1,380Zm-28.17,16.27L232.11,399c-.2.12-.22.3,0,.4l4.61,2.66a.76.76,0,0,0,.7,0l4.82-2.78c.21-.12.22-.3,0-.41l-4.61-2.66A.79.79,0,0,0,236.93,396.22Zm7-4.07-4.81,2.78c-.21.12-.23.3,0,.41l4.6,2.66a.79.79,0,0,0,.7,0l4.82-2.78c.21-.12.23-.3,0-.4l-4.61-2.66A.76.76,0,0,0,244,392.15Zm-9,26.48,4.81-2.78c.21-.12.23-.3,0-.41l-4.61-2.66a.79.79,0,0,0-.7,0l-4.82,2.78c-.21.12-.23.3,0,.4l4.61,2.66A.76.76,0,0,0,235,418.63Zm-37.14-1.75-4.61-2.66a.76.76,0,0,0-.7,0L187.73,417c-.21.12-.23.3,0,.41l4.61,2.66a.79.79,0,0,0,.7,0l4.82-2.78C198,417.16,198,417,197.85,416.88Zm9.18,2.3-4.61-2.66a.82.82,0,0,0-.7,0l-7.41,4.28c-.2.12-.22.3,0,.41l4.61,2.66a.79.79,0,0,0,.7,0l7.41-4.27C207.2,419.47,207.21,419.29,207,419.18ZM191,411.62,186.36,409a.82.82,0,0,0-.7,0l-5.93,3.43c-.2.12-.22.3,0,.4l4.61,2.66a.76.76,0,0,0,.7,0l5.93-3.42C191.14,411.91,191.16,411.73,191,411.62Zm4.55-2.62a.79.79,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.4l-4.61-2.66a.76.76,0,0,0-.7,0L191,405.93c-.2.12-.22.3,0,.41Zm19.95,12.91-4.61-2.66a.79.79,0,0,0-.7,0l-9.26,5.35c-.21.11-.23.29-.05.4l4.61,2.66a.79.79,0,0,0,.7,0l9.27-5.35C215.63,422.2,215.65,422,215.47,421.91Zm3.25,5.73L214.11,425a.76.76,0,0,0-.7,0l-5.93,3.43c-.2.12-.22.3,0,.4l4.61,2.66a.76.76,0,0,0,.7,0l5.93-3.43C218.88,427.93,218.9,427.75,218.72,427.64Zm29.16-48.87a.79.79,0,0,0,.7,0l4.81-2.78c.21-.12.23-.3.05-.4l-4.61-2.66a.75.75,0,0,0-.7,0l-4.82,2.78c-.21.12-.22.3,0,.41Zm-14.09,8.13a.82.82,0,0,0,.7,0l4.82-2.79c.21-.11.22-.3,0-.4L234.74,381a.76.76,0,0,0-.7,0l-4.82,2.78c-.2.12-.22.3,0,.41Zm-31.23,18a.76.76,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.41l-4.61-2.66a.82.82,0,0,0-.7,0L198,401.87c-.2.11-.22.29,0,.4Zm38.27-22.1a.75.75,0,0,0,.7,0l4.82-2.78c.21-.12.23-.3,0-.41L241.78,377a.79.79,0,0,0-.7,0l-4.81,2.78c-.21.12-.23.3,0,.4ZM226.75,391a.79.79,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.4l-4.61-2.67a.79.79,0,0,0-.7,0l-4.82,2.78c-.2.12-.22.3,0,.4Zm-4.57,37a.76.76,0,0,0-.7,0l-7.41,4.28c-.21.12-.23.3,0,.4l4.61,2.66a.75.75,0,0,0,.7,0l7.42-4.28c.2-.12.22-.3,0-.4Zm-5.53-31.13a.82.82,0,0,0,.7,0l4.81-2.79c.21-.11.23-.29,0-.4l-4.6-2.66a.75.75,0,0,0-.7,0l-4.82,2.78c-.21.12-.23.3,0,.41Zm-7.05,4.07a.79.79,0,0,0,.7,0l4.82-2.78c.21-.12.22-.3,0-.4L210.55,395a.79.79,0,0,0-.7,0L205,397.8c-.21.12-.23.3,0,.4Zm143-48.27a.79.79,0,0,0-.7,0l-11.86,6.85c-.21.11-.23.3,0,.4l4.61,2.66a.76.76,0,0,0,.7,0l11.86-6.85c.2-.12.22-.3,0-.4Zm-15.57,9a.79.79,0,0,0-.7,0l-4.82,2.78c-.2.12-.22.3,0,.4l4.61,2.66a.76.76,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.41Zm-95,53,4.82-2.78c.2-.12.22-.3,0-.4l-4.61-2.66a.76.76,0,0,0-.7,0l-4.82,2.78c-.2.12-.22.3,0,.41l4.61,2.66A.79.79,0,0,0,242,414.56Zm81-44.84a.79.79,0,0,0-.7,0l-4.82,2.78c-.21.12-.22.3,0,.4l4.61,2.66a.76.76,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.41Zm36.69-21.18a.76.76,0,0,0-.7,0l-4.82,2.78c-.2.12-.22.3,0,.41l4.61,2.66a.79.79,0,0,0,.7,0l4.82-2.79c.2-.11.22-.29,0-.4Zm11.65-1.4-11.19-6.47a.79.79,0,0,0-.7,0l-4.82,2.78c-.21.12-.23.3,0,.4l11.19,6.46a.76.76,0,0,0,.7,0l4.82-2.78C371.49,347.42,371.51,347.24,371.33,347.14Zm-74.66,37.78a.76.76,0,0,0-.7,0L290,388.36c-.2.12-.22.3,0,.41l4.61,2.66a.79.79,0,0,0,.7,0l5.93-3.42c.21-.12.22-.3,0-.4Zm17.79-10.28a.79.79,0,0,0-.7,0L306.35,379c-.2.12-.22.3,0,.4l4.61,2.66a.76.76,0,0,0,.7,0l7.41-4.28c.21-.12.22-.3,0-.4Zm-34.09,19.69a.82.82,0,0,0-.7,0L240,417.25c-.2.12-.22.3,0,.4l4.61,2.67a.79.79,0,0,0,.7,0l39.65-22.89c.21-.12.23-.3.05-.41Zm-41.88,24.18a.82.82,0,0,0-.7,0L231.86,422c-.21.12-.23.3-.05.4l4.61,2.66a.75.75,0,0,0,.7,0l5.93-3.42c.21-.12.23-.3,0-.41Zm50-28.89a.79.79,0,0,0-.7,0l-5.93,3.42c-.2.12-.22.3,0,.4l4.61,2.67a.79.79,0,0,0,.7,0l5.93-3.42c.2-.12.22-.3,0-.41Zm-58.19,33.6a.76.76,0,0,0-.7,0l-5.93,3.43c-.2.11-.22.29,0,.4l4.61,2.66a.76.76,0,0,0,.7,0l5.93-3.43c.2-.12.22-.3,0-.4Zm74.5-43a.76.76,0,0,0-.7,0l-5.93,3.43c-.21.11-.23.29,0,.4l4.61,2.66a.76.76,0,0,0,.7,0l5.93-3.43c.2-.11.22-.3,0-.4ZM330,365.66a.76.76,0,0,0-.7,0l-4.82,2.78c-.2.12-.22.3,0,.41l4.61,2.66a.79.79,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.4Zm15.77-11,4.82-2.78c.21-.12.22-.3,0-.41l-4.61-2.66a.79.79,0,0,0-.7,0l-4.82,2.78c-.2.12-.22.3,0,.4l4.61,2.66A.76.76,0,0,0,345.8,354.65ZM317.07,356l4.81-2.78c.21-.12.23-.3.05-.4l-4.61-2.66a.75.75,0,0,0-.7,0L311.8,353c-.21.12-.22.3,0,.41l4.61,2.66A.79.79,0,0,0,317.07,356Zm-18.71,26,14.09-8.13c.2-.12.22-.3,0-.41l-4.61-2.66a.79.79,0,0,0-.7,0L293.09,379c-.2.12-.22.3,0,.4l4.61,2.66A.76.76,0,0,0,298.36,382Zm39.7-23.3a.82.82,0,0,0,.7,0l4.82-2.79c.2-.11.22-.3,0-.4L339,352.87a.76.76,0,0,0-.7,0l-4.82,2.78c-.2.12-.22.3,0,.41Zm-5.88-3.83,4.81-2.78c.21-.12.23-.3.05-.4l-4.61-2.66a.75.75,0,0,0-.7,0l-4.82,2.78c-.21.12-.23.3,0,.41l4.61,2.66A.79.79,0,0,0,332.18,354.91Zm-40.86,31.2,4.82-2.79c.2-.12.22-.3,0-.4l-4.61-2.66a.76.76,0,0,0-.7,0l-4.82,2.78c-.2.12-.22.3,0,.41l4.61,2.66A.82.82,0,0,0,291.32,386.11Zm31.17-18.38a.79.79,0,0,0,.7,0l4.82-2.78c.21-.12.23-.3,0-.4l-4.61-2.66a.76.76,0,0,0-.7,0l-4.81,2.78c-.21.12-.23.3,0,.41Zm-66.38,38.7,4.82-2.78c.2-.12.22-.3,0-.4l-4.61-2.66a.76.76,0,0,0-.7,0l-4.82,2.78c-.2.12-.22.3,0,.41l4.61,2.66A.79.79,0,0,0,256.11,406.43Zm7-4.06,4.82-2.78c.21-.12.22-.3,0-.41l-4.61-2.66a.82.82,0,0,0-.7,0l-4.81,2.79c-.21.11-.23.3-.05.4l4.61,2.66A.75.75,0,0,0,263.15,402.37Zm-14.08,8.13,4.82-2.78c.2-.12.22-.3,0-.41l-4.61-2.66a.79.79,0,0,0-.7,0l-4.82,2.78c-.2.12-.22.3,0,.4l4.61,2.66A.76.76,0,0,0,249.07,410.5Zm28.17-16.26,4.82-2.79c.2-.11.22-.29,0-.4l-4.61-2.66a.79.79,0,0,0-.7,0L272,391.19c-.21.12-.22.3,0,.41l4.61,2.66A.79.79,0,0,0,277.24,394.24Zm-7,4.06,4.81-2.78c.21-.12.23-.3,0-.4l-4.6-2.67a.79.79,0,0,0-.7,0l-4.82,2.78c-.21.12-.23.3,0,.4l4.61,2.67A.79.79,0,0,0,270.2,398.3Zm14.08-8.13,4.82-2.78c.2-.12.22-.3,0-.41l-4.61-2.66a.79.79,0,0,0-.7,0L279,387.13c-.2.12-.22.3,0,.4l4.61,2.66A.76.76,0,0,0,284.28,390.17Zm38.43-56.56a.76.76,0,0,0,.7,0l4.81-2.78c.21-.12.23-.3,0-.41l-1.23-.71a.79.79,0,0,0-.7,0l-4.82,2.78c-.2.12-.22.3,0,.4Zm-35,22.16a.76.76,0,0,0,.7,0l4.81-2.78c.21-.12.23-.3,0-.41l-4.61-2.66a.79.79,0,0,0-.7,0l-4.82,2.78c-.21.12-.23.3,0,.4Zm14.08-8.13a.76.76,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.41l-4.61-2.66a.82.82,0,0,0-.7,0l-4.82,2.79c-.2.11-.22.3,0,.4Zm-22.68,13.1a.79.79,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.4l-4.61-2.66a.76.76,0,0,0-.7,0l-4.82,2.78c-.21.12-.22.3,0,.41Zm15.64-9a.79.79,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.4l-4.61-2.66a.76.76,0,0,0-.7,0l-4.82,2.78c-.2.12-.22.3,0,.41ZM265,368.87a.79.79,0,0,0,.7,0l4.82-2.78c.21-.12.22-.3,0-.4L266,363a.76.76,0,0,0-.7,0l-4.81,2.78c-.21.12-.23.3,0,.41Zm7.05-4.07a.76.76,0,0,0,.7,0l4.81-2.78c.21-.12.23-.3,0-.41l-4.6-2.66a.79.79,0,0,0-.7,0l-4.82,2.78c-.21.12-.23.3,0,.4Zm36.55-23.06a.76.76,0,0,0,.7,0l4.82-2.78c.21-.12.22-.3,0-.41l-1.23-.7a.74.74,0,0,0-.69,0l-4.82,2.78c-.21.12-.23.3,0,.4Zm21.13-12.19a.79.79,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.4l-1.23-.71a.76.76,0,0,0-.7,0l-4.82,2.78c-.2.12-.22.3,0,.41Zm9.68,5.59a.79.79,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.4l-4.61-2.66a.76.76,0,0,0-.7,0l-4.82,2.78c-.2.12-.22.3,0,.41Zm13.41,15.44,4.82-2.78c.21-.12.23-.3,0-.4l-4.61-2.66a.76.76,0,0,0-.7,0l-4.81,2.78c-.21.12-.23.3,0,.41l4.6,2.66A.79.79,0,0,0,352.84,350.58Zm-37.18-12.9a.79.79,0,0,0,.7,0l4.82-2.78c.21-.12.23-.3,0-.4l-1.22-.71a.79.79,0,0,0-.7,0l-4.82,2.79c-.21.11-.22.29,0,.4ZM258,372.93a.76.76,0,0,0,.7,0l4.82-2.78c.2-.12.22-.3,0-.41l-4.61-2.66a.79.79,0,0,0-.7,0l-4.82,2.78c-.2.12-.22.3,0,.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.15 413.01 279.2 413.61 307.02 429.67 356.51 401.1 357.54 400.51 328.67 383.85 278.15 413.01",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.88 401.47 328.67 385.77 279.83 413.98 307.02 429.67 355.88 401.47",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.62,273.59a5.46,5.46,0,0,0-2.54,4.64L159.33,399l159.31-91.95a5.46,5.46,0,0,0,2.54-4.64l-8.25-120.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.93,181.64l-4.07-2.35-159.31,92a5.43,5.43,0,0,0-2.54,4.64l8.25,120.77,4.07,2.34,159.31-91.95a5.46,5.46,0,0,0,2.54-4.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.62,273.59a5.46,5.46,0,0,0-2.54,4.64L159.33,399l159.31-91.95a5.46,5.46,0,0,0,2.54-4.64l-8.25-120.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,183.3l8.15,119.17a4.53,4.53,0,0,1-2.05,3.71L160.22,397.33l-8.15-119.16a4.52,4.52,0,0,1,2.05-3.72L312,183.3m.89-1.66L153.62,273.59a5.46,5.46,0,0,0-2.54,4.64L159.33,399l159.31-91.95a5.46,5.46,0,0,0,2.54-4.64l-8.25-120.77Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.28,323.43a1.07,1.07,0,0,1-.53-.13,1.26,1.26,0,0,1-.63-1.08L160.58,285a2.73,2.73,0,0,1,1.27-2.34l58.6-33.82a1.33,1.33,0,0,1,1.3-.1,1.28,1.28,0,0,1,.62,1.08L224.91,287a2.73,2.73,0,0,1-1.27,2.34l-58.59,33.83A1.64,1.64,0,0,1,164.28,323.43Zm-2.74-38.52,2.54,37.25a.39.39,0,0,0,.12.29.48.48,0,0,0,.36-.08l58.6-33.83a1.76,1.76,0,0,0,.79-1.44l-2.54-37.25a.35.35,0,0,0-.12-.28s-.18,0-.36.07l-58.59,33.83a1.78,1.78,0,0,0-.8,1.44Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.57,371.63a1.25,1.25,0,0,1-.54-.12,1.28,1.28,0,0,1-.62-1.08l-2.54-37.25a2.73,2.73,0,0,1,1.27-2.34l141.47-81.68a1.33,1.33,0,0,1,1.3-.09,1.25,1.25,0,0,1,.63,1.07l2.54,37.26a2.7,2.7,0,0,1-1.27,2.33L168.33,371.41A1.47,1.47,0,0,1,167.57,371.63ZM307.38,249.91a.53.53,0,0,0-.28.09L165.62,331.68a1.76,1.76,0,0,0-.79,1.43l2.54,37.25a.36.36,0,0,0,.12.29s.18,0,.36-.07L309.32,288.9a1.74,1.74,0,0,0,.79-1.44l-2.54-37.25a.36.36,0,0,0-.11-.29Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,292.74l3.6-2.08c.55-.32,1-.11,1.07.46a1.93,1.93,0,0,1-.93,1.61l-3.6,2.08c-.55.32-1,.11-1.07-.46A1.93,1.93,0,0,1,167,292.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.11,285.62l20.72-12c.62-.36,1.15-.12,1.19.52a2.15,2.15,0,0,1-1,1.8l-20.72,12c-.61.35-1.15.12-1.19-.52A2.17,2.17,0,0,1,167.11,285.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.41,299l3.61-2.08c.55-.31,1-.11,1.06.46a1.89,1.89,0,0,1-.92,1.61L167.55,301c-.55.31-1,.11-1.06-.47A1.92,1.92,0,0,1,167.41,299Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.83,305.18l3.61-2.08c.55-.32,1-.11,1.06.46a1.92,1.92,0,0,1-.92,1.61l-3.6,2.08c-.55.32-1,.11-1.07-.46A1.94,1.94,0,0,1,167.83,305.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.26,311.38l3.6-2.09c.55-.31,1-.11,1.07.47a1.93,1.93,0,0,1-.93,1.61l-3.6,2.08c-.55.31-1,.11-1.07-.46A1.93,1.93,0,0,1,168.26,311.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.88,309.94a.27.27,0,0,1-.22-.1.22.22,0,0,1,.07-.31l45-26a.24.24,0,0,1,.33.07.2.2,0,0,1-.06.3l-45,26A.2.2,0,0,1,174.88,309.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.45,303.73a.26.26,0,0,1-.21-.11.21.21,0,0,1,.07-.3l45-26a.25.25,0,0,1,.33.08.21.21,0,0,1-.07.3l-45,26A.24.24,0,0,1,174.45,303.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,297.54a.26.26,0,0,1-.21-.11.2.2,0,0,1,.06-.3l45-26a.26.26,0,0,1,.33.07.22.22,0,0,1-.07.31l-45,26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.61,291.34a.24.24,0,0,1-.21-.1.21.21,0,0,1,.06-.31l45-26a.25.25,0,0,1,.34.07.21.21,0,0,1-.07.3l-45,26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "175.71 309.14 175.29 303.02 179.51 299.76 184.66 296.75 187.75 292.59 192.99 289.56 195.98 285.41 206.47 279.36 209.75 274.77 214.11 268.59 218.59 265.4 219.84 283.74 175.71 309.14",
    style: {
      fill: "#90CAF9"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "175.71 309.14 175.4 304.56 181.03 301.26 185.89 297.3 191.09 294.32 196.33 290.09 201.54 287.05 204.53 282.9 209.9 279.79 212.76 275.73 216.39 271.2 218.89 269.76 219.84 283.74 175.71 309.14",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,247.92c.23,3.32-1.41,7.07-3.65,8.37s-4.25-.35-4.48-3.68,1.41-7.07,3.65-8.36S236.73,244.6,237,247.92Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.58,253.6a.54.54,0,0,1-.38-.14l-1.59-1.29a.62.62,0,0,1-.08-.86.61.61,0,0,1,.86-.08l.91.74,1.94-5.56A.63.63,0,0,1,235,246a.61.61,0,0,1,.37.78l-2.23,6.39a.62.62,0,0,1-.41.38A.5.5,0,0,1,232.58,253.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.51,270.64c.22,3.32-1.41,7.06-3.66,8.36s-4.24-.35-4.47-3.67,1.41-7.07,3.65-8.37S238.28,267.31,238.51,270.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.18,276.49a.56.56,0,0,1-.25-.05.61.61,0,0,1-.31-.8l2.53-5.8a.62.62,0,0,1,.81-.32.62.62,0,0,1,.31.8l-2.54,5.81A.6.6,0,0,1,233.18,276.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,274.86a.61.61,0,0,1-.39-.13l-3.1-2.55a.61.61,0,1,1,.77-.94l3.1,2.55a.6.6,0,0,1-.38,1.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.39,228.83,241.6,241.41c-.36.21-.67,0-.7-.45v-.12a1.34,1.34,0,0,1,.58-1.19l21.79-12.58c.35-.2.66,0,.69.45v.12A1.37,1.37,0,0,1,263.39,228.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.7,233.4,241.91,246c-.35.2-.66,0-.7-.45v-.13a1.36,1.36,0,0,1,.58-1.18l21.79-12.58c.35-.21.66,0,.69.45v.12A1.39,1.39,0,0,1,263.7,233.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,238l-21.79,12.58c-.35.2-.66,0-.69-.45V250a1.38,1.38,0,0,1,.58-1.19l21.79-12.58c.35-.2.66,0,.7.45v.12A1.38,1.38,0,0,1,264,238Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.94,251.55l-21.79,12.58c-.36.2-.67,0-.7-.45v-.12a1.35,1.35,0,0,1,.59-1.19l21.79-12.58c.35-.21.66,0,.69.45v.12A1.39,1.39,0,0,1,264.94,251.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.25,256.11l-21.79,12.58c-.35.21-.67,0-.7-.45v-.12a1.37,1.37,0,0,1,.58-1.19l21.79-12.58c.35-.2.66,0,.69.45v.12A1.37,1.37,0,0,1,265.25,256.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.56,260.67l-21.79,12.59c-.35.2-.66,0-.69-.45v-.13a1.36,1.36,0,0,1,.58-1.18l21.79-12.59c.35-.2.66,0,.69.46v.12A1.36,1.36,0,0,1,265.56,260.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.93,224.27c.23,3.32-1.41,7.06-3.65,8.36s-4.25-.35-4.48-3.67,1.41-7.07,3.66-8.37S277.7,220.94,277.93,224.27Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.55,230a.62.62,0,0,1-.38-.14l-1.58-1.3a.61.61,0,1,1,.77-.94l.91.75,2-5.57a.6.6,0,1,1,1.14.4l-2.23,6.39a.64.64,0,0,1-.41.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.48,247c.23,3.32-1.41,7.07-3.65,8.37s-4.25-.35-4.48-3.68,1.41-7.07,3.66-8.36S279.25,243.66,279.48,247Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.15,252.84a.64.64,0,0,1-.24-.05.62.62,0,0,1-.32-.81l2.54-5.8a.61.61,0,0,1,1.11.49l-2.53,5.8A.62.62,0,0,1,274.15,252.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,251.21a.64.64,0,0,1-.39-.14l-3.1-2.55a.6.6,0,0,1-.09-.85.62.62,0,0,1,.86-.09l3.1,2.55a.62.62,0,0,1,.09.86A.63.63,0,0,1,277,251.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.36,205.18l-21.79,12.58c-.35.2-.66,0-.69-.45v-.12a1.37,1.37,0,0,1,.58-1.19l21.79-12.58c.35-.21.66,0,.69.45V204A1.39,1.39,0,0,1,304.36,205.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.67,209.74l-21.79,12.58c-.35.21-.66,0-.69-.45v-.12a1.39,1.39,0,0,1,.58-1.19L304.55,208c.35-.2.67,0,.7.45v.12A1.34,1.34,0,0,1,304.67,209.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,214.3l-21.79,12.59c-.35.2-.66,0-.69-.45v-.13a1.36,1.36,0,0,1,.58-1.18l21.79-12.59c.36-.2.67,0,.7.45v.13A1.35,1.35,0,0,1,305,214.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.91,227.89l-21.79,12.58c-.35.21-.66,0-.7-.45v-.12a1.39,1.39,0,0,1,.58-1.19l21.79-12.58c.35-.2.66,0,.69.45v.12A1.37,1.37,0,0,1,305.91,227.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.22,232.46,284.43,245c-.35.2-.66,0-.69-.45v-.13a1.36,1.36,0,0,1,.58-1.18L306.1,230.7c.35-.21.66,0,.7.45v.12A1.39,1.39,0,0,1,306.22,232.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.53,237,284.74,249.6c-.35.2-.66,0-.69-.45V249a1.38,1.38,0,0,1,.58-1.19l21.79-12.58c.36-.2.67,0,.7.45v.12A1.33,1.33,0,0,1,306.53,237Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.35,279.23a.17.17,0,0,1,0-.12.24.24,0,0,1,.08-.09l1.63-.94a.1.1,0,0,1,.09,0,.13.13,0,0,1,0,.09l0,.39a.31.31,0,0,1,0,.13.24.24,0,0,1-.08.09l-1.22.7v.74a1.37,1.37,0,0,1,.23-.2l.19-.12a1.33,1.33,0,0,1,.46-.18.65.65,0,0,1,.37,0,.59.59,0,0,1,.27.27,1.11,1.11,0,0,1,.12.5,2.4,2.4,0,0,1,0,.66,2.18,2.18,0,0,1-.56,1,2.66,2.66,0,0,1-.44.33,1.41,1.41,0,0,1-.52.21.63.63,0,0,1-.37,0,.47.47,0,0,1-.24-.22,1.07,1.07,0,0,1-.11-.37.16.16,0,0,1,0-.13.24.24,0,0,1,.08-.09l.35-.2a.08.08,0,0,1,.08,0,.1.1,0,0,1,.05.07.4.4,0,0,0,.1.16.24.24,0,0,0,.14.05.27.27,0,0,0,.17,0l.19-.09a1,1,0,0,0,.39-.41,1,1,0,0,0,.12-.56.34.34,0,0,0-.18-.32.42.42,0,0,0-.41.05,1,1,0,0,0-.21.15.71.71,0,0,0-.12.13.76.76,0,0,0-.08.11l-.1.08-.4.23a.06.06,0,0,1-.08,0s0,0-.05-.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.23,277.77a1.52,1.52,0,0,1,0,.23l0,.26,0,.26c0,.09,0,.17,0,.24a3.39,3.39,0,0,1,0,.64,1.91,1.91,0,0,1-.16.59,2,2,0,0,1-.86.95,1.24,1.24,0,0,1-.55.19.51.51,0,0,1-.37-.11.81.81,0,0,1-.24-.36,2.78,2.78,0,0,1-.11-.56c0-.13,0-.29-.05-.47s0-.34,0-.49a3.55,3.55,0,0,1,0-.65,2,2,0,0,1,.16-.6,2.12,2.12,0,0,1,.33-.53,2.31,2.31,0,0,1,.53-.43,1.33,1.33,0,0,1,.55-.19.51.51,0,0,1,.37.11.81.81,0,0,1,.24.36A2.78,2.78,0,0,1,292.23,277.77Zm-1.68,2a.92.92,0,0,0,.19.53q.15.15.45,0a.91.91,0,0,0,.42-.47,1.85,1.85,0,0,0,.1-.7c0-.15,0-.3,0-.47s0-.33,0-.47a1,1,0,0,0-.19-.53q-.15-.15-.45,0a1,1,0,0,0-.42.47,1.85,1.85,0,0,0-.1.7c0,.15,0,.31,0,.48S290.54,279.6,290.55,279.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.21,275.67a.5.5,0,0,1,.28-.1.36.36,0,0,1,.21,0,.47.47,0,0,1,.13.15.62.62,0,0,1,.07.23q0,.13,0,.3c0,.11,0,.22,0,.32a1.49,1.49,0,0,1,0,.28,1,1,0,0,1-.11.29,1,1,0,0,1-.18.27,1,1,0,0,1-.28.22.6.6,0,0,1-.28.1.36.36,0,0,1-.21,0,.32.32,0,0,1-.13-.15.62.62,0,0,1-.07-.23l0-.3c0-.11,0-.21,0-.31a1.5,1.5,0,0,1,0-.29,1.15,1.15,0,0,1,.11-.29,1.27,1.27,0,0,1,.18-.27A1,1,0,0,1,293.21,275.67Zm1.74-.87.06-.12a.24.24,0,0,1,.09-.08l.26-.15s.06,0,.08,0a.09.09,0,0,1,0,.06,0,0,0,0,1,0,0,.06.06,0,0,1,0,0l-1.89,4.86-.06.11a.24.24,0,0,1-.09.08l-.26.15a.08.08,0,0,1-.08,0,.06.06,0,0,1,0-.06v0a.06.06,0,0,1,0,0Zm-1.43,2v-.41c0-.05,0-.08,0-.1a.34.34,0,0,0-.07-.16s-.1,0-.18,0a.42.42,0,0,0-.17.18.57.57,0,0,0,0,.22v.11a.92.92,0,0,0,0,.16.61.61,0,0,0,0,.14c0,.05,0,.09,0,.11a.26.26,0,0,0,.07.15s.1,0,.18,0a.42.42,0,0,0,.17-.18A.54.54,0,0,0,293.52,276.79Zm1.7-.25a.53.53,0,0,1,.28-.1.36.36,0,0,1,.21,0,.32.32,0,0,1,.13.15.62.62,0,0,1,.07.23q0,.13,0,.3c0,.11,0,.22,0,.32a1.49,1.49,0,0,1,0,.28,1.15,1.15,0,0,1-.11.29,1,1,0,0,1-.18.27,1.24,1.24,0,0,1-.28.22.73.73,0,0,1-.28.1.36.36,0,0,1-.21,0,.47.47,0,0,1-.13-.15.88.88,0,0,1-.07-.23q0-.14,0-.3c0-.11,0-.22,0-.32a1.49,1.49,0,0,1,0-.28,1,1,0,0,1,.11-.29,1.27,1.27,0,0,1,.18-.27A1,1,0,0,1,295.22,276.54Zm.31,1.12a.39.39,0,0,0,0-.11v-.3c0-.05,0-.08,0-.1a.34.34,0,0,0-.07-.16s-.1,0-.18,0a.42.42,0,0,0-.17.18.57.57,0,0,0,0,.22v.11a.76.76,0,0,0,0,.15c0,.06,0,.11,0,.15s0,.08,0,.1a.27.27,0,0,0,.07.16s.1,0,.18,0a.36.36,0,0,0,.17-.18A.54.54,0,0,0,295.53,277.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.75,279.41a17.49,17.49,0,0,1,2-5.26c.17-.29.35-.57.53-.85a12.55,12.55,0,0,1,3.53-3.61l-.25-3.6a17,17,0,0,0-5.12,5.25c-.19.28-.36.56-.53.85a24,24,0,0,0-2.88,7.65c-.06.32-.11.65-.15,1a18,18,0,0,0-.15,3.79,13.05,13.05,0,0,0,.63,3.33c.09.26.18.5.28.74a6.74,6.74,0,0,0,3.66,3.86,5.29,5.29,0,0,0,.6.21,7.35,7.35,0,0,0,5.42-.85l-.24-3.6a5.29,5.29,0,0,1-3.73.58,3.35,3.35,0,0,1-.61-.2A4.94,4.94,0,0,1,285.2,286c-.1-.23-.19-.48-.27-.73a9.79,9.79,0,0,1-.43-2.3,12.56,12.56,0,0,1,.1-2.59C284.64,280.06,284.69,279.73,284.75,279.41Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.76,269.07c-.09-.25-.18-.5-.27-.73a7.24,7.24,0,0,0-3.91-4.14,4.69,4.69,0,0,0-.6-.2,7.79,7.79,0,0,0-5.8.91l.05.77.25,3.61.06.81a4.84,4.84,0,0,1,3.34-.53,4.35,4.35,0,0,1,.61.2,4.5,4.5,0,0,1,2.25,2.4,6.93,6.93,0,0,1,.27.73,9,9,0,0,1,.39,2.06,12.21,12.21,0,0,1-.09,2.33c0,.33-.09.65-.15,1a15.94,15.94,0,0,1-1.77,4.72c-.17.29-.35.57-.53.85a11.36,11.36,0,0,1-3.17,3.23l.06.81.24,3.61.06.78a18.2,18.2,0,0,0,5.47-5.6c.19-.28.36-.57.53-.86a25,25,0,0,0,3.07-8.16c.06-.33.11-.65.16-1a19.64,19.64,0,0,0,.16-4A14.34,14.34,0,0,0,301.76,269.07Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.76,269.07c-.09-.25-.18-.5-.27-.73a7.24,7.24,0,0,0-3.91-4.14,4.69,4.69,0,0,0-.6-.2,7.79,7.79,0,0,0-5.8.91l.05.77.25,3.61.06.81a4.84,4.84,0,0,1,3.34-.53,4.35,4.35,0,0,1,.61.2,4.5,4.5,0,0,1,2.25,2.4,6.93,6.93,0,0,1,.27.73,9,9,0,0,1,.39,2.06,12.21,12.21,0,0,1-.09,2.33c0,.33-.09.65-.15,1a15.94,15.94,0,0,1-1.77,4.72c-.17.29-.35.57-.53.85a11.36,11.36,0,0,1-3.17,3.23l.06.81.24,3.61.06.78a18.2,18.2,0,0,0,5.47-5.6c.19-.28.36-.57.53-.86a25,25,0,0,0,3.07-8.16c.06-.33.11-.65.16-1a19.64,19.64,0,0,0,.16-4A14.34,14.34,0,0,0,301.76,269.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M261.29,298.59a.08.08,0,0,1-.08,0,.13.13,0,0,1,0-.09l0-.67-1.35.77a.08.08,0,0,1-.08,0,.1.1,0,0,1,0-.09l0-.39a.41.41,0,0,1,0-.16.64.64,0,0,1,.06-.16l1.18-2.89a.43.43,0,0,1,.17-.24l.33-.19a.08.08,0,0,1,.08,0,.1.1,0,0,1,0,.09l.16,2.22.37-.21a.06.06,0,0,1,.08,0s0,0,.05.08l0,.4a.17.17,0,0,1,0,.12.15.15,0,0,1-.08.09l-.38.22.05.67a.31.31,0,0,1,0,.13.24.24,0,0,1-.08.09Zm-.22-1.45L261,296l-.66,1.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.8,294a1.52,1.52,0,0,1,0,.23l0,.26,0,.26c0,.09,0,.17,0,.24a3.39,3.39,0,0,1,0,.64,1.91,1.91,0,0,1-.16.59,2,2,0,0,1-.86.95,1.43,1.43,0,0,1-.55.2.56.56,0,0,1-.38-.12.9.9,0,0,1-.23-.36,2.67,2.67,0,0,1-.11-.55c0-.14,0-.3-.05-.48s0-.34,0-.49a3.39,3.39,0,0,1,0-.64,2.38,2.38,0,0,1,.16-.61,2.12,2.12,0,0,1,.33-.53,2.31,2.31,0,0,1,.53-.43,1.29,1.29,0,0,1,.55-.19.51.51,0,0,1,.37.11.81.81,0,0,1,.24.36A2.78,2.78,0,0,1,264.8,294Zm-1.68,2a.92.92,0,0,0,.19.53q.15.15.45,0a.87.87,0,0,0,.41-.46,1.74,1.74,0,0,0,.11-.71c0-.14,0-.3,0-.47s0-.33,0-.47a1,1,0,0,0-.19-.53q-.15-.15-.45,0a1,1,0,0,0-.42.47,1.85,1.85,0,0,0-.1.7c0,.15,0,.31,0,.48S263.1,295.86,263.12,296Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.78,291.93a.6.6,0,0,1,.28-.1.36.36,0,0,1,.21,0,.47.47,0,0,1,.13.15.62.62,0,0,1,.07.23q0,.13,0,.3c0,.11,0,.22,0,.32a1.41,1.41,0,0,1,0,.28,1,1,0,0,1-.11.29,1,1,0,0,1-.18.27,1,1,0,0,1-.28.22.6.6,0,0,1-.28.1.36.36,0,0,1-.21,0,.32.32,0,0,1-.13-.15.62.62,0,0,1-.07-.23q0-.14,0-.3c0-.11,0-.21,0-.31a1.5,1.5,0,0,1,0-.29,1.15,1.15,0,0,1,.11-.29,1.59,1.59,0,0,1,.18-.27A1,1,0,0,1,265.78,291.93Zm1.75-.87a.33.33,0,0,1,.05-.12.24.24,0,0,1,.09-.08l.27-.15a.06.06,0,0,1,.07,0,.09.09,0,0,1,0,.06,0,0,0,0,1,0,0s0,0,0,0l-1.89,4.86-.06.11a.24.24,0,0,1-.09.08l-.26.15a.13.13,0,0,1-.08,0,.08.08,0,0,1,0-.07v0a.06.06,0,0,1,0,0Zm-1.44,2v-.41c0-.05,0-.08,0-.1a.34.34,0,0,0-.07-.16s-.1,0-.18,0a.35.35,0,0,0-.17.17.59.59,0,0,0,0,.23v.1a.92.92,0,0,0,0,.16.76.76,0,0,0,0,.15s0,.08,0,.1a.26.26,0,0,0,.07.15s.1,0,.18,0a.36.36,0,0,0,.17-.18A.54.54,0,0,0,266.09,293.05Zm1.7-.25a.53.53,0,0,1,.28-.1.36.36,0,0,1,.21,0,.37.37,0,0,1,.13.15.62.62,0,0,1,.07.23,2.53,2.53,0,0,1,0,.3c0,.11,0,.22,0,.32a1.49,1.49,0,0,1,0,.28,1.66,1.66,0,0,1-.1.29,1.31,1.31,0,0,1-.19.27,1.44,1.44,0,0,1-.27.22.83.83,0,0,1-.29.1.36.36,0,0,1-.21,0,.47.47,0,0,1-.13-.15.88.88,0,0,1-.07-.23q0-.14,0-.3c0-.11,0-.22,0-.32a1.49,1.49,0,0,1,0-.28,1.15,1.15,0,0,1,.11-.29,1,1,0,0,1,.19-.27A.84.84,0,0,1,267.79,292.8Zm.31,1.12a.39.39,0,0,0,0-.11v-.3c0-.05,0-.08,0-.1a.26.26,0,0,0-.07-.16s-.09,0-.18,0a.42.42,0,0,0-.17.18.85.85,0,0,0,0,.22v.11a.76.76,0,0,0,0,.15c0,.06,0,.11,0,.15a.54.54,0,0,1,0,.11.35.35,0,0,0,.07.15s.1,0,.18,0a.36.36,0,0,0,.17-.18A.54.54,0,0,0,268.1,293.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.58,301.07a12.35,12.35,0,0,1-3.52,3.6l-.35.22-.35.18a5.32,5.32,0,0,1-3.74.59,4.69,4.69,0,0,1-.6-.2,4.93,4.93,0,0,1-2.51-2.67,6.93,6.93,0,0,1-.27-.73,9.14,9.14,0,0,1-.43-2.29,13.39,13.39,0,0,1,.09-2.6c0-.33.1-.65.16-1a17.27,17.27,0,0,1,2-5.25c.17-.29.35-.58.53-.86a12.38,12.38,0,0,1,3.53-3.6l-.25-3.61a17.4,17.4,0,0,0-5.13,5.25c-.18.28-.35.57-.52.86a24,24,0,0,0-2.88,7.64c-.06.33-.11.65-.16,1a18.61,18.61,0,0,0-.14,3.79,13.22,13.22,0,0,0,.63,3.33c.08.25.17.5.27.73a6.82,6.82,0,0,0,3.66,3.87,4.69,4.69,0,0,0,.6.2,7.31,7.31,0,0,0,5.43-.84,3.9,3.9,0,0,0,.35-.19c.12-.07.24-.14.35-.22a17.13,17.13,0,0,0,5.13-5.24Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.07,285.85c-.09-.25-.18-.49-.28-.73a7.21,7.21,0,0,0-3.9-4.13l-.6-.21a7.83,7.83,0,0,0-5.8.91l.05.78.25,3.6,0,.82a4.88,4.88,0,0,1,3.35-.53,3.35,3.35,0,0,1,.61.2,4.48,4.48,0,0,1,2.25,2.39c.1.23.19.48.27.73a8.48,8.48,0,0,1,.38,2.06,12.14,12.14,0,0,1-.08,2.33c0,.33-.09.66-.16,1a15.55,15.55,0,0,1-1.76,4.72l.41.44,1.85,2,.4.42a25.27,25.27,0,0,0,3.07-8.16c.06-.32.11-.65.15-1a19.76,19.76,0,0,0,.16-4A14.35,14.35,0,0,0,274.07,285.85Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.91,310.35a.08.08,0,0,1,.09,0s0,0,0,.08l0,.4a.21.21,0,0,1,0,.13l-.06.13-.57,1.22a1,1,0,0,1,.36-.08.57.57,0,0,1,.29.07.52.52,0,0,1,.19.24,1.12,1.12,0,0,1,.09.4,1.51,1.51,0,0,1-.05.56,2,2,0,0,1-.22.53,2.54,2.54,0,0,1-.36.45,2.28,2.28,0,0,1-.46.36,1.93,1.93,0,0,1-.53.21.81.81,0,0,1-.39,0,.5.5,0,0,1-.25-.2.84.84,0,0,1-.12-.31.35.35,0,0,1,0-.13.24.24,0,0,1,.08-.09l.34-.2a.11.11,0,0,1,.08,0,.22.22,0,0,1,.06.07l.08.08a.16.16,0,0,0,.12,0,.35.35,0,0,0,.19,0,1.14,1.14,0,0,0,.26-.12,1.19,1.19,0,0,0,.42-.38.81.81,0,0,0,.14-.48c0-.17-.08-.26-.19-.27a.79.79,0,0,0-.43.14l-.36.21a.07.07,0,0,1-.09,0,.11.11,0,0,1,0-.09l0-.39a.35.35,0,0,1,0-.13c0-.05,0-.09,0-.13l.55-1.17-1.19.69a.07.07,0,0,1-.09,0,.09.09,0,0,1,0-.08l0-.4a.27.27,0,0,1,0-.12.18.18,0,0,1,.08-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,310.06a1.4,1.4,0,0,1,0,.23l0,.26,0,.26c0,.09,0,.16,0,.24a3.39,3.39,0,0,1,0,.64,2.34,2.34,0,0,1-.16.59,1.94,1.94,0,0,1-.34.52,1.84,1.84,0,0,1-.52.43,1.24,1.24,0,0,1-.55.19.51.51,0,0,1-.37-.11.74.74,0,0,1-.24-.36,2.78,2.78,0,0,1-.11-.56c0-.13,0-.29-.05-.47s0-.34,0-.49a3.55,3.55,0,0,1,0-.65,2,2,0,0,1,.16-.6,2.12,2.12,0,0,1,.33-.53,2.31,2.31,0,0,1,.53-.43,1.17,1.17,0,0,1,.55-.19.51.51,0,0,1,.37.11.73.73,0,0,1,.23.36A2.21,2.21,0,0,1,237,310.06Zm-1.68,2a1,1,0,0,0,.19.53q.15.15.45,0a.85.85,0,0,0,.41-.47,1.66,1.66,0,0,0,.11-.7c0-.15,0-.31,0-.48s0-.32,0-.46a1,1,0,0,0-.19-.53q-.15-.15-.45,0a.91.91,0,0,0-.42.47,1.85,1.85,0,0,0-.1.7c0,.15,0,.3,0,.47S235.33,311.89,235.35,312Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,308a.5.5,0,0,1,.28-.1.36.36,0,0,1,.21,0,.47.47,0,0,1,.13.15.62.62,0,0,1,.07.23q0,.14,0,.3c0,.11,0,.22,0,.31a1.5,1.5,0,0,1,0,.29,1.15,1.15,0,0,1-.11.29,1.27,1.27,0,0,1-.18.27,1.24,1.24,0,0,1-.28.22.73.73,0,0,1-.28.1.36.36,0,0,1-.21,0,.47.47,0,0,1-.13-.15.62.62,0,0,1-.07-.23l0-.3c0-.11,0-.22,0-.32a1.49,1.49,0,0,1,0-.28,1,1,0,0,1,.11-.29,1,1,0,0,1,.18-.27A1,1,0,0,1,238,308Zm1.74-.87a.67.67,0,0,1,.06-.12.24.24,0,0,1,.09-.08l.26-.15a.08.08,0,0,1,.08,0s0,0,0,.06v0a.06.06,0,0,1,0,0l-1.89,4.85a.67.67,0,0,1-.06.12.24.24,0,0,1-.09.08l-.26.15a.08.08,0,0,1-.08,0,.06.06,0,0,1,0-.06v0a.06.06,0,0,1,0,0Zm-1.43,2v-.41c0-.05,0-.08,0-.1a.3.3,0,0,0-.07-.16s-.1,0-.18,0a.42.42,0,0,0-.17.18.57.57,0,0,0,0,.22v.11a.76.76,0,0,0,0,.15.66.66,0,0,0,0,.15c0,.05,0,.09,0,.11a.26.26,0,0,0,.07.15s.1,0,.18,0a.42.42,0,0,0,.17-.18A.54.54,0,0,0,238.32,309.08Zm1.7-.26a.73.73,0,0,1,.28-.1.46.46,0,0,1,.21,0,.28.28,0,0,1,.13.15.62.62,0,0,1,.07.23l0,.3c0,.11,0,.21,0,.31a1.5,1.5,0,0,1,0,.29,1.15,1.15,0,0,1-.11.29,1.41,1.41,0,0,1-.18.27,1.6,1.6,0,0,1-.28.22.73.73,0,0,1-.28.1.46.46,0,0,1-.21,0,.42.42,0,0,1-.13-.16.52.52,0,0,1-.07-.22q0-.13,0-.3c0-.11,0-.22,0-.32a1.41,1.41,0,0,1,0-.28,1,1,0,0,1,.11-.29,1.67,1.67,0,0,1,.18-.28A1.6,1.6,0,0,1,240,308.82Zm.31,1.13v-.41c0-.05,0-.08,0-.1a.3.3,0,0,0-.07-.16s-.1,0-.18,0a.42.42,0,0,0-.17.18.54.54,0,0,0,0,.22v.11a.76.76,0,0,0,0,.15.71.71,0,0,0,0,.15c0,.05,0,.08,0,.1a.3.3,0,0,0,.07.16s.1,0,.18,0a.36.36,0,0,0,.17-.18A.54.54,0,0,0,240.33,310Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.34,311a17.27,17.27,0,0,1-2,5.25c-.17.29-.35.58-.53.85a12.42,12.42,0,0,1-3.53,3.61l-.35.22-.35.18a5.3,5.3,0,0,1-3.73.59,3.84,3.84,0,0,1-.6-.2,4.93,4.93,0,0,1-2.51-2.67,5.26,5.26,0,0,1-.28-.73,9.71,9.71,0,0,1-.43-2.29,13.41,13.41,0,0,1,.1-2.6c0-.33.09-.65.16-1a16.92,16.92,0,0,1,2-5.25c.17-.3.34-.58.53-.86a12.35,12.35,0,0,1,3.52-3.6l-.24-3.61a17.17,17.17,0,0,0-5.13,5.25c-.18.28-.36.57-.53.86a23.63,23.63,0,0,0-2.87,7.64c-.06.32-.12.65-.16,1a18.55,18.55,0,0,0-.15,3.78,12.78,12.78,0,0,0,.64,3.34c.08.25.17.5.27.73a6.85,6.85,0,0,0,3.66,3.87,3.84,3.84,0,0,0,.6.2,7.37,7.37,0,0,0,5.43-.84,3.9,3.9,0,0,1,.35-.19l.35-.22a17.17,17.17,0,0,0,5.13-5.25c.18-.28.35-.56.52-.85a24.06,24.06,0,0,0,2.88-7.64Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.32,301.87c-.08-.25-.17-.5-.27-.73a7.22,7.22,0,0,0-3.91-4.13,5.29,5.29,0,0,0-.6-.21,7.84,7.84,0,0,0-5.8.91l.06.78.24,3.6.06.82a4.76,4.76,0,0,1,3.35-.53,3.25,3.25,0,0,1,.6.2A4.41,4.41,0,0,1,242.3,305a5.8,5.8,0,0,1,.28.73,9,9,0,0,1,.38,2.06,13,13,0,0,1-.08,2.33l.62-.09,2.74-.43.6-.1a19.64,19.64,0,0,0,.16-4A14.34,14.34,0,0,0,246.32,301.87Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8,
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.32,301.87c-.08-.25-.17-.5-.27-.73a7.22,7.22,0,0,0-3.91-4.13,5.29,5.29,0,0,0-.6-.21,7.84,7.84,0,0,0-5.8.91l.06.78.24,3.6.06.82a4.76,4.76,0,0,1,3.35-.53,3.25,3.25,0,0,1,.6.2A4.41,4.41,0,0,1,242.3,305a5.8,5.8,0,0,1,.28.73,9,9,0,0,1,.38,2.06,13,13,0,0,1-.08,2.33l.62-.09,2.74-.43.6-.1a19.64,19.64,0,0,0,.16-4A14.34,14.34,0,0,0,246.32,301.87Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.23,328.1a1.15,1.15,0,0,0,.14-.37.94.94,0,0,0,0-.28.42.42,0,0,0-.13-.32c-.08-.06-.2-.05-.37.05a.82.82,0,0,0-.34.35,1.41,1.41,0,0,0-.13.48.34.34,0,0,1,0,.14l-.07.08-.35.19a.08.08,0,0,1-.08,0s0,0,0-.09a2,2,0,0,1,.06-.53,2.36,2.36,0,0,1,.21-.52,2.51,2.51,0,0,1,.32-.46,1.65,1.65,0,0,1,.42-.34.94.94,0,0,1,.48-.16.6.6,0,0,1,.35.1.82.82,0,0,1,.22.29,1.3,1.3,0,0,1,.09.4,1.22,1.22,0,0,1,0,.27,1,1,0,0,1,0,.29c0,.1-.07.21-.12.34s-.13.27-.22.43l-.74,1.41,1.2-.7a.07.07,0,0,1,.09,0,.09.09,0,0,1,0,.08l0,.4a.27.27,0,0,1,0,.12.21.21,0,0,1-.08.1l-2,1.17a.14.14,0,0,1-.09,0,.13.13,0,0,1,0-.09l0-.34a.33.33,0,0,1,0-.19c0-.06.05-.11.06-.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.84,325.74a1.64,1.64,0,0,1,0,.23l0,.26,0,.27c0,.08,0,.16,0,.23a3.34,3.34,0,0,1,0,.64,2.41,2.41,0,0,1-.16.6,1.94,1.94,0,0,1-.34.52,2,2,0,0,1-.52.42,1.28,1.28,0,0,1-.55.2.54.54,0,0,1-.38-.11.9.9,0,0,1-.23-.37,2.67,2.67,0,0,1-.11-.55c0-.14,0-.3-.05-.48s0-.34,0-.48a4.64,4.64,0,0,1,0-.65,2.43,2.43,0,0,1,.17-.6,2,2,0,0,1,.33-.53,1.89,1.89,0,0,1,.53-.43,1.34,1.34,0,0,1,.54-.2.52.52,0,0,1,.38.11.91.91,0,0,1,.24.37A2.67,2.67,0,0,1,209.84,325.74Zm-1.68,2a1,1,0,0,0,.19.54q.15.13.45,0a.93.93,0,0,0,.41-.47,1.71,1.71,0,0,0,.11-.71c0-.14,0-.3,0-.47s0-.33,0-.46a1,1,0,0,0-.19-.54q-.15-.13-.45,0a1,1,0,0,0-.42.47,1.9,1.9,0,0,0-.1.71c0,.14,0,.3,0,.47S208.14,327.58,208.16,327.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.82,323.64a.73.73,0,0,1,.28-.1.36.36,0,0,1,.21,0,.32.32,0,0,1,.13.15.57.57,0,0,1,.07.22l0,.31c0,.11,0,.21,0,.31a1.41,1.41,0,0,1,0,.28,1,1,0,0,1-.11.29,1.27,1.27,0,0,1-.18.27,1,1,0,0,1-.28.22.77.77,0,0,1-.28.11.36.36,0,0,1-.21-.05.28.28,0,0,1-.13-.15.57.57,0,0,1-.07-.22l0-.31c0-.11,0-.21,0-.31a1.41,1.41,0,0,1,0-.28,1.21,1.21,0,0,1,.11-.3,1.41,1.41,0,0,1,.18-.27A1.24,1.24,0,0,1,210.82,323.64Zm1.74-.87.06-.11a.26.26,0,0,1,.09-.09l.26-.15s.06,0,.08,0,0,0,0,.07a0,0,0,0,0,0,0v0l-1.89,4.85a.54.54,0,0,1-.06.11l-.09.09-.26.15a.12.12,0,0,1-.08,0s0,0,0-.07v0a.08.08,0,0,1,0,0Zm-1.43,2v-.41a.54.54,0,0,1,0-.11.26.26,0,0,0-.07-.15s-.1,0-.18,0a.36.36,0,0,0-.17.18.54.54,0,0,0,0,.22v.11a664109906293.2,664109906293.2,0,0,1,0,.3c0,.05,0,.08,0,.1a.34.34,0,0,0,.07.16s.1,0,.18,0a.35.35,0,0,0,.17-.17A.57.57,0,0,0,211.13,324.77Zm1.7-.26a.6.6,0,0,1,.28-.1.36.36,0,0,1,.21,0,.28.28,0,0,1,.13.15.52.52,0,0,1,.07.22l0,.3c0,.11,0,.22,0,.32a1.41,1.41,0,0,1,0,.28,1,1,0,0,1-.11.29,1.27,1.27,0,0,1-.18.27,1,1,0,0,1-.28.22.6.6,0,0,1-.28.1.3.3,0,0,1-.21,0,.32.32,0,0,1-.13-.15.57.57,0,0,1-.07-.22l0-.31c0-.11,0-.21,0-.31a1.41,1.41,0,0,1,0-.28,1.21,1.21,0,0,1,.11-.3,2.11,2.11,0,0,1,.18-.27A1,1,0,0,1,212.83,324.51Zm.31,1.12v-.41s0-.08,0-.1A.34.34,0,0,0,213,325s-.1,0-.18,0a.4.4,0,0,0-.17.17.62.62,0,0,0,0,.23v.11a.76.76,0,0,0,0,.15.76.76,0,0,0,0,.15s0,.08,0,.1a.34.34,0,0,0,.07.16s.1,0,.18,0a.31.31,0,0,0,.17-.17A.59.59,0,0,0,213.14,325.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.62,318.11l-2.6,2.66a9.31,9.31,0,0,1,.43,2.3,13.29,13.29,0,0,1-.09,2.59c0,.33-.1.66-.16,1a17.33,17.33,0,0,1-2,5.26c-.17.29-.35.57-.53.85a12.26,12.26,0,0,1-3.53,3.6l-.35.23a3.84,3.84,0,0,1-.35.18,5.3,5.3,0,0,1-3.73.59,3.86,3.86,0,0,1-.6-.21,4.91,4.91,0,0,1-2.51-2.66c-.1-.23-.2-.48-.28-.73a9.79,9.79,0,0,1-.43-2.3,14.14,14.14,0,0,1,.1-2.59c0-.33.09-.66.16-1a17.33,17.33,0,0,1,2-5.26c.17-.29.34-.57.53-.85a12.23,12.23,0,0,1,3.52-3.6l-.24-3.61a17.17,17.17,0,0,0-5.13,5.25c-.18.28-.36.57-.53.86a23.63,23.63,0,0,0-2.87,7.64c-.06.32-.11.65-.16,1a18.52,18.52,0,0,0-.15,3.78,13.66,13.66,0,0,0,.64,3.34c.08.25.17.49.27.73a6.85,6.85,0,0,0,3.66,3.87,6,6,0,0,0,.6.2,7.41,7.41,0,0,0,5.43-.84l.35-.2c.12-.06.23-.14.35-.21a17.17,17.17,0,0,0,5.13-5.25c.18-.28.35-.56.52-.85a24,24,0,0,0,2.88-7.65c.06-.32.11-.65.16-1a19.26,19.26,0,0,0,.15-3.78A13.66,13.66,0,0,0,218.62,318.11Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,312.67c-.19-.07-.39-.14-.6-.2a7.77,7.77,0,0,0-5.79.91l0,.78.24,3.6.06.81a4.81,4.81,0,0,1,3.35-.52,3.82,3.82,0,0,1,.6.19,4.47,4.47,0,0,1,2.25,2.4l.59-.6,2.6-2.66.56-.57A7.27,7.27,0,0,0,215,312.67Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.9,344a.13.13,0,0,1,0-.1.28.28,0,0,1,0-.12l.88-1.5.06-.11s.05-.06.08-.07l.34-.2a.06.06,0,0,1,.08,0,.11.11,0,0,1,.05.09l.24,3.59a.22.22,0,0,1,0,.13.22.22,0,0,1-.07.09l-.36.2a.06.06,0,0,1-.08,0s0,0,0-.08l-.19-2.75-.57,1a.22.22,0,0,1-.09.08.08.08,0,0,1-.08,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.37,341.6a2.32,2.32,0,0,0,0,.24v.26l0,.26a1.85,1.85,0,0,1,0,.23,3.5,3.5,0,0,1,0,.65,2.48,2.48,0,0,1-.17.59,1.91,1.91,0,0,1-.33.52,2.31,2.31,0,0,1-.53.43,1.24,1.24,0,0,1-.55.19.51.51,0,0,1-.37-.11.73.73,0,0,1-.23-.36,2.21,2.21,0,0,1-.12-.56c0-.14,0-.29,0-.47s0-.35,0-.49a4.63,4.63,0,0,1,0-.65,2.06,2.06,0,0,1,.17-.6,2,2,0,0,1,.33-.53,1.92,1.92,0,0,1,.53-.43,1.17,1.17,0,0,1,.54-.19.49.49,0,0,1,.38.11.8.8,0,0,1,.23.36A3.49,3.49,0,0,1,182.37,341.6Zm-1.69,2a1,1,0,0,0,.2.53c.09.1.24.09.44,0a1,1,0,0,0,.42-.47,2.08,2.08,0,0,0,.11-.71c0-.14,0-.3,0-.47s0-.32,0-.46a.92.92,0,0,0-.19-.53c-.1-.1-.24-.09-.45,0a.87.87,0,0,0-.41.46,1.93,1.93,0,0,0-.11.71c0,.15,0,.3,0,.47S180.67,343.44,180.68,343.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.34,339.5a.79.79,0,0,1,.28-.1.46.46,0,0,1,.21.05.34.34,0,0,1,.14.15.77.77,0,0,1,.06.23,1.39,1.39,0,0,1,0,.3c0,.11,0,.21,0,.31a1.55,1.55,0,0,1,0,.29,1.25,1.25,0,0,1-.1.29,1.48,1.48,0,0,1-.19.27,1.44,1.44,0,0,1-.27.22.77.77,0,0,1-.29.1.31.31,0,0,1-.2,0,.36.36,0,0,1-.14-.16.71.71,0,0,1-.07-.22q0-.13,0-.3c0-.11,0-.22,0-.32a1.41,1.41,0,0,1,0-.28,1.45,1.45,0,0,1,.11-.29,1,1,0,0,1,.19-.27A1,1,0,0,1,183.34,339.5Zm1.75-.87.06-.11a.24.24,0,0,1,.09-.08l.26-.15a.13.13,0,0,1,.08,0,.08.08,0,0,1,0,.07v0s0,0,0,0l-1.9,4.85a.67.67,0,0,1-.06.12.36.36,0,0,1-.09.08l-.26.15a.08.08,0,0,1-.08,0,.06.06,0,0,1,0-.06v0s0,0,0,0Zm-1.43,2a.49.49,0,0,0,0-.11v-.3c0-.05,0-.08,0-.1a.24.24,0,0,0-.07-.16s-.09,0-.18,0a.42.42,0,0,0-.17.18.85.85,0,0,0,0,.22v.11c0,.05,0,.1,0,.15s0,.1,0,.15a.56.56,0,0,0,0,.1.27.27,0,0,0,.06.16s.1,0,.18,0a.36.36,0,0,0,.17-.18A.79.79,0,0,0,183.66,340.63Zm1.69-.26a.79.79,0,0,1,.28-.1.36.36,0,0,1,.21.05.34.34,0,0,1,.14.15.77.77,0,0,1,.06.23,1.39,1.39,0,0,1,0,.3c0,.11,0,.21,0,.31a.9.9,0,0,1,0,.28,1.18,1.18,0,0,1-.1.3,1.48,1.48,0,0,1-.19.27,1.52,1.52,0,0,1-.27.22.79.79,0,0,1-.28.1.46.46,0,0,1-.21,0,.36.36,0,0,1-.14-.16,1.42,1.42,0,0,1-.07-.22c0-.09,0-.2,0-.31s0-.21,0-.31a1.41,1.41,0,0,1,0-.28,1.45,1.45,0,0,1,.11-.29,1.26,1.26,0,0,1,.19-.28A1,1,0,0,1,185.35,340.37Zm.32,1.13a.49.49,0,0,0,0-.11v-.3a.25.25,0,0,0,0-.1.22.22,0,0,0-.07-.16s-.09,0-.18,0a.42.42,0,0,0-.17.18.78.78,0,0,0,0,.22v.11c0,.05,0,.1,0,.15s0,.1,0,.15a.56.56,0,0,0,0,.1.24.24,0,0,0,.07.16s.09,0,.18,0a.39.39,0,0,0,.16-.18A.59.59,0,0,0,185.67,341.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.47,329.05l.05.77.25,3.61,0,.81a4.87,4.87,0,0,1,3.35-.53l.33-.87L187,329l.31-.84A7.77,7.77,0,0,0,181.47,329.05Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.47,329.05l.05.77.25,3.61,0,.81a4.87,4.87,0,0,1,3.35-.53l.33-.87L187,329l.31-.84A7.77,7.77,0,0,0,181.47,329.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M191.48,333.78c-.08-.25-.17-.49-.27-.73a6.85,6.85,0,0,0-3.66-3.87l-1.45,3.87a4.91,4.91,0,0,1,2.51,2.66c.1.23.19.48.28.73a9.82,9.82,0,0,1,.42,2.29,13.36,13.36,0,0,1-.09,2.6c0,.33-.1.66-.16,1a17.17,17.17,0,0,1-2,5.25c-.17.3-.35.58-.53.86A12.38,12.38,0,0,1,183,352l-.34.23-.36.18a5.28,5.28,0,0,1-3.73.58,3.52,3.52,0,0,1-.6-.2,4.91,4.91,0,0,1-2.51-2.66c-.1-.23-.19-.48-.28-.73a9.81,9.81,0,0,1-.42-2.3,13.29,13.29,0,0,1,.09-2.59c0-.33.1-.66.16-1a17.23,17.23,0,0,1,2-5.26c.17-.29.35-.57.53-.85a12.42,12.42,0,0,1,3.53-3.61l-.25-3.6a17.17,17.17,0,0,0-5.13,5.25c-.18.28-.36.56-.53.85a23.77,23.77,0,0,0-2.87,7.65c-.06.32-.11.65-.16,1a19.39,19.39,0,0,0-.15,3.79,13.48,13.48,0,0,0,.64,3.33c.08.26.17.5.27.74a6.8,6.8,0,0,0,3.66,3.86l.6.21a7.37,7.37,0,0,0,5.43-.85l.35-.19c.12-.06.23-.14.35-.21a17.29,17.29,0,0,0,5.13-5.25c.18-.28.36-.57.53-.86a23.63,23.63,0,0,0,2.87-7.64c.06-.32.11-.65.16-1a19.26,19.26,0,0,0,.15-3.78A13.66,13.66,0,0,0,191.48,333.78Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,298.62,168.28,381c-.35.2-.67,0-.7-.45v-.12a1.34,1.34,0,0,1,.58-1.19l142.73-82.4c.35-.21.66,0,.69.45v.12A1.39,1.39,0,0,1,311,298.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.32,303.18l-142.73,82.4c-.35.21-.66,0-.69-.45V385a1.39,1.39,0,0,1,.58-1.19l142.73-82.4c.35-.2.66,0,.69.45V302A1.38,1.38,0,0,1,311.32,303.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.92,181.63l-4.06-2.34-159.31,92a5.65,5.65,0,0,0-2.44,3.46,4.37,4.37,0,0,0-.09.5,3.55,3.55,0,0,0,0,.46c0,.07,0,.15,0,.23l.41,6,4.07,2.35,162.06-93.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.92,181.63l-159.3,92a5.41,5.41,0,0,0-2.11,2.47l-4.06-2.35a5.27,5.27,0,0,0-.34,1,5.65,5.65,0,0,1,2.44-3.46l159.31-92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.07,278.23l.41,6-4.07-2.35-.41-6c0-.08,0-.16,0-.23a3.55,3.55,0,0,1,0-.46,4.37,4.37,0,0,1,.09-.5,5.27,5.27,0,0,1,.34-1l4.06,2.35A4.64,4.64,0,0,0,151.07,278.23Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Glass--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--glass--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.78,102.8h0a2.25,2.25,0,0,1-.34-2.26,7.08,7.08,0,0,1,4.6-4.49,2.22,2.22,0,0,1,2.25.4h0l28.14,26.65h0a3.08,3.08,0,0,1,.58,3.25,9.93,9.93,0,0,1-6.44,6.28,3.09,3.09,0,0,1-3.24-.66h0Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,96.05c2-.51,3.15.68,2.6,2.66A7.14,7.14,0,0,1,286,103.2c-2,.5-3.15-.69-2.59-2.66A7.08,7.08,0,0,1,288,96.05Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M288,96.05c2-.51,3.15.68,2.6,2.66A7.14,7.14,0,0,1,286,103.2c-2,.5-3.15-.69-2.59-2.66A7.08,7.08,0,0,1,288,96.05Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M275.89,91a4.31,4.31,0,0,1,2.78-2.72,1.35,1.35,0,0,1,1.36.25h0l9,9.18h0a1.38,1.38,0,0,1,.2,1.37,4.27,4.27,0,0,1-2.78,2.71,1.35,1.35,0,0,1-1.36-.24l-9-9.17h0A1.38,1.38,0,0,1,275.89,91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.67,88.28a2.85,2.85,0,0,0-.46.17l-.08,0a3.72,3.72,0,0,0-.39.21l0,0A4.24,4.24,0,0,0,275.89,91a1.38,1.38,0,0,0,.2,1.37l2.15,2.2a14.78,14.78,0,0,0,2.16-1.75l7.93,7.74a3.77,3.77,0,0,0,.88-1.49,1.38,1.38,0,0,0-.2-1.37h0l-9-9.18h0A1.35,1.35,0,0,0,278.67,88.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.74,100.49l28.41,27.78a7.81,7.81,0,0,0,.87-1.92,3.06,3.06,0,0,0-.59-3.25h0L290.3,96.45a2.28,2.28,0,0,1,.34,2.26A6.1,6.1,0,0,1,289.74,100.49Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.74,100.49l28.41,27.78a7.81,7.81,0,0,0,.87-1.92,3.06,3.06,0,0,0-.59-3.25h0L290.3,96.45a2.28,2.28,0,0,1,.34,2.26A6.1,6.1,0,0,1,289.74,100.49Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M249.26,107.26c4.55,2.62,10.82,2.24,17.76-1.76,13.87-8,25.11-27.48,25.11-43.5,0-8-2.81-13.63-7.35-16.25h0l-5.1-3c-4.55-2.62-10.83-2.24-17.76,1.76-13.87,8-25.11,27.48-25.11,43.5,0,8,2.81,13.63,7.35,16.25l5.1,3ZM288.7,62c0,7.16-2.45,15.34-6.9,23S271.5,99,265.3,102.52c-5.6,3.24-10.69,3.86-14.32,1.76s-5.64-6.81-5.64-13.28c0-7.15,2.45-15.33,6.9-23s10.3-13.91,16.5-17.49c5.6-3.23,10.68-3.86,14.32-1.76S288.7,55.54,288.7,62Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.26,107.26c4.55,2.62,10.82,2.24,17.76-1.76,13.87-8,25.11-27.48,25.11-43.5,0-8-2.81-13.63-7.35-16.25h0l-5.1-3c-4.55-2.62-10.83-2.24-17.76,1.76-13.87,8-25.11,27.48-25.11,43.5,0,8,2.81,13.63,7.35,16.25l5.1,3ZM288.7,62c0,7.16-2.45,15.34-6.9,23S271.5,99,265.3,102.52c-5.6,3.24-10.69,3.86-14.32,1.76s-5.64-6.81-5.64-13.28c0-7.15,2.45-15.33,6.9-23s10.3-13.91,16.5-17.49c5.6-3.23,10.68-3.86,14.32-1.76S288.7,55.54,288.7,62Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,47.5c-13.87,8-25.11,27.48-25.11,43.5s11.24,22.5,25.11,14.5S292.13,78,292.13,62,280.89,39.5,267,47.5Zm16,1.22c3.63,2.1,5.64,6.82,5.64,13.28,0,7.15-2.45,15.33-6.9,23S271.5,99,265.3,102.52c-5.6,3.24-10.68,3.86-14.32,1.76s-5.64-6.81-5.64-13.28c0-7.15,2.45-15.33,6.9-23s10.3-13.92,16.5-17.49C274.34,47.25,279.42,46.62,283.06,48.72Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,47.5c-13.87,8-25.11,27.48-25.11,43.5s11.24,22.5,25.11,14.5S292.13,78,292.13,62,280.89,39.5,267,47.5Zm16,1.22c3.63,2.1,5.64,6.82,5.64,13.28,0,7.15-2.45,15.33-6.9,23S271.5,99,265.3,102.52c-5.6,3.24-10.68,3.86-14.32,1.76s-5.64-6.81-5.64-13.28c0-7.15,2.45-15.33,6.9-23s10.3-13.92,16.5-17.49C274.34,47.25,279.42,46.62,283.06,48.72Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.91,91c0-10.51,4.84-22.51,12.09-31.78l-.06.07-5.08-2.95c-7.23,9.26-12.05,21.22-12.05,31.71,0,8,2.81,13.63,7.36,16.25l5.09,3h0l.27.15C244.83,104.85,241.91,99.16,241.91,91Z",
    style: {
      fill: "#90CAF9",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.06,48.72a9.46,9.46,0,0,0-4.88-1.22,19.29,19.29,0,0,1,2.14,9.67c0,7.15-2.44,15.33-6.89,23s-10.31,13.91-16.5,17.48a19.52,19.52,0,0,1-9.45,3,9.57,9.57,0,0,0,3.5,3.61c3.63,2.1,8.72,1.48,14.33-1.76C271.49,99,277.36,92.74,281.8,85s6.9-15.89,6.9-23C288.7,55.53,286.7,50.82,283.06,48.72Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.91,59.81c0,7.16-2.45,15.34-6.9,23s-10.3,13.91-16.5,17.48c-4.62,2.67-8.89,3.56-12.28,2.61-2.52-2.47-3.89-6.61-3.89-11.94,0-7.15,2.45-15.33,6.9-23s10.3-13.92,16.5-17.49c4.62-2.67,8.89-3.56,12.28-2.61C283.54,50.34,284.91,54.48,284.91,59.81Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.61,46.27a3.15,3.15,0,0,1,.29.22h0l-.48-.34-.2-.14.25.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,46.56a1.12,1.12,0,0,1,.21.17,2.37,2.37,0,0,0-.3-.23h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.31,47.7h0l-.45-.42a3.45,3.45,0,0,1,.28.26Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Documents--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--line--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.72,282.64a.5.5,0,0,0-.5.5v38.93L399,340.69a.51.51,0,0,0-.19.68.51.51,0,0,0,.44.25.57.57,0,0,0,.25-.06L432,322.79a.47.47,0,0,0,.25-.43V283.14A.5.5,0,0,0,431.72,282.64Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.72,282.64a.5.5,0,0,0-.5.5v38.93L399,340.69a.51.51,0,0,0-.19.68.51.51,0,0,0,.44.25.57.57,0,0,0,.25-.06L432,322.79a.47.47,0,0,0,.25-.43V283.14A.5.5,0,0,0,431.72,282.64Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.69,284.31a4.51,4.51,0,0,1,2-3.52c1.12-.64,2-.12,2,1.18a4.47,4.47,0,0,1-2,3.51C430.6,286.13,429.69,285.61,429.69,284.31Z",
    style: {
      fill: "#90CAF9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Document--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sheet--inject-44"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "338.34 91.48 336.27 90.29 428.98 36.76 431.05 37.95 338.34 91.48",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.05 37.95 431.05 180.34 338.3 233.89 338.34 91.48 431.05 37.95",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.55,38.81V180.06l-91.76,53,0-141.27,91.72-52.95m.5-.86L338.34,91.48l0,142.41,92.75-53.55V38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.34 91.48 338.3 233.89 336.29 232.73 336.27 90.29 338.3 91.45 338.34 91.48",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357,130.1c.05,0,.09,0,.12,0a.17.17,0,0,1,.05.13v.55a1.37,1.37,0,0,1,0,.19c0,.06-.05.15-.08.27l-1.45,5.29a.85.85,0,0,1-.06.17.3.3,0,0,1-.12.13l-.52.3a.09.09,0,0,1-.12,0,.14.14,0,0,1-.05-.13s0-.05,0-.11l1.46-5.3-2,1.13a.11.11,0,0,1-.12,0,.18.18,0,0,1-.05-.14V132a.45.45,0,0,1,.05-.18.28.28,0,0,1,.12-.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.07,129.94v1.48a6,6,0,0,1-.12,1,3.35,3.35,0,0,1-.28.88,3.22,3.22,0,0,1-.51.77,3.17,3.17,0,0,1-.77.62,1.91,1.91,0,0,1-.78.27.64.64,0,0,1-.51-.18,1.06,1.06,0,0,1-.28-.55,3.41,3.41,0,0,1-.11-.83c0-.21,0-.45,0-.71s0-.52,0-.73a5.24,5.24,0,0,1,.11-1,3.42,3.42,0,0,1,.28-.89,3.11,3.11,0,0,1,1.29-1.41,1.7,1.7,0,0,1,.77-.27.64.64,0,0,1,.51.18,1,1,0,0,1,.28.55A3.84,3.84,0,0,1,361.07,129.94Zm-2.52,2.89a1.4,1.4,0,0,0,.21.8c.13.15.33.14.63,0a1.41,1.41,0,0,0,.62-.68,3.16,3.16,0,0,0,.21-1.06c0-.21,0-.45,0-.7s0-.49,0-.69a1.47,1.47,0,0,0-.21-.81c-.13-.15-.33-.14-.62,0a1.45,1.45,0,0,0-.63.69,3.15,3.15,0,0,0-.21,1.05c0,.22,0,.45,0,.71S358.54,132.62,358.55,132.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.61,126.83a.87.87,0,0,1,.4-.14.52.52,0,0,1,.29.07.51.51,0,0,1,.17.23,1,1,0,0,1,.07.34c0,.14,0,.29,0,.46s0,.32,0,.46a1.54,1.54,0,0,1-.07.42,2.35,2.35,0,0,1-.17.44,2.13,2.13,0,0,1-.29.4,1.38,1.38,0,0,1-.4.31,1,1,0,0,1-.4.15.51.51,0,0,1-.28-.07.47.47,0,0,1-.18-.23,1.21,1.21,0,0,1-.07-.34c0-.14,0-.29,0-.46s0-.32,0-.46a2,2,0,0,1,.07-.42,1.85,1.85,0,0,1,.18-.44,2.63,2.63,0,0,1,.28-.4A1.76,1.76,0,0,1,362.61,126.83Zm2.51-1.25a1.31,1.31,0,0,1,.09-.17.51.51,0,0,1,.13-.12l.38-.21a.12.12,0,0,1,.11,0,.13.13,0,0,1,0,.1s0,0,0,0a.14.14,0,0,1,0,.06l-3.08,7.2a1.14,1.14,0,0,1-.09.16.33.33,0,0,1-.14.12l-.37.22a.12.12,0,0,1-.11,0,.11.11,0,0,1,0-.1v0l0-.06Zm-2.18,2.94a.71.71,0,0,0,0-.16v-.45a.62.62,0,0,0,0-.16.32.32,0,0,0-.08-.23c0-.06-.13,0-.25,0a.59.59,0,0,0-.25.27,1.14,1.14,0,0,0-.08.33s0,.09,0,.16v.45c0,.07,0,.12,0,.15a.45.45,0,0,0,.08.24c.05.05.13,0,.25,0a.56.56,0,0,0,.25-.26A.8.8,0,0,0,362.94,128.52Zm2.38-.33a.8.8,0,0,1,.4-.14.51.51,0,0,1,.28.07.52.52,0,0,1,.18.23,1.28,1.28,0,0,1,.07.34c0,.14,0,.29,0,.46s0,.32,0,.47a2.3,2.3,0,0,1-.07.42,1.78,1.78,0,0,1-.18.43,2.63,2.63,0,0,1-.28.4,2.08,2.08,0,0,1-.4.32,1,1,0,0,1-.4.14.45.45,0,0,1-.29-.07.51.51,0,0,1-.17-.23,1.21,1.21,0,0,1-.07-.34c0-.14,0-.29,0-.45s0-.32,0-.47a2,2,0,0,1,.07-.42,2.35,2.35,0,0,1,.17-.44,2.13,2.13,0,0,1,.29-.4A1.61,1.61,0,0,1,365.32,128.19Zm.33,1.69v-.77a.44.44,0,0,0-.08-.23c-.05,0-.13,0-.25,0a.52.52,0,0,0-.25.26.89.89,0,0,0-.08.33.67.67,0,0,0,0,.16c0,.07,0,.15,0,.23s0,.15,0,.22a.58.58,0,0,0,0,.15.38.38,0,0,0,.08.24c0,.05.13,0,.25,0a.62.62,0,0,0,.25-.26A1.23,1.23,0,0,0,365.65,129.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.34,120.66a35.79,35.79,0,0,0-4.88,11.75,28.58,28.58,0,0,0-.65,5.9,19.12,19.12,0,0,0,.65,5.15l3.34-3.37a13.63,13.63,0,0,1-.49-3.8,20.59,20.59,0,0,1,.49-4.36,26.44,26.44,0,0,1,3.6-8.68,18,18,0,0,1,5.82-5.89v-4.67A24.3,24.3,0,0,0,352.34,120.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,117.68c-.88-3.11-2.61-5.23-4.87-6.12s-4.94-.57-7.88,1.13v4.67a6.66,6.66,0,0,1,5.82-.83,6.42,6.42,0,0,1,3.6,4.52,14,14,0,0,1,.49,3.8,21.11,21.11,0,0,1-.49,4.36,26.44,26.44,0,0,1-3.6,8.68,18.1,18.1,0,0,1-5.82,5.89,6.66,6.66,0,0,1-5.82.83,6.42,6.42,0,0,1-3.6-4.52l-3.34,3.37c.89,3.12,2.61,5.23,4.88,6.12s4.93.57,7.88-1.13a24.4,24.4,0,0,0,7.88-8A35.77,35.77,0,0,0,373,128.73a27.93,27.93,0,0,0,.66-5.9A18.71,18.71,0,0,0,373,117.68Z",
    style: {
      fill: "#90CAF9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.86,178.76a3.52,3.52,0,0,1-.54.67,3.66,3.66,0,0,1-.67.52,2.69,2.69,0,0,1-.76.3,1,1,0,0,1-.54-.05.68.68,0,0,1-.33-.3,1.42,1.42,0,0,1-.13-.47.41.41,0,0,1,.05-.18.43.43,0,0,1,.12-.14l.49-.28c.05,0,.08,0,.11,0a.35.35,0,0,1,.08.11.64.64,0,0,0,.1.13.38.38,0,0,0,.17.06.53.53,0,0,0,.26,0,1.77,1.77,0,0,0,.38-.18,1.73,1.73,0,0,0,.61-.56,1.19,1.19,0,0,0,.24-.71c0-.25-.08-.38-.24-.4a1,1,0,0,0-.61.19l-.52.3q-.08,0-.12,0a.16.16,0,0,1-.05-.13V177a.58.58,0,0,1,.05-.2,1.5,1.5,0,0,1,.09-.18l.87-1.73-1.72,1q-.08,0-.12,0a.16.16,0,0,1-.05-.13v-.59a.41.41,0,0,1,.05-.18.28.28,0,0,1,.12-.14l2.73-1.58s.09,0,.12,0a.14.14,0,0,1,0,.13V174a.51.51,0,0,1,0,.2,1.07,1.07,0,0,0-.09.19l-.92,1.81a1.34,1.34,0,0,1,.51-.12.73.73,0,0,1,.39.13.68.68,0,0,1,.25.35,1.76,1.76,0,0,1,.09.6,2.74,2.74,0,0,1-.13.85A3.15,3.15,0,0,1,356.86,178.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.88,177.91a.72.72,0,0,1-.51-.18,1.19,1.19,0,0,1-.28-.55,4,4,0,0,1-.11-.84c0-.2,0-.44,0-.71s0-.51,0-.73a6,6,0,0,1,.11-1,3.78,3.78,0,0,1,.28-.9,3.27,3.27,0,0,1,.51-.78,2.85,2.85,0,0,1,.78-.62,2,2,0,0,1,.55-.23v1.21c-.13-.09-.3-.09-.55.06a1.32,1.32,0,0,0-.62.68,2.92,2.92,0,0,0-.22,1.06c0,.21,0,.45,0,.7s0,.49,0,.7a1.37,1.37,0,0,0,.22.8c.12.15.32.14.62,0a1.48,1.48,0,0,0,.55-.56v1.19a3.28,3.28,0,0,1-.55.41A1.8,1.8,0,0,1,358.88,177.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.28,175.9a3.15,3.15,0,0,0,.21-1.05c0-.22,0-.45,0-.71s0-.48,0-.69a1.43,1.43,0,0,0-.21-.8s0,0-.07,0v-1.21a.87.87,0,0,1,.22,0,.64.64,0,0,1,.51.18,1.15,1.15,0,0,1,.29.55,4.78,4.78,0,0,1,.11.83v1.48a7.41,7.41,0,0,1-.11,1,3.64,3.64,0,0,1-.29.88,3,3,0,0,1-.51.77c-.07.08-.15.14-.22.21V176S360.26,176,360.28,175.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.57,169.75a.45.45,0,0,0-.29-.08.93.93,0,0,0-.39.14,1.65,1.65,0,0,0-.41.33,1.91,1.91,0,0,0-.28.4,1.75,1.75,0,0,0-.17.43,2.37,2.37,0,0,0-.08.42c0,.15,0,.31,0,.47s0,.32,0,.46a1.14,1.14,0,0,0,.08.33.45.45,0,0,0,.17.23.38.38,0,0,0,.28.07.87.87,0,0,0,.41-.14,1.52,1.52,0,0,0,.39-.32,1.8,1.8,0,0,0,.29-.39,2,2,0,0,0,.17-.44,1.67,1.67,0,0,0,.07-.42c0-.15,0-.3,0-.47s0-.31,0-.45a.89.89,0,0,0-.07-.34A.45.45,0,0,0,363.57,169.75Zm-.35,1.59v.16a.9.9,0,0,1-.09.33.55.55,0,0,1-.24.26c-.13.07-.21.08-.25,0a.37.37,0,0,1-.09-.23,1.1,1.1,0,0,0,0-.16v-.45a1,1,0,0,0,0-.16.9.9,0,0,1,.09-.33.52.52,0,0,1,.25-.26c.11-.07.2-.08.24,0a.38.38,0,0,1,.09.24v.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.66,172.75c0,.15,0,.31,0,.47s0,.32,0,.46a1.28,1.28,0,0,0,.07.34.58.58,0,0,0,.17.23.54.54,0,0,0,.29.07,1.05,1.05,0,0,0,.4-.15,1.57,1.57,0,0,0,.4-.32,1.75,1.75,0,0,0,.28-.39,1.85,1.85,0,0,0,.18-.44,2.3,2.3,0,0,0,.07-.42c0-.15,0-.3,0-.47s0-.31,0-.45a1.14,1.14,0,0,0-.07-.34.47.47,0,0,0-.18-.23A.42.42,0,0,0,366,171a.84.84,0,0,0-.4.14,1.26,1.26,0,0,0-.4.32,1.91,1.91,0,0,0-.46.83A2.3,2.3,0,0,0,364.66,172.75Zm.59.12v-.22a.76.76,0,0,1,0-.17.94.94,0,0,1,.08-.33.56.56,0,0,1,.25-.26c.12-.07.2-.08.25,0a.45.45,0,0,1,.08.24s0,.08,0,.15v.45c0,.08,0,.13,0,.16a1.14,1.14,0,0,1-.08.33.59.59,0,0,1-.25.27c-.12.07-.21.08-.25,0a.37.37,0,0,1-.08-.23.62.62,0,0,1,0-.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.3,175.76l3.09-7.19a.87.87,0,0,1,.09-.17.37.37,0,0,1,.13-.12l.38-.22a.16.16,0,0,1,.11,0,.13.13,0,0,1,0,.1.09.09,0,0,1,0,.05.14.14,0,0,1,0,.06L363,175.44a1.31,1.31,0,0,1-.09.17.33.33,0,0,1-.14.12l-.37.22c-.05,0-.08,0-.11,0s0,0,0-.09v-.05A.14.14,0,0,0,362.3,175.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.22 160.5 360.21 160.51 360.21 155.84 360.22 155.83 360.22 160.5",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.13,168a14.12,14.12,0,0,0-.49-3.8,6.38,6.38,0,0,0-3.6-4.51,6.62,6.62,0,0,0-5.82.82v-4.67c2.94-1.7,5.67-2,7.88-1.13s4,3,4.87,6.12a18.71,18.71,0,0,1,.66,5.15,27.93,27.93,0,0,1-.66,5.9l-3.33.48A21.11,21.11,0,0,0,370.13,168Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.22 186.92 360.22 191.59 360.21 191.6 360.21 186.93 360.22 186.92",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.34,163.8a35.87,35.87,0,0,0-4.88,11.75,28.73,28.73,0,0,0-.65,5.9,19.07,19.07,0,0,0,.65,5.15c.89,3.12,2.61,5.24,4.88,6.13s4.93.56,7.87-1.13v-4.67a6.67,6.67,0,0,1-5.81.82,6.4,6.4,0,0,1-3.6-4.52,13.63,13.63,0,0,1-.49-3.8,20.59,20.59,0,0,1,.49-4.36,26.53,26.53,0,0,1,3.6-8.68,18,18,0,0,1,5.81-5.88v-4.67A24.44,24.44,0,0,0,352.34,163.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.64,172.35A26.44,26.44,0,0,1,366,181a18.1,18.1,0,0,1-5.82,5.89v4.67a24.46,24.46,0,0,0,7.88-8A35.91,35.91,0,0,0,373,171.87Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--check-list--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.25,106.67a.41.41,0,0,1-.19,0,.4.4,0,0,1-.2-.33V99a.38.38,0,0,1,.2-.33l6.29-3.64a.42.42,0,0,1,.38,0,.4.4,0,0,1,.2.34v7.26a.4.4,0,0,1-.2.34l-6.29,3.63A.41.41,0,0,1,386.25,106.67Zm.39-7.43v6.37l5.51-3.18V96.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Check--inject-44",
    d: "M393.28,93.57a.76.76,0,0,0-1,.41l-2.88,6.86-.69-.67a.76.76,0,0,0-1.08,0,.75.75,0,0,0,0,1.07l1.48,1.45a.79.79,0,0,0,.54.22l.15,0a.76.76,0,0,0,.55-.45l3.32-7.89A.76.76,0,0,0,393.28,93.57Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.89,94.84,421,81.47c.55-.32,1-.09,1,.52a2.17,2.17,0,0,1-1,1.67L397.89,97c-.56.32-1,.09-1-.51A2.15,2.15,0,0,1,397.89,94.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.25,117.57a.41.41,0,0,1-.19,0,.4.4,0,0,1-.2-.34v-7.26a.4.4,0,0,1,.2-.34l6.29-3.63a.37.37,0,0,1,.38,0,.4.4,0,0,1,.2.34v7.26a.37.37,0,0,1-.2.33l-6.29,3.64A.41.41,0,0,1,386.25,117.57Zm.39-7.43v6.37l5.51-3.18V107Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--check--inject-44",
    d: "M393.28,104.46a.76.76,0,0,0-1,.41l-2.88,6.86-.69-.66a.76.76,0,1,0-1.06,1.09l1.48,1.45a.78.78,0,0,0,.54.21h.15a.76.76,0,0,0,.55-.45l3.32-7.9A.77.77,0,0,0,393.28,104.46Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.89,105.7,421,92.34c.55-.33,1-.1,1,.51a2.18,2.18,0,0,1-1,1.68l-23.15,13.36c-.56.32-1,.09-1-.51A2.15,2.15,0,0,1,397.89,105.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.25,128.47a.33.33,0,0,1-.19-.06.38.38,0,0,1-.2-.33v-7.27a.4.4,0,0,1,.2-.33l6.29-3.63a.37.37,0,0,1,.38,0,.38.38,0,0,1,.2.33v7.27a.4.4,0,0,1-.2.33l-6.29,3.63A.33.33,0,0,1,386.25,128.47Zm.39-7.43v6.37l5.51-3.19v-6.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--check--inject-44",
    d: "M393.28,115.36a.76.76,0,0,0-1,.41l-2.88,6.86-.69-.67a.77.77,0,0,0-1.08,0,.76.76,0,0,0,0,1.08l1.48,1.44a.79.79,0,0,0,.54.22l.15,0a.76.76,0,0,0,.55-.45l3.32-7.89A.76.76,0,0,0,393.28,115.36Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.89,116.56,421,103.2c.55-.32,1-.09,1,.51a2.17,2.17,0,0,1-1,1.68l-23.15,13.36c-.56.32-1,.09-1-.51A2.18,2.18,0,0,1,397.89,116.56Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "389.32 174.39 385.58 176.55 385.58 134.73 389.32 132.57 389.32 174.39",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.92 170.58 392.18 172.74 392.18 130.92 395.92 128.76 395.92 170.58",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.52 166.77 398.78 168.93 398.78 127.11 402.52 124.95 402.52 166.77",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.12 162.96 405.38 165.12 405.38 123.3 409.12 121.14 409.12 162.96",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.72 159.15 411.98 161.3 411.98 119.49 415.72 117.33 415.72 159.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.32 155.33 418.58 157.49 418.58 115.67 422.32 113.52 422.32 155.33",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.58 115.67 422.32 113.52 422.32 132.6 418.58 134.76 418.58 115.67",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.58 143.86 389.32 141.7 389.32 165.05 385.58 167.21 385.58 143.86",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.58 167.21 389.32 165.05 389.32 174.39 385.58 176.55 385.58 167.21",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.18 145.36 395.92 143.2 395.92 151.6 392.18 153.76 392.18 145.36",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.18 153.76 395.92 151.6 395.92 170.58 392.18 172.74 392.18 153.76",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.78 130.61 402.52 128.45 402.52 135.78 398.78 137.94 398.78 130.61",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.78 137.94 402.52 135.78 402.52 166.77 398.78 168.93 398.78 137.94",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.38 132.43 409.12 130.27 409.12 148.75 405.38 150.91 405.38 132.43",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.38 150.91 409.12 148.75 409.12 162.96 405.38 165.12 405.38 150.91",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.98 136.12 415.72 133.96 415.72 141.78 411.98 143.94 411.98 136.12",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.98 143.94 415.72 141.78 415.72 159.15 411.98 161.3 411.98 143.94",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.58 134.76 422.32 132.6 422.32 155.33 418.58 157.49 418.58 134.76",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.58 167.21 389.32 165.05 389.32 174.39 385.58 176.55 385.58 167.21",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.58 167.21 389.32 165.05 389.32 174.39 385.58 176.55 385.58 167.21",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.18 153.76 395.92 151.6 395.92 170.58 392.18 172.74 392.18 153.76",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.18 153.76 395.92 151.6 395.92 170.58 392.18 172.74 392.18 153.76",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.78 137.94 402.52 135.78 402.52 166.77 398.78 168.93 398.78 137.94",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.78 137.94 402.52 135.78 402.52 166.77 398.78 168.93 398.78 137.94",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.38 150.91 409.12 148.75 409.12 162.96 405.38 165.12 405.38 150.91",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.38 150.91 409.12 148.75 409.12 162.96 405.38 165.12 405.38 150.91",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.98 143.94 415.72 141.78 415.72 159.15 411.98 161.3 411.98 143.94",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.98 143.94 415.72 141.78 415.72 159.15 411.98 161.3 411.98 143.94",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.58 134.76 422.32 132.6 422.32 155.33 418.58 157.49 418.58 134.76",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.58 134.76 422.32 132.6 422.32 155.33 418.58 157.49 418.58 134.76",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.09,102.07a.5.5,0,0,1-.25-.93L424,55.31a.5.5,0,0,1,.68.18.51.51,0,0,1-.18.69L345.34,102A.47.47,0,0,1,345.09,102.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.09,106.69a.5.5,0,0,1-.25-.93L424,59.93a.51.51,0,0,1,.68.19.5.5,0,0,1-.18.68l-79.17,45.83A.57.57,0,0,1,345.09,106.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.09,111.32a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69L424,64.56a.5.5,0,0,1,.5.86l-79.17,45.83A.59.59,0,0,1,345.09,111.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.09,208.49a.5.5,0,0,1-.25-.93L424,161.73a.5.5,0,0,1,.5.87l-79.17,45.83A.57.57,0,0,1,345.09,208.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.09,213.12a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69L424,166.36a.5.5,0,0,1,.5.86l-79.17,45.83A.59.59,0,0,1,345.09,213.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.09,217.74a.5.5,0,0,1-.25-.93L424,171a.5.5,0,1,1,.5.86l-79.17,45.83A.47.47,0,0,1,345.09,217.74Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-44",
    points: "431.05 180.34 431.05 118.52 369.14 154.27 369.12 216.09 431.05 180.34",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--document--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--sheet--inject-44"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "379.64 161.44 377.57 160.25 470.28 106.72 472.35 107.91 379.64 161.44",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "472.35 107.91 472.35 250.3 379.6 303.85 379.64 161.44 472.35 107.91",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.86,108.76V250l-91.77,53,0-141.27,91.73-53m.49-.85-92.71,53.53,0,142.41,92.75-53.55V107.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.64 161.44 379.6 303.85 377.59 302.69 377.57 160.25 379.6 161.41 379.64 161.44",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M392.78,259.55l-4.15,2.39a1.16,1.16,0,0,0-.47.91v.09c0,.35.21.51.47.36l4.15-2.39a1.14,1.14,0,0,0,.47-.91v-.09C393.25,259.56,393,259.4,392.78,259.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.79,254.35l-4.15,2.39a1.14,1.14,0,0,0-.47.91v.09c0,.35.21.51.47.36l4.15-2.39a1.16,1.16,0,0,0,.47-.91v-.09C402.26,254.36,402.05,254.2,401.79,254.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.8,249.15l-4.15,2.39a1.15,1.15,0,0,0-.48.91v.09c0,.35.22.51.48.36l4.15-2.4a1.12,1.12,0,0,0,.47-.9v-.09C411.27,249.16,411.06,249,410.8,249.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.8,244l-4.15,2.39a1.14,1.14,0,0,0-.47.91v.09c0,.35.21.51.47.36l4.15-2.4a1.13,1.13,0,0,0,.48-.9v-.1C420.28,244,420.06,243.8,419.8,244Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.81,238.75l-4.15,2.39a1.14,1.14,0,0,0-.47.9v.1c0,.35.21.51.47.36l4.15-2.4a1.12,1.12,0,0,0,.47-.9v-.1C429.28,238.75,429.07,238.59,428.81,238.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.82,233.54l-4.15,2.4a1.15,1.15,0,0,0-.48.9v.1c0,.35.22.51.48.36l4.15-2.4a1.12,1.12,0,0,0,.47-.9v-.1C438.29,233.55,438.08,233.39,437.82,233.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.82,228.34l-4.14,2.4a1.1,1.1,0,0,0-.48.9v.1c0,.35.21.51.48.36l4.14-2.4a1.12,1.12,0,0,0,.48-.9v-.1C447.3,228.35,447.09,228.19,446.82,228.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.83,223.14l-4.15,2.4a1.12,1.12,0,0,0-.47.9v.1c0,.34.21.51.47.35l4.15-2.39a1.14,1.14,0,0,0,.47-.91v-.09C456.3,223.15,456.09,223,455.83,223.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.84,217.94l-4.15,2.4a1.12,1.12,0,0,0-.47.9v.1c0,.34.21.5.47.35l4.15-2.39a1.14,1.14,0,0,0,.47-.91v-.09C465.31,218,465.1,217.79,464.84,217.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388 247.3 393.11 244.35 393.11 252.74 388 255.68 388 247.3",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.01 233.45 402.11 230.51 402.11 247.54 397.01 250.48 397.01 233.45",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.01 233.45 402.11 230.51 402.11 247.54 397.01 250.48 397.01 233.45",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.01 217.48 411.12 214.53 411.12 242.34 406.01 245.28 406.01 217.48",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.01 217.48 411.12 214.53 411.12 242.34 406.01 245.28 406.01 217.48",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.02 227.33 420.12 224.39 420.12 237.14 415.02 240.09 415.02 227.33",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.02 227.33 420.12 224.39 420.12 237.14 415.02 240.09 415.02 227.33",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.02 219.3 429.12 216.36 429.12 231.94 424.02 234.89 424.02 219.3",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.02 219.3 429.12 216.36 429.12 231.94 424.02 234.89 424.02 219.3",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.03 209.29 438.13 206.34 438.13 226.74 433.03 229.69 433.03 209.29",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.03 215.06 447.13 212.11 447.13 221.55 442.03 224.49 442.03 215.06",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.03 215.06 447.13 212.11 447.13 221.55 442.03 224.49 442.03 215.06",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.03 206.85 456.14 203.91 456.14 216.35 451.03 219.29 451.03 206.85",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.03 206.85 456.14 203.91 456.14 216.35 451.03 219.29 451.03 206.85",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "460.04 199.66 465.14 196.71 465.14 211.15 460.04 214.09 460.04 199.66",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.05,185.75c-5.64,11.94-13.09,15.42-17.76,14.78a15.77,15.77,0,0,1-4.08-1.21c-2.21-.9-4-1.61-7.63.51-2.36,1.36-4.31,3.87-6.21,6.3-2.45,3.15-4.76,6.12-7.59,5.85-2-.19-3.37-1.63-4.72-3-2.08-2.15-4.22-4.38-8.5-1.92-7.13,4.12-15.3,19.75-20.82,31.14l.53.53c5.42-11.2,13.43-26.55,20.29-30.51,3.95-2.28,5.9-.26,8,1.87,1.4,1.45,2.84,2.95,5,3.15,3.13.3,5.6-2.86,8.21-6.21,1.82-2.34,3.69-4.75,5.89-6,3.45-2,5-1.35,7.22-.46a16.24,16.24,0,0,0,4.17,1.23c4.89.67,12.69-3,18.61-15.5Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.05,185.75c-5.64,11.94-13.09,15.42-17.76,14.78a15.77,15.77,0,0,1-4.08-1.21c-2.21-.9-4-1.61-7.63.51-2.36,1.36-4.31,3.87-6.21,6.3-2.45,3.15-4.76,6.12-7.59,5.85-2-.19-3.37-1.63-4.72-3-2.08-2.15-4.22-4.38-8.5-1.92-7.13,4.12-15.3,19.75-20.82,31.14l.53.53c5.42-11.2,13.43-26.55,20.29-30.51,3.95-2.28,5.9-.26,8,1.87,1.4,1.45,2.84,2.95,5,3.15,3.13.3,5.6-2.86,8.21-6.21,1.82-2.34,3.69-4.75,5.89-6,3.45-2,5-1.35,7.22-.46a16.24,16.24,0,0,0,4.17,1.23c4.89.67,12.69-3,18.61-15.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.14,274.35a.5.5,0,0,1-.25-.93l79.17-45.83a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-79.17,45.82A.43.43,0,0,1,386.14,274.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.14,279a.5.5,0,0,1-.25-.93l79.17-45.83a.5.5,0,0,1,.68.19.49.49,0,0,1-.18.68l-79.17,45.83A.51.51,0,0,1,386.14,279Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.14,283.6a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l79.17-45.82a.5.5,0,1,1,.5.86l-79.17,45.83A.43.43,0,0,1,386.14,283.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,171.1a.5.5,0,0,1-.25-.93l40.62-23.45a.5.5,0,0,1,.5.86L386.29,171A.45.45,0,0,1,386,171.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,175.79a.5.5,0,0,1-.25-.93l60.93-35.18a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-60.93,35.18A.57.57,0,0,1,386,175.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,185.17a.5.5,0,0,1-.25-.93l36.56-21.11a.5.5,0,0,1,.5.87l-36.56,21.11A.57.57,0,0,1,386,185.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,189.86a.5.5,0,0,1-.25-.93l36.56-21.11a.51.51,0,0,1,.68.19.49.49,0,0,1-.18.68L386.29,189.8A.57.57,0,0,1,386,189.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,194.55a.5.5,0,0,1-.25-.93l36.56-21.11a.51.51,0,0,1,.68.19.49.49,0,0,1-.18.68l-36.56,21.11A.57.57,0,0,1,386,194.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,199.24a.5.5,0,0,1-.25-.93l36.56-21.11a.51.51,0,0,1,.68.19.49.49,0,0,1-.18.68l-36.56,21.11A.57.57,0,0,1,386,199.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,203.93a.5.5,0,0,1-.25-.93l36.56-21.11a.51.51,0,0,1,.68.19.49.49,0,0,1-.18.68l-36.56,21.11A.57.57,0,0,1,386,203.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,208.62a.5.5,0,0,1-.25-.93l36.56-21.11a.51.51,0,0,1,.68.19.49.49,0,0,1-.18.68l-36.56,21.11A.57.57,0,0,1,386,208.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,213.31a.5.5,0,0,1-.25-.93l36.56-21.11a.51.51,0,0,1,.68.19.49.49,0,0,1-.18.68l-36.56,21.11A.57.57,0,0,1,386,213.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.4,160.73a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l36.56-21.1a.5.5,0,1,1,.5.86l-36.56,21.11A.45.45,0,0,1,428.4,160.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.4,165.42a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l36.56-21.1a.5.5,0,1,1,.5.86l-36.56,21.11A.45.45,0,0,1,428.4,165.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.4,170.11a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l36.56-21.1a.5.5,0,1,1,.5.86L428.65,170A.45.45,0,0,1,428.4,170.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.4,174.8a.5.5,0,0,1-.25-.93l36.56-21.11a.5.5,0,1,1,.5.86l-36.56,21.11A.45.45,0,0,1,428.4,174.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.4,179.49a.5.5,0,0,1-.25-.93l36.56-21.11a.51.51,0,0,1,.69.18.52.52,0,0,1-.19.69l-36.56,21.1A.45.45,0,0,1,428.4,179.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.4,184.18a.5.5,0,0,1-.25-.93l36.56-21.11a.5.5,0,1,1,.5.86l-36.56,21.11A.45.45,0,0,1,428.4,184.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.4,188.87a.5.5,0,0,1-.25-.93l36.56-21.11a.51.51,0,0,1,.69.18.52.52,0,0,1-.19.69l-36.56,21.1A.45.45,0,0,1,428.4,188.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoEvaluationLeft);
export default __webpack_public_path__ + "static/media/Auto-evaluation-left.3b3775ec93d8a908602752612b241088.svg";
export { ForwardRef as ReactComponent };